/* build:1791280000 V3.34f-UX3 (2026-10-06 : attributs panier dès résultats, notice PDF sans compte, shim Klaviyo API client) */
/**
 * ParaDermia™ — Quiz UI V2
 * Pure vanilla JS, zero dépendances. Dépend de quiz-algo.js (chargé en premier).
 *
 * Mount points :
 *   <div data-quiz-root></div>          on /pages/quiz
 *   <div data-quiz-results-root></div>  on /pages/quiz-results
 *
 * Refonte V2 :
 *   - Hero accueil dark + eyebrow + stats + halo CTA (item 1)
 *   - Transition 5 étapes timing 5.4s + message final (item 3)
 *   - STEP 4 preview / STEP 6 gate dark (items 4 + 16)
 *   - STEP 5 niveau OPTIMAL recommandée fond vert (item 5)
 *   - Page résultat hero pack-bg/pack-accent (item 6)
 *   - Cart selector + bouton +Ajouter par produit (items 8 + 9)
 *   - Upsell corps (item 10)
 *   - 5 alertes personnalisées enrichies (item 11)
 *   - Pied de page : contact pharmacienne + CTA final + mention légale (item 12)
 *   - Vouvoiement strict + protocole/routine (item 14)
 */
(function () {
  'use strict';

  // ── 2026-10-06 — Klaviyo sans script onsite ──────────────────────────────
  // Constat (audit) : paradermia.com ne charge pas klaviyo.js, donc les
  // window._learnq.push(...) des quiz n'étaient lus par personne (aucun
  // événement quiz depuis le 25/05/2026). Ce shim transforme les push
  // ['identify'|'track'] en appels à l'API client Klaviyo (clé publique
  // company_id, aucun secret). Si klaviyo.js est un jour chargé
  // (window.klaviyo défini), le shim s'efface et laisse faire le natif.
  (function () {
    var CID = 'SM95Gk';
    if (window.__pdKlaviyoShim || window.klaviyo) return;
    window.__pdKlaviyoShim = true;
    function anon() {
      try {
        var k = 'pd_anon_id', v = localStorage.getItem(k);
        if (!v) { v = 'pd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
        return v;
      } catch (_) { return 'pd-' + Date.now(); }
    }
    var ident = {};
    function send(path, data) {
      try {
        fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CID, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: data })
        }).catch(function () {});
      } catch (_) {}
    }
    function profileAttrs(extra) {
      var a = Object.assign({}, extra || {}), out = {};
      if (a.$email) { out.email = a.$email; delete a.$email; }
      if (a.$first_name) { out.first_name = a.$first_name; delete a.$first_name; }
      if (a.$last_name) { out.last_name = a.$last_name; delete a.$last_name; }
      if (ident.email && !out.email) out.email = ident.email;
      if (ident.first_name && !out.first_name) out.first_name = ident.first_name;
      if (!out.email) out.anonymous_id = anon();
      var props = {};
      Object.keys(a).forEach(function (k) { if (k.charAt(0) !== '$' && a[k] !== undefined) props[k] = a[k]; });
      if (Object.keys(props).length) out.properties = props;
      return out;
    }
    var q = { push: function (cmd) {
      try {
        if (!Array.isArray(cmd)) return;
        if (cmd[0] === 'identify') {
          var pa = profileAttrs(cmd[1]);
          if (pa.email) ident.email = pa.email;
          if (pa.first_name) ident.first_name = pa.first_name;
          send('profiles', { type: 'profile', attributes: pa });
        } else if (cmd[0] === 'track') {
          send('events', { type: 'event', attributes: {
            properties: Object.assign({ source_page: location.pathname }, cmd[2] || {}),
            metric: { data: { type: 'metric', attributes: { name: String(cmd[1]) } } },
            profile: { data: { type: 'profile', attributes: profileAttrs() } }
          } });
        }
      } catch (_) {}
    } };
    var existing = window._learnq;
    if (Array.isArray(existing)) existing.forEach(function (c) { q.push(c); });
    window._learnq = q;
  })();

  // ── Cercle ParaDermia : case de consentement (30/10/2026) ──────────────
  // Case NON cochée par défaut (CNIL). Cochée → inscription marketing à la
  // liste Klaviyo « Cercle ParaDermia » (WCbzsz, simple opt-in) via l'API
  // client publique, ce qui déclenche la série de bienvenue (code -10 %).
  function pdCercleBox() {
    var l = document.createElement('label');
    l.className = 'pd-consent';
    l.style.cssText = 'display:flex;gap:10px;align-items:flex-start;text-align:left;font-size:13px;line-height:1.45;margin:4px 0 2px;cursor:pointer;opacity:.92';
    var c = document.createElement('input');
    c.type = 'checkbox'; c.name = 'pd_cercle';
    c.style.cssText = 'margin-top:3px;width:18px;height:18px;flex:0 0 18px;accent-color:#1e3d10';
    var s = document.createElement('span');
    s.textContent = 'Je rejoins le Cercle ParaDermia : je reçois mon code −10 % (dès 45 € d’achat) et les conseils de notre pharmacienne par e-mail. Désinscription en un clic.';
    l.appendChild(c); l.appendChild(s);
    return l;
  }
  function pdCercleSubscribe(form, email, firstName, source) {
    try {
      var c = form && form.querySelector('input[name="pd_cercle"]');
      if (!c || !c.checked || !email) return false;
      var a = { email: email };
      if (firstName) a.first_name = firstName;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SM95Gk', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: a } } }, relationships: { list: { data: { type: 'list', id: 'WCbzsz' } } } } }),
      }).catch(function () {});
      try { localStorage.setItem('pd_cercle_sub', '1'); } catch (_) {}
      return true;
    } catch (e) { return false; }
  }


  // ────────────────────────────────────────────────────────────────────────────
  //  STEP 1 Hero — Contenu intro V2 (item 1 + item 13)
  // ────────────────────────────────────────────────────────────────────────────

  const HERO_CONTENT = {
    eyebrow: 'Analyse de peau · Paradermia',
    titleHtml: 'Votre peau a une <em>logique.</em>',
    subtitle: 'Nous allons la décoder, en 5 minutes.',
    cta: 'Démarrer mon analyse',
    stats: [
      { value: '5',    label: 'Minutes' },
      { value: '16',   label: 'Questions' },
      { value: '100%', label: 'Gratuit' }
    ],
    credentials: [
      'Élaborée par une Docteure en Pharmacie',
      'Validée par un dermatologue',
      'Recommandations auditées'
    ],
    infoHint: 'Pour chaque question, un bouton vous explique pourquoi nous vous la posons — nous vous recommandons de le consulter pour répondre avec précision.',
    info: [
      'Ce questionnaire a été conçu par notre Docteure en Pharmacie, spécialiste en dermo-cosmétique. Chaque question a un rôle précis dans la construction de votre protocole et vos réponses restent strictement confidentielles.',
      'En deux étapes : un diagnostic de votre profil cutané, puis une personnalisation fine selon vos objectifs et votre tolérance. À l\'arrivée, votre protocole de soins complet, actifs et compléments inclus.',
      'Pour chaque question, un bouton d\'information vous explique pourquoi nous vous la posons. Comptez 5 minutes.'
    ]
  };

  // URLs des 6 images Fitzpatrick (FEATURE 1 — STEP 7.4)
  const FITZPATRICK_IMAGES = {
    A: 'https://cdn.shopify.com/s/files/1/1032/7094/1009/files/type_I.png?v=1777060738',
    B: 'https://cdn.shopify.com/s/files/1/1032/7094/1009/files/Sans_titre_400_x_400_px.png?v=1777061525',
    C: 'https://cdn.shopify.com/s/files/1/1032/7094/1009/files/type_3.png?v=1777061335',
    D: 'https://cdn.shopify.com/s/files/1/1032/7094/1009/files/type_4.png?v=1777061564',
    E: 'https://cdn.shopify.com/s/files/1/1032/7094/1009/files/type_5.png?v=1777061481',
    F: 'https://cdn.shopify.com/s/files/1/1032/7094/1009/files/TYPE6.png?v=1777060652'
  };

  // ────────────────────────────────────────────────────────────────────────────
  //  QUESTIONS — vouvoiement strict (item 14), copy validée
  // ────────────────────────────────────────────────────────────────────────────

  const QUESTIONS = [
    // ─── STEP 2 — Diagnostic socle ────────────────────────────────────────
    {
      id: 'Q2_1', step: 'STEP2', required: true, type: 'single',
      title: 'Équilibre sébum',
      prompt: 'Vers 14h (sans avoir remis de produits), comment se comporte votre peau ?',
      info: 'L\'équilibre sébum évolue avec l\'âge, les hormones et le climat. Cette réponse détermine directement les textures et les actifs régulateurs adaptés à votre peau, pas ceux d\'une peau type.',
      options: [
        { value: 'A', label: 'Elle brille de partout.' },
        { value: 'B', label: 'Elle brille uniquement sur la zone T.' },
        { value: 'C', label: 'Elle tiraille, elle est rêche.' },
        { value: 'D', label: 'Confortable, ni brillance ni tiraillement.' }
      ]
    },
    {
      id: 'Q2_2', step: 'STEP2', required: true, type: 'single',
      title: 'Barrière cutanée',
      prompt: 'Après vous être lavé le visage à l\'eau claire uniquement, votre peau…',
      info: 'L\'état de la barrière cutanée est indépendant du type de peau. Une peau grasse peut avoir une barrière fragile. Cette réponse sécurise votre protocole, car certains actifs puissants deviennent contre-productifs si la barrière est fragilisée.',
      options: [
        { value: 'A', label: 'Tire fortement, inconfort immédiat.' },
        { value: 'B', label: 'Tire un peu puis se rééquilibre.' },
        { value: 'C', label: 'Confortable immédiatement.' },
        { value: 'D', label: 'Rougit, chauffe ou picote.' }
      ]
    },
    {
      id: 'Q2_3', step: 'STEP2', required: true, type: 'single',
      title: 'Objectif principal',
      prompt: 'Choisissez UNE seule réponse — ce qui vous dérange le plus en ce moment.',
      info: 'Chaque problématique cutanée a ses actifs de référence, validés cliniquement. Votre réponse détermine le protocole de base. Vous pourrez affiner vos objectifs secondaires juste après.',
      options: [
        { value: 'A', label: 'Mes boutons, points noirs et pores dilatés' },
        { value: 'B', label: 'Mes taches brunes, marques d\'acné ou mon teint irrégulier' },
        { value: 'C', label: 'Mes rides, ridules ou le relâchement de ma peau' },
        { value: 'D', label: 'Mon teint terne, fatigué et en manque d\'éclat' },
        { value: 'E', label: 'Mes rougeurs, ma peau qui chauffe ou réagit à tout' },
        { value: 'F', label: 'Ma peau très sèche, qui tiraille ou manque de confort' },
        { value: 'G', label: 'Mon masque de grossesse (ou ma peau pendant la grossesse)' },
        { value: 'H', label: 'Mes vergetures (corps)' }
      ]
    },
    {
      id: 'Q2_3acne', step: 'STEP2', required: true, type: 'single',
      title: 'Type d\'acné',
      prompt: 'Pour mieux cibler vos actifs, vos imperfections ressemblent plutôt à…',
      showIf: (a) => a.Q2_3 === 'A',
      info: 'Acné inflammatoire et acné rétentionnelle ne se traitent pas avec les mêmes actifs.',
      options: [
        { value: 'A', label: 'Des boutons rouges, enflés, parfois douloureux.' },
        { value: 'B', label: 'Des points noirs, pores bouchés, comédons, pas de rougeur.' },
        { value: 'C', label: 'Les deux à la fois.' }
      ]
    },
    {
      id: 'Q2_3taches', step: 'STEP2', required: true, type: 'single',
      title: 'Type de taches',
      prompt: 'Quelle famille de taches vous concerne le plus ?',
      showIf: (a) => a.Q2_3 === 'B',
      info: 'Trois grandes familles de taches existent et chacune répond à des actifs spécifiques. Les marques post-acné réagissent aux anti-inflammatoires comme la niacinamide ou l\'acide azélaïque. Le mélasma hormonal demande l\'acide tranexamique et une photoprotection stricte. Les taches solaires répondent à la vitamine C et aux exfoliants chimiques. Distinguer votre type de taches nous permet de cibler les bons mécanismes.',
      options: [
        { value: 'A', label: 'Marques sombres après boutons ou irritations.' },
        { value: 'B', label: 'Taches apparues ou aggravées par le soleil ou la grossesse.' },
        { value: 'C', label: 'Taches solaires et signes de vieillissement.' },
        { value: 'D', label: 'Je ne sais pas vraiment.' }
      ]
    },
    {
      id: 'Q2_4', step: 'STEP2', required: true, type: 'single',
      title: 'Ancienneté',
      prompt: 'Depuis combien de temps ce problème est-il installé ?',
      info: 'Un problème récent et un problème installé depuis des années ne se traitent pas de la même façon. Cette réponse calibre la structure de votre protocole et l\'intensité des actifs sélectionnés.',
      options: [
        { value: 'A', label: 'Depuis quelques jours, c\'est tout récent.' },
        { value: 'B', label: 'Depuis quelques semaines.' },
        { value: 'C', label: 'Depuis plusieurs mois, ça commence à s\'installer.' },
        { value: 'D', label: 'Depuis des années, ou alors ça revient sans arrêt !' }
      ]
    },
    {
      id: 'Q2_5', step: 'STEP2', required: true, type: 'single',
      title: 'Intensité ressentie',
      prompt: 'À quel point ce problème vous préoccupe-t-il au quotidien ?',
      info: 'Cette question nous aide à comprendre l\'urgence ressentie et la priorité que vous accordez à votre routine. Elle influence le niveau d\'exigence des actifs sélectionnés, pas uniquement le message de votre résultat.',
      options: [
        { value: 'A', label: 'C\'est léger, ça ne me gêne pas plus que ça.' },
        { value: 'B', label: 'C\'est modéré, ça commence vraiment à m\'agacer devant le miroir.' },
        { value: 'C', label: 'C\'est important, le régler est ma priorité absolue.' }
      ]
    },
    {
      // V3.34f BUG-E — Q7_4 phototype REMONTÉE en STEP2 (obligatoire tous
      // parcours). Sans ça, en Bilan rapide, mapPhototype défaut = III → une
      // peau IV-VI reçoit SPF cast blanc + perd filtres PIH (risque clinique).
      // ID Q7_4 conservé pour rétrocompat algo (mapPhototype lit a.Q7_4).
      // Q7_4bis, Q7_PIH, Q7_PRATIQUES restent en STEP7 (raffinement complet).
      id: 'Q7_4', step: 'STEP2', required: true, type: 'single', imageOptions: true,
      title: 'Phototype',
      prompt: 'Quelle description correspond le mieux à votre peau face au soleil ?',
      info: 'La réaction au soleil reflète la concentration en mélanine, ce qui influence la tolérance à certains actifs et le risque de taches résiduelles après inflammation. En cas de doute entre deux phototypes, choisissez le plus foncé. Votre protocole intégrera mieux les précautions adaptées.',
      options: [
        { value: 'A', label: 'Peau très claire, brûle toujours, bronze jamais.',          image: FITZPATRICK_IMAGES.A },
        { value: 'B', label: 'Peau claire, brûle facilement, bronze très peu.',           image: FITZPATRICK_IMAGES.B },
        { value: 'C', label: 'Peau intermédiaire, quelques coups de soleil, bronze.',     image: FITZPATRICK_IMAGES.C },
        { value: 'D', label: 'Peau mate, brûle rarement, bronze facilement.',             image: FITZPATRICK_IMAGES.D },
        { value: 'E', label: 'Peau brune, ne brûle presque jamais, bronze intensément.',  image: FITZPATRICK_IMAGES.E },
        { value: 'F', label: 'Peau très foncée, ne prend jamais de coups de soleil.',     image: FITZPATRICK_IMAGES.F }
      ]
    },
    {
      id: 'Q2_6', step: 'STEP2', required: true, type: 'single', lock: true,
      title: 'Sécurité grossesse',
      prompt: 'Par mesure de sécurité, êtes-vous actuellement enceinte ou allaitez-vous ? Réponse confidentielle.',
      info: 'Certains actifs cosmétiques sont déconseillés pendant la grossesse et l\'allaitement. Cette réponse active un filtre strict sur votre protocole. Chaque produit est vérifié compatible par notre pharmacienne, sans compromis sur l\'efficacité.',
      options: [
        { value: 'A', label: 'Oui, je suis enceinte.' },
        { value: 'B', label: 'Oui, j\'allaite.' },
        { value: 'C', label: 'Non.' }
      ]
    },

    // ─── STEP 7 — Personnalisation avancée (skippable) ────────────────────
    {
      id: 'Q7_1', step: 'STEP7', required: true, type: 'single',
      title: 'Votre âge',
      prompt: 'Pour adapter les actifs, dans quelle tranche d\'âge vous situez-vous ?',
      info: 'Le renouvellement cellulaire ralentit progressivement avec l\'âge, ce qui change les actifs dont votre peau a besoin et leur dosage optimal. Cette réponse affine la sélection pour que les actifs soient concentrés au bon niveau.',
      options: [
        { value: 'A', label: 'Moins de 18 ans' },
        { value: 'B', label: '18–24 ans' },
        { value: 'C', label: '25–34 ans' },
        { value: 'D', label: '35–44 ans' },
        { value: 'E', label: '45–54 ans' },
        { value: 'F', label: '55 ans et plus' }
      ]
    },
    {
      // V3.34f — Q7_2 remonté en STEP2 (avant : STEP7 = bilan complet seul).
      // Sans ça, en Bilan rapide → secondary_objectives=[] → multi-problématiques
      // ignorées. Non-required : l'utilisateur pressé coche H (aucun).
      // Remplace la Q2_3bis (retirée pour éviter doublon question objectifs).
      id: 'Q7_2', step: 'STEP2', required: false, type: 'multi', max: 2,
      title: 'Objectifs secondaires',
      prompt: 'Y a-t-il d\'autres choses que vous aimeriez améliorer ? (max 2)',
      info: 'Un protocole peut adresser plusieurs objectifs simultanément, à condition que les actifs soient compatibles entre eux. Nous vérifions ces compatibilités pour que les actifs se renforcent mutuellement plutôt que de s\'annuler.',
      options: [
        { value: 'A', label: 'Ma peau qui tiraille ou boit ses soins trop vite' },
        { value: 'B', label: 'Mes rougeurs et zones sensibles' },
        { value: 'C', label: 'Mes taches et mon teint irrégulier' },
        { value: 'D', label: 'Mes pores dilatés' },
        { value: 'E', label: 'Mon teint terne et mon manque d\'éclat' },
        { value: 'F', label: 'Mes rides et signes de l\'âge' },
        { value: 'G', label: 'Mon contour des yeux (cernes, poches, ridules)' },
        { value: 'H', label: 'Non, mon objectif principal me suffit' }
      ]
    },
    {
      // V3.34f — Q7_2bis remonté en STEP2 (conditionnel Q7_2=G). Sans ça,
      // en Bilan rapide, l'utilisateur qui coche 'contour yeux' dans Q7_2
      // (maintenant STEP2) n'avait jamais la sous-question eye_concern.
      id: 'Q7_2bis', step: 'STEP2', required: true, type: 'single',
      title: 'Contour des yeux',
      prompt: 'Concernant votre contour des yeux, qu\'est-ce qui vous dérange le plus ?',
      showIf: (a) => Array.isArray(a.Q7_2) && a.Q7_2.indexOf('G') !== -1,
      info: 'Le contour des yeux est la zone la plus fine et fragile du visage.',
      options: [
        { value: 'A', label: 'J\'ai l\'air fatigué(e) : poches, cernes.' },
        { value: 'B', label: 'Rides, ridules ou relâchement.' },
        { value: 'C', label: 'Ça tiraille, c\'est sec.' }
      ]
    },
    {
      id: 'Q7_3', step: 'STEP7', required: true, type: 'single',
      title: 'Tolérance cutanée',
      prompt: 'Comment réagit votre peau face à un nouveau produit ?',
      info: 'La tolérance cutanée détermine la concentration et la nature des actifs que votre peau peut recevoir. Une peau peu tolérante ne recevra pas les mêmes formules qu\'une peau robuste. Même objectif, protocole différent.',
      options: [
        { value: 'A', label: 'Très souvent : rougeurs, chaleur, picotements.' },
        { value: 'B', label: 'Parfois sensible.' },
        { value: 'C', label: 'S\'adapte bien.' },
        { value: 'D', label: 'Tolère tout.' }
      ]
    },
    {
      id: 'Q7_3_rosacee', step: 'STEP7', required: true, type: 'boolean',
      title: 'Rosacée',
      prompt: 'Avez-vous des rougeurs persistantes avec petits vaisseaux visibles sur le nez ou les joues ?',
      showIf: (a) => a.Q7_3 === 'A',
      info: 'La rosacée nécessite des précautions particulières sur les actifs exfoliants et les textures. Cette réponse oriente votre protocole vers les exfoliants doux uniquement, sans acides forts comme le glycolique ou le salicylique.',
      options: [ { value: true, label: 'Oui' }, { value: false, label: 'Non' } ]
    },
    {
      id: 'Q7_3b', step: 'STEP7', required: false, type: 'multi', lock: true,
      title: 'Sensibilités connues',
      prompt: 'Avez-vous une sensibilité connue ?',
      info: 'Certains actifs cosmétiques appartiennent à la même famille chimique que des allergènes courants. Cette information nous permet d\'écarter préventivement les actifs à risque croisé pour votre profil.',
      options: [
        { value: 'A', label: 'Aspirine / salicylates' },
        { value: 'B', label: 'Parfums / huiles essentielles' },
        { value: 'C', label: 'Aucune sensibilité connue' },
        { value: 'D', label: 'Je ne sais pas' }
      ]
    },
    {
      id: 'Q7_ALLERGIES', step: 'STEP7', required: false, type: 'multi', aucunKey: 'E',
      title: 'Allergies alimentaires',
      prompt: 'Avez-vous des allergies alimentaires connues parmi ces familles ?',
      info: 'Certains allergènes alimentaires courants comme l\'avoine, le soja, les fruits à coque ou le lait sont aussi présents dans des cosmétiques. Si vous avez ces allergies, nous filtrons les produits susceptibles de déclencher une réaction sans que vous ayez à lire chaque liste d\'ingrédients.',
      options: [
        { value: 'A', label: 'Avoine.' },
        { value: 'B', label: 'Soja.' },
        { value: 'C', label: 'Fruits à coque.' },
        { value: 'D', label: 'Lait.' },
        { value: 'E', label: 'Aucune allergie alimentaire connue.' }
      ]
    },
    // V3.34f BUG-E — Q7_4 (phototype) déplacé plus haut en STEP2 (obligatoire
    // tous parcours). L'ancien bloc STEP7 est retiré. Q7_4bis reste en STEP7.
    {
      id: 'Q7_4bis', step: 'STEP7', required: true, type: 'single',
      title: 'Exposition UV',
      prompt: 'Comment décririez-vous votre exposition au soleil au quotidien ?',
      info: 'Le type de protection solaire recommandé dépend autant de votre peau que de la quantité d\'UV reçue au quotidien. Cette réponse précise le niveau de SPF et la formule adaptés à votre mode de vie.',
      options: [
        { value: 'A', label: 'Faible à modérée, souvent en intérieur.' },
        { value: 'B', label: 'Forte, région très ensoleillée ou beaucoup en extérieur.' }
      ]
    },
    {
      id: 'Q7_PIH', step: 'STEP7', required: true, type: 'single',
      title: 'Marques pigmentaires',
      prompt: 'Avez-vous tendance à garder une trace sombre après un bouton, une irritation ou une blessure ?',
      showIf: (a) => a.Q7_4 === 'C' || a.Q7_4 === 'D' || a.Q7_4 === 'E' || a.Q7_4 === 'F',
      info: 'Les peaux foncées et métissées ont une réactivité pigmentaire qui varie d\'une personne à l\'autre. Certaines gardent une marque sombre après le moindre bouton ou irritation, d\'autres non. Cette information nous permet d\'adapter la force des actifs et la progressivité du protocole pour respecter votre tendance à pigmenter.',
      options: [
        { value: 'A', label: 'Oui, systématiquement.' },
        { value: 'B', label: 'Parfois, selon la cause.' },
        { value: 'C', label: 'Non, ma peau récupère sans marque.' },
        { value: 'D', label: 'Je ne saurais pas dire.' }
      ]
    },
    {
      id: 'Q7_PRATIQUES', step: 'STEP7', required: false, type: 'single',
      title: 'Produits éclaircissants',
      prompt: 'Utilisez-vous actuellement des produits éclaircissants spécifiques ?',
      showIf: (a) => a.Q7_4 === 'D' || a.Q7_4 === 'E' || a.Q7_4 === 'F',
      info: 'Certains produits éclaircissants en vente libre ou disponibles à l\'étranger contiennent des actifs puissants comme l\'hydroquinone ou des corticoïdes qui peuvent interagir négativement avec les actifs que nous recommandons. Cette information nous permet de vous proposer une routine cohérente et sécurisée, sans cumul à risque.',
      options: [
        { value: 'A', label: 'Oui, prescrits par un dermatologue.' },
        { value: 'B', label: 'Oui, achetés sans prescription.' },
        { value: 'C', label: 'Non.' },
        { value: 'D', label: 'Je préfère ne pas préciser.' }
      ]
    },
    {
      id: 'Q7_5', step: 'STEP7', required: true, type: 'single', lock: true,
      title: 'Post-acte médical',
      prompt: 'Avez-vous récemment fait un soin dermatologique ou une procédure esthétique ?',
      info: 'Après une procédure esthétique comme un laser, un peeling ou une injection, la peau entre dans une phase de reconstruction active. Certains actifs sont contre-indiqués pendant cette période. Cette réponse adapte votre protocole à l\'étape de récupération de votre peau.',
      options: [
        { value: 'A', label: 'Oui, je suis en pleine récupération.' },
        { value: 'B', label: 'Oui, il y a moins de 2 semaines.' },
        { value: 'C', label: 'Non.' }
      ]
    },
    {
      id: 'Q7_MEDICAMENTS', step: 'STEP7', required: true, type: 'multi', lock: true, aucunKey: 'G',
      title: 'Traitements en cours',
      prompt: 'Suivez-vous actuellement un traitement médical impactant potentiellement votre peau ?',
      info: 'Certains traitements médicaux modifient la tolérance cutanée ou interagissent avec des actifs cosmétiques courants. Anticoagulants, traitement diabète, hypothyroïdie, isotrétinoïne : autant de signaux qui adaptent la sélection en toute sécurité. Vos réponses restent strictement confidentielles et ne remplacent pas l\'avis de votre médecin.',
      options: [
        { value: 'A', label: 'Isotrétinoïne orale ou récemment arrêtée.' },
        { value: 'B', label: 'Anticoagulants.' },
        { value: 'C', label: 'Traitement diabète.' },
        { value: 'D', label: 'Traitement thyroïdien.' },
        { value: 'E', label: 'Antibiothérapie longue durée en cours.' },
        { value: 'F', label: 'Autre traitement chronique.' },
        { value: 'G', label: 'Aucun de ces traitements.' }
      ]
    },
    {
      id: 'Q7_6', step: 'STEP7', required: false, type: 'multi',
      title: 'Actifs déjà utilisés',
      prompt: 'Concernant votre routine actuelle, utilisez-vous déjà des actifs puissants ?',
      info: 'Certains actifs ne doivent pas être doublés. Les utiliser dans deux produits différents peut irriter ou saturer la peau. Cette réponse nous permet d\'affiner votre sélection en évitant les doublons inutiles.',
      options: [
        { value: 'A', label: 'Oui, des acides exfoliants : AHA, BHA, salicylique, glycolique…' },
        { value: 'B', label: 'Oui, de la Vitamine C.' },
        { value: 'C_lt3m', label: 'Oui, du Rétinol ou des Rétinoïdes, depuis moins de 3 mois.' },
        { value: 'C_gte3m', label: 'Oui, du Rétinol ou des Rétinoïdes, depuis plus de 3 mois.' },
        { value: 'D', label: 'Non, je commence / je fais une pause.' },
        { value: 'E', label: 'Je ne sais pas trop.' }
      ]
    },
    {
      id: 'Q7_7', step: 'STEP7', required: false, type: 'single',
      title: 'Préférences',
      prompt: 'Dernière précision sur vos préférences de soin :',
      info: 'La meilleure routine est celle que vous allez vraiment suivre dans le temps.',
      options: [
        { value: 'A', label: 'Je privilégie la neutralité, sans odeur particulière.' },
        { value: 'B', label: 'Je privilégie l\'efficacité brute, les actifs les plus puissants disponibles.' },
        { value: 'C', label: 'Je n\'ai pas de préférence particulière.' }
      ]
    },
    {
      id: 'Q7_8', step: 'STEP7', required: true, type: 'single',
      title: 'Genre',
      prompt: 'Vous êtes…',
      info: 'La peau masculine est naturellement plus épaisse et plus séborrhéique que la peau féminine. Cette réponse influence directement le choix des textures et des actifs que nous allons vous recommander.',
      options: [
        { value: 'A', label: 'Femme' },
        { value: 'B', label: 'Homme' },
        { value: 'C', label: 'Je préfère ne pas préciser' }
      ]
    },
    {
      id: 'Q7_9', step: 'STEP7', required: true, type: 'single',
      title: 'Barbe et rasage',
      prompt: 'Comment ça se passe de votre côté, concernant la barbe et le rasage ?',
      // V3.2 CORRECTION 8 — masculin OU genre non défini
      showIf: (a) => a.Q7_8 === 'B' || a.Q7_8 === 'C',
      info: 'Le rasage est un facteur d\'agression cutanée récurrent. Il fragilise la barrière, génère des micro-irritations et peut provoquer des poils incarnés, particulièrement fréquents sur les peaux mates et foncées. Cette réponse nous permet d\'intégrer ces contraintes spécifiques dans la sélection de vos soins.',
      options: [
        { value: 'A', label: 'Je me rase régulièrement.' },
        { value: 'B', label: 'Je porte une barbe.' },
        { value: 'C', label: 'Tondeuse ou longueur courte sans rasage serré.' },
        { value: 'D', label: 'Aucun de ces cas.' }
      ]
    },
    {
      id: 'Q7_HORMONAL', step: 'STEP7', required: true, type: 'single', lock: true,
      title: 'Contexte hormonal',
      prompt: 'Quel est votre contexte hormonal actuel ?',
      showIf: (a) => a.Q7_8 === 'A',
      info: 'Le contexte hormonal influence directement plusieurs problématiques cutanées : acné de la femme adulte, mélasma, sensibilité fluctuante, perte d\'élasticité en péri-ménopause. Cette information oriente la sélection des actifs les plus adaptés à votre situation. Vos réponses restent strictement confidentielles.',
      options: [
        { value: 'A', label: 'Pilule contraceptive ou anneau hormonal.' },
        { value: 'B', label: 'Dispositif intra-utérin hormonal.' },
        { value: 'C', label: 'Aucune de ces situations / pas de contraception hormonale.' },
        { value: 'D', label: 'Traitement hormonal de la ménopause.' },
        { value: 'E', label: 'Péri-ménopause ou ménopause sans traitement.' },
        { value: 'F', label: 'Projet de grossesse en cours.' },
        { value: 'G', label: 'Je préfère ne pas préciser.' }
      ]
    },
    {
      id: 'Q7_TABAC', step: 'STEP7', required: true, type: 'single',
      title: 'Tabagisme',
      prompt: 'Fumez-vous régulièrement ?',
      info: 'Le tabagisme actif accélère le vieillissement cutané, dégrade la barrière et ralentit la cicatrisation par un mécanisme bien documenté de stress oxydatif. Cette information nous permet de renforcer les actifs antioxydants et la photoprotection dans votre routine.',
      options: [
        { value: 'A', label: 'Oui, quotidiennement.' },
        { value: 'B', label: 'Occasionnellement.' },
        { value: 'C', label: 'Jamais ou arrêté depuis plus d\'un an.' }
      ]
    },
    {
      // V3.34f — Q7_10 remonté en STEP2 obligatoire tous parcours. Sans ça,
      // en Bilan rapide port_maquillage=false → démaquillant jamais proposé
      // même pour utilisatrice qui se maquille tous les jours. Impact : le
      // slot demaquillant est calibré en STEP2 comme les autres étapes core.
      id: 'Q7_10', step: 'STEP2', required: true, type: 'single',
      title: 'Maquillage',
      prompt: 'Portez-vous du maquillage ?',
      info: 'Le démaquillage est une étape aussi importante que le soin lui-même. Si vous vous maquillez régulièrement, une étape démaquillant spécifique sera intégrée à votre protocole.',
      options: [
        { value: 'A', label: 'Oui, tous les jours.' },
        { value: 'B', label: 'Oui, de temps en temps.' },
        { value: 'C', label: 'Non, jamais / Je ne suis pas concerné(e).' }
      ]
    },
    {
      id: 'Q7_REGULARITE', step: 'STEP7', required: true, type: 'single',
      title: 'Habitudes de routine',
      prompt: 'À quelle fréquence appliquez-vous une routine de soin actuellement ?',
      info: 'Le meilleur protocole est celui que vous appliquerez réellement. Connaître vos habitudes nous permet d\'ajuster le réalisme du protocole : programme matin et soir complet si c\'est dans votre routine actuelle, ou version simplifiée mieux alignée avec votre rythme.',
      options: [
        { value: 'A', label: 'Matin et soir, tous les jours.' },
        { value: 'B', label: 'Une fois par jour, presque tous les jours.' },
        { value: 'C', label: 'Quelques fois par semaine.' },
        { value: 'D', label: 'Occasionnellement, sans vraie routine.' }
      ]
    },
    {
      id: 'Q7_COMPLEMENTS', step: 'STEP7', required: false, type: 'multi', aucunKey: 'J', chips: true,
      title: 'Compléments alimentaires actuels',
      prompt: 'Prenez-vous déjà des compléments alimentaires ?',
      info: 'Connaître les compléments que vous prenez déjà nous évite de vous proposer des doublons inutiles. L\'objectif est de compléter intelligemment ce qui manque dans votre routine, pas d\'accumuler les actifs ni les dépenses.',
      options: [
        { value: 'A', label: 'Magnésium.' },
        { value: 'B', label: 'Oméga-3.' },
        { value: 'C', label: 'Vitamine D.' },
        { value: 'D', label: 'Zinc.' },
        { value: 'E', label: 'Vitamines B.' },
        { value: 'F', label: 'Probiotiques.' },
        { value: 'G', label: 'Vitamine C.' },
        { value: 'H', label: 'Collagène.' },
        { value: 'I', label: 'Adaptogènes type ashwagandha rhodiola.' },
        { value: 'J', label: 'Aucun pour l\'instant.' }
      ]
    },

    // ─── STEP MDV — Mode de vie ────────────────────────────────────────────
    {
      id: 'QMDV', step: 'MDV', required: false, type: 'multi', max: 3,
      title: 'Mode de vie',
      prompt: 'Afin de vous recommander les meilleurs supports pour cette routine, nous avons quelques dernières questions sur votre quotidien. (3 choix maximum)',
      info: 'L\'état de votre peau reflète aussi votre équilibre de vie. Ces réponses permettent de compléter votre protocole avec les bons soutiens nutritionnels, les compléments les plus utiles selon votre quotidien réel.',
      options: [
        { value: 'A', label: 'Je manque de sommeil régulièrement.' },
        { value: 'B', label: 'Je suis souvent stressé(e).' },
        { value: 'C', label: 'Mon alimentation est déséquilibrée.' },
        { value: 'D', label: 'Je fais beaucoup de sport / transpire beaucoup.' },
        { value: 'E', label: 'Je suis souvent exposé(e) au soleil.' },
        { value: 'F', label: 'Tout va bien de ce côté-là.' }
      ]
    }
  ];

  const STORAGE_KEY = 'pd_quiz_session';
  const PACK_KEY = 'pd_pack_detected';
  const OUTPUT_KEY = 'pd_quiz_output';

  // ────────────────────────────────────────────────────────────────────────────
  //  STATE
  // ────────────────────────────────────────────────────────────────────────────

  function defaultState() {
    // V7.12 — Customer prefill : si window.PARADERMIA_CUSTOMER est exposé par
    // le Liquid (utilisatrice connectée), on prefill email + firstName et on
    // skippe la STEP3 dans buildFlow.
    const cust = (typeof window !== 'undefined' && window.PARADERMIA_CUSTOMER) || {};
    return {
      answers: {}, cursor: 0,
      email: cust.email || null,
      firstName: cust.firstName || null,
      skipped7: false, step0Seen: false,
      // V3.34b-1 : variable parcours additive ('standard' | 'personnalise' | null).
      // Posée à la bifurcation (cf renderStep6Gate). skipped7 conservé pour
      // compat backward avec buildFlow et les autres consommateurs existants.
      // Sera consommée par V3.34b-4 (page bifurcation), V3.34b-6 (MDV-LIGHT)
      // et plus tard V3.34c/d.
      parcours: null,
      // V3.34c-1 : variables tier (foundation pour V3.34c-2 calcul tier_final).
      // tier_user_choice : niveau choisi manuellement par la cliente. Sync
      //   avec answers.tier_selected (conservé pour compat algo qui consomme
      //   directement tier_selected, cf quiz-algo.js l.235)
      // tier_final : niveau final qui pilotera la sélection produits.
      //   Calculé en V3.34c-2 (Philosophie C). Reste null pour V3.34c-1.
      tier_user_choice: null,
      tier_final: null,
      // V3.34d-1 : flag MDV-LIGHT répondu (true si au moins 1 option cochée
      // au CTA, false si skip ou 0 cochée). Permet d'identifier en STEP 8 si
      // la cliente a renseigné son mode de vie ou pas (pour scoring compléments
      // dégradé en mode standard sans MDV-LIGHT renseigné).
      mdv_light_answered: false,
      startedAt: Date.now()
      // V3.17 : heroSeen retiré (renderHero retiré du flow V3.16)
    };
  }
  function loadState() {
    try { const raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : null; }
    catch (_) { return null; }
  }
  function saveState(s) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (_) {} }
  function clearState() { try { localStorage.removeItem(STORAGE_KEY); } catch (_) {} }

  // ────────────────────────────────────────────────────────────────────────────
  //  FLOW
  // ────────────────────────────────────────────────────────────────────────────

  function buildFlow(answers, skipped7) {
    const out = [];
    for (const q of QUESTIONS) {
      if (skipped7 && q.step === 'STEP7') continue;
      // V3.34b-6 : skip QMDV (STEP MDV complet) en branche standard.
      // En standard, on remplace par la coquille _MDV_LIGHT (appendée plus bas).
      // En personnalisation (skipped7=false), QMDV reste tel quel après les Q7.x.
      if (skipped7 && q.id === 'QMDV') continue;
      if (q.showIf && !q.showIf(answers)) continue;
      out.push(q);
    }
    const idxAfter26 = out.findIndex(q => q.id === 'Q2_6');
    if (idxAfter26 !== -1) {
      // V7.12 — Skip STEP3 email capture si user connectée (PARADERMIA_CUSTOMER)
      const skipEmail = !!(typeof window !== 'undefined'
        && window.PARADERMIA_CUSTOMER
        && window.PARADERMIA_CUSTOMER.email);
      const insertions = [];
      if (!skipEmail) {
        insertions.push({ id: '_STEP3_EMAIL', type: '_email', step: 'STEP3', required: false });
      }
      insertions.push(
        // V3.34b-3 — Transition 1 narrative repositionnée entre email et révélation pack
        { id: '_TRANSITION_1',         type: '_transition1', step: 'STEP3', required: false }
      );
      insertions.push(
        // V3.34b-5 — Fusion STEP 4 (révélation pack) + STEP 5 (choix niveau) en 1 seule page.
        // Anciens items _STEP4_PREVIEW (_preview) et _STEP5_LEVEL (_step5) remplacés par
        // _STEP_PACK_AND_TIER (_packtier). Anciennes fonctions renderStep4Preview et
        // renderStep5Level conservées en dead code pour traçabilité/rollback.
        { id: '_STEP_PACK_AND_TIER',   type: '_packtier',    step: 'STEP4', required: false }
      );
      if (!skipped7) insertions.push(
        { id: '_STEP6_GATE', type: '_gate', step: 'STEP6', required: false }
      );
      out.splice(idxAfter26 + 1, 0, ...insertions);
    }
    if (answers.Q2_3 === 'A' && answers.Q2_4 === 'D' && answers.Q2_5 === 'C') {
      const i = out.findIndex(q => q.id === 'Q2_5');
      if (i !== -1) out.splice(i + 1, 0, { id: '_ALERT_ACNE_SEVERE', type: '_alert', step: 'STEP2', required: false });
    }
    if (answers.Q7_3 === 'A' && (answers.Q7_3_rosacee === true || answers.Q7_3_rosacee === 'oui')) {
      const i = out.findIndex(q => q.id === 'Q7_3_rosacee');
      if (i !== -1) out.splice(i + 1, 0, { id: '_ALERT_ROSACEE', type: '_alert', step: 'STEP7', required: false });
    }
    // V3.34b-6 : append coquille MDV-LIGHT en branche standard (skipped7=true).
    // Remplace QMDV (skip ci-dessus dans la boucle). Le contenu détaillé sera
    // implémenté en V3.34d ; pour V3.34b-6, juste la coquille routée minimale.
    if (skipped7) {
      out.push({ id: '_MDV_LIGHT', type: '_mdvlight', step: 'MDV', required: false });
    }
    return out;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  RENDER UTILS
  // ────────────────────────────────────────────────────────────────────────────

  const SVG = {
    lock: '<svg class="pd-svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 1 1 8 0v4"/></svg>',
    info: '<svg class="pd-svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><circle cx="12" cy="8" r="0.5" fill="currentColor"/></svg>',
    close: '<svg class="pd-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>',
    sun:    '<svg class="pd-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="4.2" y1="4.2" x2="6.3" y2="6.3"/><line x1="17.7" y1="17.7" x2="19.8" y2="19.8"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/><line x1="4.2" y1="19.8" x2="6.3" y2="17.7"/><line x1="17.7" y1="6.3" x2="19.8" y2="4.2"/></svg>',
    moon:   '<svg class="pd-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>',
    pregnancy: '<svg class="pd-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="5" r="2"/><path d="M11 8c-2 0-3 2-3 4v2h1l1 8h4l1-8h1v-2c0-2-1-4-3-4z"/></svg>',
    sun_strong: '<svg class="pd-svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="2" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22"/><line x1="4" y1="12" x2="2" y2="12"/><line x1="22" y1="12" x2="20" y2="12"/><line x1="5.6" y1="5.6" x2="4.2" y2="4.2"/><line x1="19.8" y1="19.8" x2="18.4" y2="18.4"/><line x1="5.6" y1="18.4" x2="4.2" y2="19.8"/><line x1="19.8" y1="4.2" x2="18.4" y2="5.6"/></svg>',
    warning: '<svg class="pd-svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3 2 20h20L12 3z"/><line x1="12" y1="10" x2="12" y2="14"/><circle cx="12" cy="17" r="0.6" fill="currentColor"/></svg>',
    check: '<svg class="pd-svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12 10 17 19 7"/></svg>',
    bottle: '<svg class="pd-svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="3" width="8" height="3"/><path d="M9 6v3l-2 2v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-9l-2-2V6"/><line x1="9" y1="14" x2="15" y2="14"/></svg>',
    chevron: '<svg class="pd-svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>',
    grid:   '<svg class="pd-svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',
    documentCheck: '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="14 3 14 9 20 9"/><polyline points="9 14 11 16 15 12"/></svg>',
    star:   '<svg class="pd-svg" viewBox="0 0 24 24" width="10" height="10" fill="currentColor"><polygon points="12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9"/></svg>',
    arrow_left:  '<svg class="pd-svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"/></svg>',
    arrow_right: '<svg class="pd-svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>',
    email:    '<svg class="pd-svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="3 7 12 13 21 7"/></svg>',
    bookmark: '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>',
    infinity: '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 12c0-2 1.5-4 3.5-4 .5 0 1 .2 1.5.5M5 12c0-2-1.5-4-3.5-4-.5 0-1 .2-1.5.5M2 12c0 2 1.5 4 3.5 4 2.5 0 3-1 6.5-4s4-4 6.5-4 3.5 2 3.5 4-1.5 4-3.5 4c-2.5 0-3-1-6.5-4S8 8 5.5 8"/></svg>',
    truck:    '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1"/><path d="M14 9h4l3 4v4h-7"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    refund:   '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 9 6 6 9 9"/><path d="M6 6v9a4 4 0 0 0 4 4h9"/><polyline points="21 15 18 18 15 15"/></svg>',
    message:  '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8z"/></svg>',
    pharmacy: '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>',
    clock:    '<svg class="pd-svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>',
    search:    '<svg class="pd-svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>',
    heart:     '<svg class="pd-svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    lightning: '<svg class="pd-svg" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>'
  };
  const ICONS = { back: '←' };

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function h(tag, attrs, children) {
    const el = document.createElement(tag);
    if (attrs) for (const k in attrs) {
      const v = attrs[k];
      if (v === undefined || v === null) continue;
      if (k === 'class') el.className = v;
      else if (k === 'html') el.innerHTML = v;
      else if (k.startsWith('on')) el.addEventListener(k.slice(2), v);
      else if (k === 'dataset') for (const dk in v) el.dataset[dk] = v[dk];
      else el.setAttribute(k, v);
    }
    if (children) (Array.isArray(children) ? children : [children]).forEach(c => {
      if (c == null) return;
      el.appendChild(c instanceof Node ? c : document.createTextNode(String(c)));
    });
    return el;
  }

  // V3.28 — Fonction neutralisée. La bordure des .pd-option est gérée
  // exclusivement par la règle CSS quiz-paradermia.css:2498-2499 (border
  // 1.5px solid rgba(30,61,16,0.12), surchargée par .is-selected pour
  // border-color #1e3d10). L'ancienne implémentation V3.2 injectait des
  // styles inline !important sur border-left uniquement, ce qui :
  //   - écrasait toute règle CSS future sur border-left
  //   - créait une bordure asymétrique (les 3 autres côtés gérés CSS,
  //     le côté gauche figé en inline)
  //   - rendait impossible toute évolution propre du design des options.
  // Les appels (lignes ~670 et ~944) sont laissés en place : avec ce
  // return immédiat, ils deviennent des no-op sans effet de bord.
  function fixOptionBorders() {
    return;
    /* ANCIEN CODE V3.2 — conservé pour référence (do not re-enable)
    document.querySelectorAll('.pd-option').forEach(el => {
      el.style.setProperty('border-left', '1.5px solid rgba(30,61,16,0.12)', 'important');
      el.style.removeProperty('border-left-color');
    });
    document.querySelectorAll('.pd-option.is-selected').forEach(el => {
      el.style.setProperty('border-left', '1.5px solid #1e3d10', 'important');
    });
    */
  }

  // V4.2 — Fond vert step6 piloté par classe sur le conteneur racine du quiz
  // UNIQUEMENT (jamais body ni éléments Dawn). Ajouté par renderStep6Gate,
  // retiré par tous les autres renderers.
  function setQuizBgDark(on) {
    const r = document.querySelector('[data-quiz-root]');
    if (!r) return;
    if (on) r.classList.add('pd-bg-dark');
    else r.classList.remove('pd-bg-dark');
  }

  // V3.4 — Tooltip ⓘ : init unique d'un listener global touchstart pour fermer
  // tous les tooltips quand on touche ailleurs. La gestion hover desktop est
  // 100% CSS. Le toggle is-open au click est attaché par renderQuestion.
  let _pdTooltipTouchInit = false;
  function ensureTooltipTouchListener() {
    if (_pdTooltipTouchInit) return;
    _pdTooltipTouchInit = true;
    document.addEventListener('touchstart', function() {
      document.querySelectorAll('[data-info-wrap]').forEach(function(w) {
        w.classList.remove('is-open');
      });
    }, { passive: true });
  }

  // V3.20 / V3.21 — Masque/restaure la nav Dawn ENTIÈRE (header + announcement
  // + footer) pendant le parcours quiz pour immersion totale. Sélecteurs
  // élargis pour couvrir Dawn moderne + legacy + semantic + IDs Shopify
  // (avec catch-alls défensifs [id^="shopify-section-"][id*="..."]).
  // Manipule uniquement style.setProperty/removeProperty sur Dawn (jamais
  // classList — règle absolue).
  const PD_NAV_SELECTORS = [
    // Header Dawn
    '.site-header',
    'header[role="banner"]',
    '#shopify-section-header',
    '.header-wrapper',
    '.shopify-section-header-sticky',
    '[id^="shopify-section-"][id*="header"]',
    // Announcement bar Dawn
    '#shopify-section-announcement-bar',
    '.announcement-bar',
    '.utility-bar',
    '[id^="shopify-section-"][id*="announcement"]',
    // Footer Dawn (V3.21 + V3.30 : ajout 'footer' tag générique et
    // '.section-footer' pour couvrir le cas où Dawn n'expose ni role
    // ni id attendu. Sans ces 2 sélecteurs, hideNav masquait certaines
    // pages mais showNav ne réaffichait pas en sortie -> footer manquant
    // sur /pages/quiz-results. Le quiz interne utilise <div class="pd-footer">
    // (pas le tag <footer>), donc ajouter 'footer' (tag) ne touche que Dawn.
    '.site-footer',
    '.section-footer',
    'footer',
    'footer[role="contentinfo"]',
    '#shopify-section-footer',
    '[id^="shopify-section-"][id*="footer"]'
  ];
  function hideNav() {
    PD_NAV_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }
  function showNav() {
    PD_NAV_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.removeProperty('display');
        // V3.30e — Defensive : si l'élément reste caché après removeProperty
        // (cas observé sur le footer Dawn de paradermia.myshopify.com où
        // l'inline display:none !important survit à removeProperty pour une
        // raison non diagnostiquée — possible cache Shopify Section Rendering
        // entre navigations /pages/quiz -> /pages/quiz-results), on force
        // display:block !important. Battre une autre déclaration inline
        // !important. block est safe pour header/footer/announcement Dawn
        // (testé manuellement : f.style.setProperty('display','block','important')
        // restaure le footer correctement).
        if (getComputedStyle(el).display === 'none') {
          el.style.setProperty('display', 'block', 'important');
        }
      });
    });
    // V3.25 — Retire la classe body.pd-quiz-active qui forçait le bg
    // #1e3d10 sur tout le body pendant le quiz. Sur la page résultats le
    // body retrouve son fond Dawn normal.
    document.body.classList.remove('pd-quiz-active');
  }

  function renderProgress(root, current, total, sectionLabel) {
    // V3.34d-PROGRESS-REPOSITION — La mini-barre dégradée vert/or .pd-progress
    // a été retirée (faisait doublon avec la nouvelle .pd-progression au-dessus
    // de la carte). On conserve uniquement le label textuel "SECTION · X/Y".
    const labelText = total > 0 ? `${sectionLabel || ''} · ${current}/${total}` : (sectionLabel || '');
    const label = h('div', { class: 'pd-progress-label' }, labelText.trim());
    root.appendChild(label);
  }

  const SECTION_POSITIONS = {
    Q2_1: { section: 'STEP2', step: 1, total: 9 },
    Q2_2: { section: 'STEP2', step: 2, total: 9 },
    Q2_3: { section: 'STEP2', step: 3, total: 9 },
    Q2_3acne: { section: 'STEP2', step: 3, total: 9 },
    Q2_3taches: { section: 'STEP2', step: 3, total: 9 },
    Q7_2: { section: 'STEP2', step: 4, total: 9 },   // V3.34f — remonté en STEP2
    Q7_2bis: { section: 'STEP2', step: 4, total: 9 }, // conditionnel Q7_2=G
    Q2_4: { section: 'STEP2', step: 5, total: 9 },
    Q2_5: { section: 'STEP2', step: 6, total: 9 },
    Q7_4: { section: 'STEP2', step: 7, total: 9 },   // V3.34f BUG-E
    Q7_10: { section: 'STEP2', step: 8, total: 9 },  // V3.34f — port maquillage
    Q2_6: { section: 'STEP2', step: 9, total: 9 },
    Q7_1: { section: 'STEP7', step: 1, total: 13 },
    Q7_2: { section: 'STEP7', step: 2, total: 13 },
    Q7_2bis: { section: 'STEP7', step: 2, total: 13 },
    Q7_3: { section: 'STEP7', step: 3, total: 13 },
    Q7_3_rosacee: { section: 'STEP7', step: 3, total: 13 },
    Q7_3b: { section: 'STEP7', step: 4, total: 13 },
    Q7_ALLERGIES: { section: 'STEP7', step: 4, total: 13 },
    // Q7_4 déplacé en STEP2 (voir ligne 767) — entrée STEP7 retirée V3.34f BUG-E
    Q7_4bis: { section: 'STEP7', step: 5, total: 13 },
    Q7_PIH: { section: 'STEP7', step: 5, total: 13 },
    Q7_PRATIQUES: { section: 'STEP7', step: 5, total: 13 },
    Q7_5: { section: 'STEP7', step: 6, total: 13 },
    Q7_MEDICAMENTS: { section: 'STEP7', step: 6, total: 13 },
    Q7_6: { section: 'STEP7', step: 7, total: 13 },
    Q7_7: { section: 'STEP7', step: 8, total: 13 },
    Q7_8: { section: 'STEP7', step: 9, total: 13 },
    Q7_9: { section: 'STEP7', step: 9, total: 13 },
    Q7_HORMONAL: { section: 'STEP7', step: 9, total: 13 },
    Q7_TABAC: { section: 'STEP7', step: 10, total: 13 },
    Q7_10: { section: 'STEP7', step: 11, total: 13 },
    Q7_REGULARITE: { section: 'STEP7', step: 12, total: 13 },
    Q7_COMPLEMENTS: { section: 'STEP7', step: 13, total: 13 },
    QMDV:  { section: 'MDV',   step: 1, total: 1 }
  };
  const SECTION_LABELS = {
    STEP2: 'DIAGNOSTIC',
    STEP3: 'ÉTAPE INTERMÉDIAIRE',
    STEP4: 'VOTRE ROUTINE',
    STEP5: 'VOTRE NIVEAU',
    STEP6: 'VOTRE PROTOCOLE',
    STEP7: 'PERSONNALISATION',
    MDV:   'MODE DE VIE'
  };

  // Correction UI (demande Bilikiss) — libellé de progression en TEXTE simple
  // sous la barre (plus de badge), au format « Partie X · Nom · position/total ».
  // Le total provient de SECTION_POSITIONS (totaux réels des sections du quiz :
  // Partie 1 = 6 questions, Partie 2 = 13). MDV rattaché à la Partie 2.
  const PART_INFO = {
    STEP2: { part: 1, name: 'Analyse de base' },
    STEP7: { part: 2, name: 'Personnalisation' },
    MDV:   { part: 2, name: 'Mode de vie' }
  };

  // ────────────────────────────────────────────────────────────────────────────
  //  RENDER QUESTION (générique)
  // ────────────────────────────────────────────────────────────────────────────

  function renderQuestion(q, state, flow, app) {
    setQuizBgDark(false);
    const root = h('div', { class: 'pd-question pd-fade' });

    // V3.34d-PROGRESS-REPOSITION — Calcul du pct (DOM créé en fin de fonction
    // dans le wrapper externe, pour que la barre soit AU-DESSUS de la carte).
    const flowIdx = (flow && Array.isArray(flow)) ? flow.indexOf(q) : -1;
    const flowLen = (flow && flow.length) || 0;
    const globalPct = (flowLen > 0 && flowIdx >= 0)
      ? Math.min(100, Math.round(((flowIdx + 1) / flowLen) * 100))
      : 0;

    // Correction UI (demande Bilikiss) — label de progression en texte simple,
    // format « Partie X · Nom · position/total » (cf PART_INFO + SECTION_POSITIONS).
    const pos = SECTION_POSITIONS[q.id];
    if (pos) {
      const pi = PART_INFO[pos.section];
      const prefix = pi ? ('Partie ' + pi.part + ' · ' + pi.name) : (SECTION_LABELS[pos.section] || '');
      renderProgress(root, pos.step, pos.total, prefix);
    } else {
      renderProgress(root, 0, 0, SECTION_LABELS[q.step] || '');
    }

    // Correction UI (demande Bilikiss) — le badge « pill » de section a été
    // SUPPRIMÉ ; l'info section/partie/position est dans le label sous la barre.
    // Le header ne sert plus qu'au badge « Réponse confidentielle » des
    // questions à cadenas, sur sa propre ligne.
    if (q.lock) {
      const header = h('div', { class: 'pd-question-header' });
      header.appendChild(h('span', { class: 'pd-lock', html: SVG.lock + ' <span>Réponse confidentielle</span>' }));
      root.appendChild(header);
    }

    // V3.4 — Wrapper info ⓘ avec tooltip (toujours présent, fallback générique).
    const infoWrap = h('div', { class: 'pd-info-wrap', 'data-info-wrap': '' });
    const infoBtn = h('button', {
      class: 'pd-info-btn', type: 'button',
      'aria-label': 'Pourquoi cette question ?'
    }, 'i');
    const infoTooltip = h('div', { class: 'pd-info-tooltip' },
      q.hint || q.info || 'Cette information nous permet d\'affiner votre protocole personnalisé.');
    infoWrap.appendChild(infoBtn);
    infoWrap.appendChild(infoTooltip);

    // Correction UI (demande Bilikiss) — bouton info sur la MÊME LIGNE que le
    // titre de la question (gain de place) : titre à gauche, bouton « i » à droite.
    const titleRow = h('div', { class: 'pd-question-titlerow' });
    titleRow.appendChild(h('h2', { class: 'pd-question-title' }, q.title));
    titleRow.appendChild(infoWrap);
    root.appendChild(titleRow);
    root.appendChild(h('p', { class: 'pd-question-prompt' }, q.prompt));

    const optsWrap = h('div', {
      class: 'pd-options pd-options-' + q.type + (q.imageOptions ? ' pd-options-image' : '') + (q.chips ? ' pd-options-chips' : '')
    });
    const current = state.answers[q.id];
    const isMulti = q.type === 'multi';

    for (const opt of q.options) {
      const selected = isMulti
        ? Array.isArray(current) && current.indexOf(opt.value) !== -1
        : (current === opt.value || (typeof current === 'boolean' && current === opt.value));

      const btn = h('button', {
        class: 'pd-option'
          + (selected ? ' is-selected' : '')
          + (opt.image ? ' pd-option-with-image' : ''),
        type: 'button',
        dataset: { value: String(opt.value) }
      });
      if (opt.image) {
        const imgWrap = h('div', { class: 'pd-option-image-container' }, [
          h('img', { src: opt.image, alt: opt.label, loading: 'lazy' })
        ]);
        btn.appendChild(imgWrap);
      }
      const body = h('div', { class: 'pd-option-body' }, [
        h('span', { class: 'pd-option-bullet' }),
        h('span', { class: 'pd-option-label' }, opt.label)
      ]);
      btn.appendChild(body);
      btn.addEventListener('click', () => handleSelection(q, opt.value, state, app));
      optsWrap.appendChild(btn);
    }
    root.appendChild(optsWrap);

    // Correction (demande Bilikiss) — médicaments « Autre traitement » (Q7_MEDICAMENTS
    // option F) : champ texte libre OPTIONNEL pour préciser le traitement. L'algo
    // ne le lit pas, mais il est capturé et envoyé à Klaviyo (medicaments_autre_detail)
    // pour le suivi par la pharmacienne. S'affiche uniquement si 'F' est coché.
    if (q.id === 'Q7_MEDICAMENTS' && Array.isArray(current) && current.indexOf('F') !== -1) {
      const wrap = h('div', { class: 'pd-freetext-wrap' });
      wrap.appendChild(h('label', { class: 'pd-freetext-label', for: 'pd-medic-autre' },
        'Préciser le traitement (optionnel)'));
      const input = h('input', {
        class: 'pd-freetext-input', type: 'text', id: 'pd-medic-autre',
        maxlength: '120', placeholder: 'Ex : traitement thyroïdien, antihypertenseur…',
        value: state.answers.Q7_MEDICAMENTS_autre || ''
      });
      input.addEventListener('input', (e) => {
        state.answers.Q7_MEDICAMENTS_autre = e.target.value;
        saveState(state);
      });
      wrap.appendChild(input);
      root.appendChild(wrap);
    }

    // V3.4 — Footer unifié : single = back + note discrète, multi = back + Suivant.
    // Plus de pd-cta-next inline (le bouton multi est dans le footer uniquement).
    // Plus de skip "Suivant" pour questions non-required (toutes obligatoires).
    const footer = h('div', { class: 'pd-footer' });
    if (canGoBack(state, flow)) {
      const back = h('button', { class: 'pd-btn pd-btn-ghost', type: 'button', 'data-action': 'back' },
        ICONS.back + ' Précédent');
      back.addEventListener('click', () => goPrev(state, app));
      footer.appendChild(back);
    }
    if (isMulti) {
      const next = h('button', { class: 'pd-btn pd-btn-primary', type: 'button', 'data-action': 'next' },
        'Suivant →');
      next.addEventListener('click', () => goNext(state, app));
      footer.appendChild(next);
    } else {
      footer.appendChild(h('span', { class: 'pd-footer-note' },
        'Sélection unique — avancement automatique'));
    }
    root.appendChild(footer);

    // V3.4 — fixOptionBorders + tooltip click handler en rAF après injection DOM.
    // Le listener touchstart global est armé une seule fois (idempotent).
    ensureTooltipTouchListener();
    requestAnimationFrame(() => {
      fixOptionBorders();
      document.querySelectorAll('[data-info-wrap]').forEach(function(wrap) {
        const btn = wrap.querySelector('.pd-info-btn');
        if (!btn) return;
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          wrap.classList.toggle('is-open');
        });
      });
    });

    // V3.34d-PROGRESS-REPOSITION — Wrapper externe : barre de progression
    // 4px à largeur de carte, 8px au-dessus de la carte question.
    // V7.10 — pd-progress-label déplacé de root vers wrapper, sous la barre
    // (cohérent avec quiz nutrition).
    const wrapper = h('div', { class: 'pd-question-wrapper' });
    const progression = h('div', { class: 'pd-progression' });
    progression.appendChild(h('div', {
      class: 'pd-progression__fill',
      style: 'width:' + globalPct + '%'
    }, '​'));
    wrapper.appendChild(progression);
    const progressLabel = root.querySelector('.pd-progress-label');
    if (progressLabel) {
      progressLabel.remove();
      progressLabel.classList.add('pd-progress-label--under-bar');
      wrapper.appendChild(progressLabel);
    }
    // Correction UI (demande Bilikiss) — le badge pd-step-tag a été supprimé du
    // header (cf plus haut). Plus de déplacement « out-of-card » : toute l'info
    // de section/partie/position est dans le label texte sous la barre.
    wrapper.appendChild(root);
    return wrapper;
  }

  function stepLabel(step) {
    return {
      STEP2: 'Analyse de base',
      STEP3: 'Recevoir mon protocole',
      STEP4: 'Votre routine de base',
      STEP7: 'Personnalisation avancée',
      MDV:   'Mode de vie'
    }[step] || '';
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  STEP 3 — Email capture (item 15 : copy "protocole")
  // ────────────────────────────────────────────────────────────────────────────

  function renderEmailCapture(state, app) {
    const root = h('div', { class: 'pd-question pd-email-capture pd-fade' });
    renderProgress(root, 0, 0, SECTION_LABELS.STEP3);
    // Item 15 : suppression du double étiquette ÉTAPE INTERMÉDIAIRE (le label progress suffit).
    root.appendChild(h('h2', { class: 'pd-question-title' }, 'Accédez à votre protocole'));
    root.appendChild(h('p', { class: 'pd-question-prompt' },
      'Votre prénom personnalise votre page de résultats. Votre email vous permet de la retrouver à tout moment et de recevoir vos conseils personnalisés.'));

    const form = h('form', { class: 'pd-form' });
    const firstIn = h('input', { type: 'text', name: 'first_name', placeholder: 'Prénom (facultatif)', class: 'pd-input' });
    const emailIn = h('input', { type: 'email', name: 'email', placeholder: 'votre@email.com', class: 'pd-input' });
    const submit = h('button', { class: 'pd-btn pd-btn-dark', type: 'submit' }, 'Continuer →');
    form.appendChild(firstIn); form.appendChild(emailIn); form.appendChild(pdCercleBox()); form.appendChild(submit);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      state.email = emailIn.value.trim() || null;
      state.firstName = firstIn.value.trim() || null;
      saveState(state);
      if (state.email) {
        try {
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', { $email: state.email, $first_name: state.firstName || undefined }]);
          window._learnq.push(['track', 'Quiz Peau Email Renseigné', { source: 'quiz_peau' }]);
          state.cercle = pdCercleSubscribe(form, state.email, state.firstName, 'Bilan peau'); saveState(state);
        } catch (err) { /* silent */ }
      }
      goNext(state, app);
    });
    root.appendChild(form);
    // V3.4 — pas de lien "passer cette étape" affiché (demande Bilikiss) :
    // incite à laisser l'email. L'email reste techniquement facultatif (champ
    // non requis), mais sans affordance de skip explicite.
    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  V3.34-fix-transitions-v2 — TRANSITION 1 (entre email et révélation pack)
  //  Refonte structure narrative + animation séquentielle (pattern transition 2).
  //  Eyebrow active/done crossfade, 3 checks fade-in cascadés, titre + CTA.
  //  Fond hérite body.pd-quiz-active vert sombre via override CSS .pd-question.
  // ────────────────────────────────────────────────────────────────────────────

  function renderTransition1(state, app) {
    setQuizBgDark(false);
    // FIX-T1-HARMONISATION — Refonte structure pour réutiliser le pattern
    // visuel de la transition finale (.pd-transition-eyebrow + tirets latéraux
    // CSS, .pd-transition-line flex space-between, .pd-transition-status rond
    // vert à droite avec halo sur le dernier). Overrides scopés .pd-transition-1
    // dans le CSS pour adapter à 3 checks au lieu de 5 et tailles brief.
    const root = h('div', { class: 'pd-question pd-transition-1 pd-fade' });

    // Eyebrow : texte initial "ANALYSE EN COURS" → swap "ANALYSE TERMINÉE"
    // à 2.0s + classe .is-done. Tirets latéraux fournis par ::before/::after.
    const eyebrow = h('p', { class: 'pd-transition-eyebrow' }, 'ANALYSE EN COURS');
    root.appendChild(eyebrow);

    // 3 checks (cachés au mount, révélés cascadés à 0.5/1.0/1.5s)
    const stepsList = h('div', { class: 'pd-transition-steps' });
    const checkTexts = [
      'Vos réponses sont enregistrées.',
      'Votre profil cutané est identifié.',
      'Votre routine est en cours de construction.'
    ];
    const checkRefs = checkTexts.map(text => {
      const line = h('div', { class: 'pd-transition-line' });
      line.appendChild(h('p', { class: 'pd-transition-title' }, text));
      const status = h('div', { class: 'pd-transition-status' }, '✓');
      line.appendChild(status);
      stepsList.appendChild(line);
      return { line, status };
    });
    root.appendChild(stepsList);

    // Titre Playfair (caché au mount, révélé à 2.4s)
    const title = h('h2', {
      class: 'pd-transition-1-title',
      html: 'Votre profil cutané est <em>analysé.</em>'
    });
    root.appendChild(title);

    // CTA plein vert (style scopé via CSS .pd-transition-1 .pd-btn-primary).
    const cta = h('button', {
      class: 'pd-btn pd-btn-primary pd-transition-1-cta',
      type: 'button',
      'data-action': 'transition1-next'
    }, 'Découvrir ma routine →');
    cta.addEventListener('click', () => goNext(state, app));
    root.appendChild(cta);

    // Animation séquentielle (pattern transition finale).
    // 0.5/1.0/1.5s checks (line + status), 2.0s eyebrow swap, 2.4s titre, 2.9s CTA.
    const TR1_INTERVAL_MS = 500;
    setTimeout(() => {
      checkRefs[0].line.classList.add('is-visible');
      checkRefs[0].status.classList.add('is-visible');
    }, TR1_INTERVAL_MS);
    setTimeout(() => {
      checkRefs[1].line.classList.add('is-visible');
      checkRefs[1].status.classList.add('is-visible');
    }, TR1_INTERVAL_MS * 2);
    setTimeout(() => {
      checkRefs[2].line.classList.add('is-visible');
      checkRefs[2].status.classList.add('is-visible');
    }, TR1_INTERVAL_MS * 3);

    // 2.0s : eyebrow swap ANALYSE EN COURS -> ANALYSE TERMINÉE + .is-done
    setTimeout(() => {
      eyebrow.textContent = 'ANALYSE TERMINÉE';
      eyebrow.classList.add('is-done');
    }, TR1_INTERVAL_MS * 4);

    // 2.4s titre, 2.9s CTA
    setTimeout(() => title.classList.add('is-visible'), TR1_INTERVAL_MS * 4 + 400);
    setTimeout(() => cta.classList.add('is-visible'), TR1_INTERVAL_MS * 4 + 900);

    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  STEP 4 — Preview Routine (item 4 : "Voici ce que votre peau nous a dit.")
  // ────────────────────────────────────────────────────────────────────────────

  function renderStep4Preview(state, app) {
    setQuizBgDark(false);
    const root = h('div', { class: 'pd-question pd-step4 pd-fade' });
    renderProgress(root, 0, 0, SECTION_LABELS.STEP4);

    const primaryConcern = state.answers.Q2_3;
    const isPregnant = state.answers.Q2_6 === 'A' || state.answers.Q2_6 === 'B';
    const packKey = isPregnant && primaryConcern !== 'H'
      ? 'pack_SAFE'
      : (PACK_FROM_Q23[primaryConcern] || 'pack_CALM');
    const display = ROUTINE_DISPLAY_UI[packKey] || { name: 'Routine personnalisée', descriptor: '' };
    // Extrait le suffixe : "pack_CLEAR" → "CLEAR" pour la classe + l'em
    const packShort = packKey.replace('pack_', '');

    root.appendChild(h('h2', { class: 'pd-question-title' }, 'Voici ce que votre peau nous a dit.'));
    root.appendChild(h('p', { class: 'pd-question-prompt' },
      'Votre routine de base est prête. Vous pourrez l\'affiner à l\'étape suivante.'));

    // V3.6 — Carte signature avec wrapper dégradé lime→or→vert (pseudo border)
    const gradientWrap = h('div', { class: 'pd-step4-gradient-wrap pd-pack-' + packShort });
    const inner = h('div', { class: 'pd-step4-inner' });
    inner.appendChild(h('div', { class: 'pd-step4-eyebrow' }, 'Votre routine de base'));
    inner.appendChild(h('h3', {
      class: 'pd-step4-routine-name',
      html: 'Routine <em>' + escapeHtml(packShort) + '</em>'
    }));
    inner.appendChild(h('p', { class: 'pd-step4-routine-sub' }, display.descriptor));
    gradientWrap.appendChild(inner);
    root.appendChild(gradientWrap);

    // Footer : back link discret + bouton Suivant primary à droite
    const footer = h('div', { class: 'pd-footer' });
    const back = h('button', { class: 'pd-btn pd-btn-ghost', type: 'button', 'data-action': 'back' },
      ICONS.back + ' Précédent');
    back.addEventListener('click', () => goPrev(state, app));
    const next = h('button', { class: 'pd-btn pd-btn-primary', type: 'button', 'data-action': 'next' },
      'Suivant →');
    next.addEventListener('click', () => goNext(state, app));
    footer.appendChild(back);
    footer.appendChild(next);
    root.appendChild(footer);
    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  V3.34b-5 — STEP combiné : révélation pack + sélection niveau (1 page)
  //  Fusion de renderStep4Preview (révélation pack) et renderStep5Level (choix niveau).
  //  La cliente lit son pack identifié + sélectionne son niveau sur la même page.
  //  CTA "Continuer →" mène à la page bifurcation (renderStep6Gate V3.34b-4).
  // ────────────────────────────────────────────────────────────────────────────

  function renderPackAndTier(state, app) {
    setQuizBgDark(false);
    const root = h('div', { class: 'pd-question pd-pack-and-tier pd-fade' });

    // ── Section 1 : Révélation pack ──────────────────────────────────────────
    // Logique pack identique à renderStep4Preview (Q2_3 + Q2_6 grossesse override).
    const primaryConcern = state.answers.Q2_3;
    const isPregnant = state.answers.Q2_6 === 'A' || state.answers.Q2_6 === 'B';
    const packKey = isPregnant && primaryConcern !== 'H'
      ? 'pack_SAFE'
      : (PACK_FROM_Q23[primaryConcern] || 'pack_CALM');
    const display = ROUTINE_DISPLAY_UI[packKey] || { name: 'Routine personnalisée', descriptor: '' };
    const packShort = packKey.replace('pack_', '');

    const sectionReveal = h('section', { class: 'pd-pat-section pd-pat-section-reveal' });
    // V3.34d-AERATION-CARTES-BEIGE — Bloc beige : eyebrow seul. Le titre
    // "Votre routine est SAFE" et le descriptor "Grossesse & Allaitement"
    // ont été déplacés UNIQUEMENT sur la carte verte gradient ci-dessous
    // (anti-doublon, info routine concentrée sur la carte signature).
    sectionReveal.appendChild(h('p', { class: 'pd-pat-eyebrow' }, 'VOTRE PROFIL EST IDENTIFIÉ'));

    // Visuel pack : carte gradient signature de renderStep4Preview.
    // Eyebrow + titre Routine + descriptor (display.descriptor).
    const gradientWrap = h('div', { class: 'pd-step4-gradient-wrap pd-pack-' + packShort });
    const inner = h('div', { class: 'pd-step4-inner' });
    inner.appendChild(h('div', { class: 'pd-step4-eyebrow' }, 'Votre routine de base'));
    inner.appendChild(h('h3', {
      class: 'pd-step4-routine-name',
      html: 'Routine <em>' + escapeHtml(packShort) + '</em>'
    }));
    inner.appendChild(h('p', { class: 'pd-step4-routine-sub' }, display.descriptor));
    gradientWrap.appendChild(inner);
    sectionReveal.appendChild(gradientWrap);
    root.appendChild(sectionReveal);

    // ── Séparateur visuel discret ────────────────────────────────────────────
    root.appendChild(h('div', { class: 'pd-pat-divider' }));

    // ── Section 2 : Sélection niveau ─────────────────────────────────────────
    // Logique niveau identique à renderStep5Level (algo cap + recommended +
    // pré-sélection + cartes cliquables avec re-render).
    const algo = window.ParaDermiaAlgo;
    const cap = (algo.maxAllowedLevel(algo.collectInputs(state.answers)) || 'niveau_PREMIUM')
      .replace('niveau_', '');
    const recommended = (algo.computeRecommendedLevel(state.answers) || 'niveau_OPTIMAL')
      .replace('niveau_', '');
    // V8 (demande Bilikiss) — Pré-sélection du niveau RECOMMANDÉ. Supprime le
    // double-clic : la carte recommandée est sélectionnée d'office, le bouton
    // « Continuer » est actif immédiatement, et si la cliente « passe » sans
    // cliquer une autre carte, c'est le recommandé qui est pris. On
    // présélectionne le `recommended` FRAÎCHEMENT calculé (jamais une valeur
    // périmée) : dans computeTierFinal, tier_user_choice == tier_recalculated
    // → AUCUNE fausse alerte de descente. Le bug « vigilance fantôme » venait
    // d'un tier_user_choice périmé d'un run précédent, pas du recommandé live.
    // La cliente peut toujours cliquer une autre carte pour changer.
    if (!state.answers.tier_selected) {
      state.answers.tier_selected = recommended;
      state.tier_user_choice = recommended;
      saveState(state);
    }

    const LEVEL_DESC = {
      STARTER: 'Les essentiels qui fonctionnent.',
      OPTIMAL: 'Meilleur rapport qualité / résultat.',
      PREMIUM: 'Actifs concentrés dernière génération.'
    };
    const LEVEL_LABEL = { STARTER: 'Starter', OPTIMAL: 'Optimal', PREMIUM: 'Premium' };

    const sectionTier = h('section', { class: 'pd-pat-section pd-pat-section-tier' });
    sectionTier.appendChild(h('p', { class: 'pd-pat-eyebrow' },
      'QUEL NIVEAU DE SOINS VOUS CORRESPOND ?'));

    const grid = h('div', { class: 'pd-levels-grid' });
    ['STARTER','OPTIMAL','PREMIUM'].forEach(L => {
      const disabled = (L === 'PREMIUM' && cap !== 'PREMIUM') ||
                       (L === 'OPTIMAL' && cap === 'STARTER');
      const isSelected = state.answers.tier_selected === L && !disabled;
      // Sprint 4 refactor — Badge RECOMMANDÉ aligné sur computeRecommendedLevel
      // (score_duree + score_expertise + plafond maxAllowedLevel), identique à
      // la pré-sélection. && !disabled reste comme garde défensive (recommended
      // est déjà cappé en pratique, jamais sur une carte disabled).
      const isRecommendedVisual = (L === recommended) && !disabled;
      const card = h('div', {
        class: 'pd-level-card'
          + (isSelected ? ' is-selected' : '')
          + (disabled ? ' is-disabled' : ''),
        'data-value': L.toLowerCase()
      });
      if (isRecommendedVisual) {
        card.appendChild(h('span', { class: 'pd-level-badge' }, 'Recommandé'));
      }
      card.appendChild(h('p', { class: 'pd-level-name' }, LEVEL_LABEL[L]));
      card.appendChild(h('p', { class: 'pd-level-desc' }, LEVEL_DESC[L]));
      if (disabled) card.appendChild(h('p', { class: 'pd-step5-cap' }, 'Non disponible pour votre profil.'));
      if (!disabled) {
        card.addEventListener('click', () => {
          state.answers.tier_selected = L;
          // V3.34c-1 : sync tier_user_choice canonique. answers.tier_selected
          // reste consommé directement par l'algo (cf quiz-algo.js l.235).
          state.tier_user_choice = L;
          saveState(state);
          app.render();
        });
      }
      grid.appendChild(card);
    });
    sectionTier.appendChild(grid);
    root.appendChild(sectionTier);

    // ── CTA Continuer — désactivé tant qu'aucun niveau n'est choisi ──────────
    const footer = h('div', { class: 'pd-footer' });
    const back = h('button', { class: 'pd-btn pd-btn-ghost', type: 'button', 'data-action': 'back' },
      ICONS.back + ' Précédent');
    back.addEventListener('click', () => goPrev(state, app));
    const hasChoice = !!state.answers.tier_selected;
    const next = h('button', {
      class: 'pd-btn pd-btn-primary pd-pat-cta' + (hasChoice ? '' : ' is-disabled'),
      type: 'button', 'data-action': 'next',
      disabled: hasChoice ? null : ''
    }, hasChoice ? 'Continuer →' : 'Choisissez un niveau');
    if (hasChoice) next.addEventListener('click', () => goNext(state, app));
    footer.appendChild(back);
    footer.appendChild(next);
    root.appendChild(footer);

    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  STEP 6 — Gate "Affiner ?" (item 16 : fond vert + copy compléments)
  // ────────────────────────────────────────────────────────────────────────────

  function renderStep6Gate(state, app) {
    // V3.34e — Refonte step6Gate : analyse mi-parcours motivante avec 2 CTAs
    // courts (Finaliser / Affiner), hiérarchisés selon state.intro_choice
    // (qui est désormais choisi DÈS l'intro renderStep0). Le user voit que
    // sa routine de base est prête et choisit (ou confirme) sa suite. Le
    // mode déjà choisi à l'intro = CTA primaire vert clair en haut ; l'autre
    // mode = CTA ghost en bas (porte de sortie discrète). Rétrocompat : si
    // state.intro_choice undefined (sessions antérieures), on défaut sur
    // 'complet' (= hiérarchie identique à V3.34b-4).
    setQuizBgDark(true);
    const root = h('div', { class: 'pd-question pd-step6 pd-bifurcation pd-step6-v2 pd-fade' });

    // Récupération pack identifié + niveau choisi (logique inchangée)
    const primaryConcern = state.answers.Q2_3;
    const isPregnant = state.answers.Q2_6 === 'A' || state.answers.Q2_6 === 'B';
    const packKey = isPregnant && primaryConcern !== 'H'
      ? 'pack_SAFE'
      : (PACK_FROM_Q23[primaryConcern] || 'pack_CALM');
    const packShort = packKey.replace('pack_', '');
    const tierLabel = state.answers.tier_selected || 'OPTIMAL';

    // Mode hérité de l'intro (rétrocompat → 'complet' par défaut)
    const introMode = state.intro_choice || 'complet';

    root.appendChild(h('p', { class: 'pd-bifurcation-eyebrow' }, 'ÉTAPE 2 SUR 3 · ANALYSE'));

    const frame = h('div', { class: 'pd-bifurcation-frame pd-step6-frame-v2' });

    // Titre motivant : "Votre routine de base est prête."
    frame.appendChild(h('h2', {
      class: 'pd-bifurcation-title pd-step6-title-v2',
      html: 'Votre routine de base est <em>prête.</em>'
    }));

    // Pastille Pack + Niveau
    const packPillWrap = h('div', { class: 'pd-step6-pack-pill-wrap' });
    const packPill = h('div', { class: 'pd-step6-pack-pill' });
    packPill.appendChild(h('span', {}, 'Pack ' + escapeHtml(packShort)));
    packPill.appendChild(h('span', { class: 'pd-step6-pack-sep' }, '·'));
    packPill.appendChild(h('span', {}, 'Niveau ' + escapeHtml(tierLabel)));
    packPillWrap.appendChild(packPill);
    frame.appendChild(packPillWrap);

    // Construction des 2 blocs CTAs (Finaliser / Affiner)
    const buildFinaliserBlock = (variant) => {
      const block = h('div', { class: 'pd-step6-cta-block' });
      const btn = h('button', {
        class: 'pd-step6-cta pd-step6-cta--' + variant,
        type: 'button',
        'data-action': 'step6-finaliser'
      }, 'Finaliser');
      btn.addEventListener('click', () => {
        try {
          if (introMode !== 'rapide') {
            window._learnq = window._learnq || [];
            window._learnq.push(['track', 'Quiz Peau Mode Changed', {
              from: introMode, to: 'rapide'
            }]);
          }
        } catch (err) { /* silent */ }
        state.skipped7 = true;
        state.parcours = 'standard';
        state.intro_choice = 'rapide';
        const flow = buildFlow(state.answers, true);
        const targetIdx = flow.findIndex(f => f.id === '_MDV_LIGHT' || f.id === 'QMDV');
        state.cursor = targetIdx !== -1 ? targetIdx : flow.length - 1;
        saveState(state);
        app.render();
      });
      const helper = h('div', { class: 'pd-step6-cta-helper' });
      helper.appendChild(document.createTextNode("Une dernière question pour l'ajuster à vos habitudes. "));
      helper.appendChild(h('span', { class: 'pd-step6-cta-time' }, '10 s'));
      block.appendChild(btn);
      block.appendChild(helper);
      return block;
    };

    const buildAffinerBlock = (variant) => {
      const block = h('div', { class: 'pd-step6-cta-block' });
      const btn = h('button', {
        class: 'pd-step6-cta pd-step6-cta--' + variant,
        type: 'button',
        'data-action': 'step6-affiner'
      }, 'Affiner');
      btn.addEventListener('click', () => {
        try {
          if (introMode !== 'complet') {
            window._learnq = window._learnq || [];
            window._learnq.push(['track', 'Quiz Peau Mode Changed', {
              from: introMode, to: 'complet'
            }]);
          }
        } catch (err) { /* silent */ }
        state.skipped7 = false;
        state.parcours = 'personnalise';
        state.intro_choice = 'complet';
        saveState(state);
        goNext(state, app);
      });
      const helper = h('div', { class: 'pd-step6-cta-helper' });
      helper.appendChild(document.createTextNode('Quelques questions complémentaires pour personnaliser. '));
      helper.appendChild(h('span', { class: 'pd-step6-cta-time' }, '~ 2 min'));
      block.appendChild(btn);
      block.appendChild(helper);
      return block;
    };

    // Hiérarchie : le mode choisi à l'intro = primaire en haut, l'autre = ghost en bas
    const ctaWrap = h('div', { class: 'pd-step6-cta-wrap' });
    if (introMode === 'rapide') {
      ctaWrap.appendChild(buildFinaliserBlock('primary'));
      ctaWrap.appendChild(buildAffinerBlock('ghost'));
    } else {
      ctaWrap.appendChild(buildAffinerBlock('primary'));
      ctaWrap.appendChild(buildFinaliserBlock('ghost'));
    }
    frame.appendChild(ctaWrap);

    root.appendChild(frame);

    // Back link discret hors cadre (inchangé)
    const back = h('button', {
      class: 'pd-btn pd-btn-ghost pd-back-link', type: 'button', 'data-action': 'back'
    }, ICONS.back + ' Précédent');
    back.addEventListener('click', () => goPrev(state, app));
    root.appendChild(back);

    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  V3.34d-1 — MDV-LIGHT contenu fonctionnel (5 options multi-select max 3)
  //  Insérée par buildFlow uniquement si skipped7=true (parcours='standard').
  //  Réutilise les values A-E de QMDV (l.328-339) pour que algo génère les
  //  tags mode_vie_* automatiquement (algo lit a.QMDV directement, cf
  //  quiz-algo.js l.230 : lifestyle = a.QMDV.slice(0, 3)).
  //  Pas d'option F "Tout va bien" en MDV-LIGHT (équivalent fonctionnel = skip
  //  ou validation 0 coché).
  //  CTA "Voir mon protocole →" -> goNext -> finalize -> transition 2 -> STEP 8.
  //  Skip "Passer cette étape" -> ne touche pas answers.QMDV -> goNext.
  // ────────────────────────────────────────────────────────────────────────────

  // V3.34d-MDV-STANDARD-ALIGN-PERSO — Labels alignés sur QMDV complet
  // (cf l.332-339, parcours personnalisation). 6 options dont la value 'F'
  // "Tout va bien" qui est filtrée avant écriture state.answers.QMDV pour
  // ne pas générer de tag mode_vie_* parasite côté algo.
  const MDV_LIGHT_OPTIONS = [
    { value: 'A', label: 'Je manque de sommeil régulièrement.' },
    { value: 'B', label: 'Je suis souvent stressé(e).' },
    { value: 'C', label: 'Mon alimentation est déséquilibrée.' },
    { value: 'D', label: 'Je fais beaucoup de sport / transpire beaucoup.' },
    { value: 'E', label: 'Je suis souvent exposé(e) au soleil.' },
    { value: 'F', label: 'Tout va bien de ce côté-là.' }
  ];
  const MDV_LIGHT_MAX = 3;

  function renderMdvLight(state, app) {
    setQuizBgDark(false);
    const root = h('div', { class: 'pd-question pd-mdv-light pd-fade' });

    // V7 FIX MDV-LIGHT — Refonte titre/prompt selon retour utilisatrice :
    //  - Eyebrow vert clair supprimé (faisait doublon avec le titre)
    //  - Titre principal devient "Une dernière question" (gros, Playfair),
    //    cohérent avec le rythme visuel des pages questions standards
    //  - Accent couleur (em vert) retiré du titre — trop chargé visuellement
    //  - Prompt fusionne l'ancien titre + l'ancien subtext en texte simple
    //    (Raleway, plus petit, comme les autres pages questions)
    // Utilisation des classes standards pd-question-title et pd-question-prompt
    // (au lieu des classes spécifiques pd-mdv-light-*) pour garantir l'alignement
    // visuel avec les autres pages questions sans CSS dédié.
    root.appendChild(h('h2', { class: 'pd-question-title' },
      'Une dernière question'));
    root.appendChild(h('p', { class: 'pd-question-prompt' },
      'Votre quotidien influence aussi votre peau. En ce moment, comment vous sentez-vous au quotidien ? (3 choix maximum)'));

    // Pré-remplissage si la cliente revient en arrière (état persisté QMDV)
    const initialSet = new Set(
      Array.isArray(state.answers.QMDV) ? state.answers.QMDV : []
    );

    const optionsList = h('ul', {
      class: 'pd-mdv-light-options pd-options pd-options-multi'
    });
    // V3.34d-MDV-OPTION-F-EXCLUSIVE — Map value → btn pour pouvoir décocher
    // visuellement A-E quand F est cochée (et inversement).
    const buttonsByValue = {};
    MDV_LIGHT_OPTIONS.forEach(function(opt) {
      const isSelected = initialSet.has(opt.value);
      const li = h('li', { class: 'pd-mdv-light-option-wrap' });
      const btn = h('button', {
        class: 'pd-option pd-mdv-light-option' + (isSelected ? ' is-selected' : ''),
        type: 'button',
        'data-value': opt.value
      });
      buttonsByValue[opt.value] = btn;
      const body = h('div', { class: 'pd-option-body' }, [
        h('span', { class: 'pd-option-bullet' }),
        h('span', { class: 'pd-option-label' }, opt.label)
      ]);
      btn.appendChild(body);
      btn.addEventListener('click', function() {
        // V3.34d-MDV-OPTION-F-EXCLUSIVE — Logique exclusive F :
        //  - Cocher F → décoche A-E (visuel + state)
        //  - Cocher A-E alors que F est cochée → décoche F
        //  - Max 3 ne s'applique qu'aux A-E (F seule n'occupe qu'1 slot)
        if (opt.value === 'F') {
          if (initialSet.has('F')) {
            initialSet.delete('F');
            btn.classList.remove('is-selected');
          } else {
            // Décocher visuellement toutes les A-E déjà cochées
            ['A', 'B', 'C', 'D', 'E'].forEach(function(v) {
              if (initialSet.has(v)) {
                initialSet.delete(v);
                if (buttonsByValue[v]) buttonsByValue[v].classList.remove('is-selected');
              }
            });
            initialSet.add('F');
            btn.classList.add('is-selected');
          }
          return;
        }
        // Toggle A-E
        if (initialSet.has(opt.value)) {
          initialSet.delete(opt.value);
          btn.classList.remove('is-selected');
        } else {
          // Retirer F si présente avant d'ajouter A-E
          if (initialSet.has('F')) {
            initialSet.delete('F');
            if (buttonsByValue['F']) buttonsByValue['F'].classList.remove('is-selected');
          }
          // Max 3 sur A-E uniquement (F déjà retirée ci-dessus si présente)
          if (initialSet.size >= MDV_LIGHT_MAX) return;
          initialSet.add(opt.value);
          btn.classList.add('is-selected');
        }
      });
      li.appendChild(btn);
      optionsList.appendChild(li);
    });
    root.appendChild(optionsList);

    // CTA principal "Voir mon protocole →" — toujours cliquable même 0 coché.
    const cta = h('button', {
      class: 'pd-btn pd-btn-primary pd-mdv-light-cta',
      type: 'button',
      'data-action': 'mdvlight-validate'
    }, 'Voir mon protocole →');
    cta.addEventListener('click', function() {
      // V3.34d-MDV-STANDARD-ALIGN-PERSO — La value 'F' "Tout va bien" est
      // filtrée avant écriture state.answers.QMDV (ne doit pas générer de
      // tag mode_vie_* côté algo). Si la cliente coche F seul, mdv_light_answered
      // reste true (validation explicite, différent d'un skip pur) mais
      // QMDV reste vide → équivalent fonctionnel skip côté algo.
      const arrFiltered = Array.from(initialSet).filter(function(v) { return v !== 'F'; });
      if (initialSet.size > 0) {
        state.mdv_light_answered = true;
        if (arrFiltered.length > 0) {
          state.answers.QMDV = arrFiltered;
        } else {
          delete state.answers.QMDV;
        }
      } else {
        // 0 coché : pas de tags mode_vie_*, équivalent fonctionnel d'un skip.
        // On nettoie défensivement answers.QMDV au cas où il aurait été posé
        // antérieurement (revisite après cochage puis décochage total).
        delete state.answers.QMDV;
        state.mdv_light_answered = false;
      }
      saveState(state);
      goNext(state, app);
    });
    root.appendChild(cta);

    // V3.34d-MDV-STANDARD-ALIGN-PERSO — Lien "Passer cette étape" retiré.
    // L'option F "Tout va bien de ce côté-là." remplit fonctionnellement ce
    // rôle (F seule cochée → state.answers.QMDV vide après filter, équivalent
    // skip mais avec validation explicite via mdv_light_answered=true).

    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  Bandeau alerte plein écran (acné sévère, rosacée — déclenchés in-flow)
  // ────────────────────────────────────────────────────────────────────────────

  const ALERTS_CONTENT = {
    _ALERT_ACNE_SEVERE: {
      title: 'Acné installée détectée',
      body:  'Une acné installée bénéficie souvent d\'une consultation dermatologique en parallèle de votre routine cosmétique pour accélérer les résultats. En attendant, voici le protocole le mieux adapté à votre profil.'
    },
    _ALERT_ROSACEE: {
      title: 'Rougeurs persistantes',
      body:  'Des rougeurs persistantes peuvent indiquer une rosacée. Un diagnostic dermatologique est recommandé pour une prise en charge précise. Votre protocole a été ajusté avec les actifs les mieux tolérés pour ce profil.'
    }
  };
  function renderAlertBanner(item, state, app) {
    const root = h('div', { class: 'pd-question pd-alert-banner pd-fade' });
    const c = ALERTS_CONTENT[item.id] || { title: 'Information', body: '' };
    root.appendChild(h('div', { class: 'pd-alert-banner-icon', html: SVG.warning }));
    root.appendChild(h('h2', { class: 'pd-alert-banner-title' }, c.title));
    root.appendChild(h('p', { class: 'pd-alert-banner-body' }, c.body));
    const cta = h('button', { class: 'pd-btn pd-btn-dark pd-cta-next', type: 'button' }, 'Compris, je continue →');
    cta.addEventListener('click', () => goNext(state, app));
    root.appendChild(cta);
    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  STEP 5 — Choix niveau (item 5 : copy + OPTIMAL recommandée fond vert via CSS)
  // ────────────────────────────────────────────────────────────────────────────

  function renderStep5Level(state, app) {
    setQuizBgDark(false);
    const root = h('div', { class: 'pd-question pd-step5 pd-fade' });
    renderProgress(root, 0, 0, SECTION_LABELS.STEP5);

    root.appendChild(h('h2', { class: 'pd-question-title' }, 'Quel niveau de soins vous correspond ?'));
    root.appendChild(h('p', { class: 'pd-question-prompt' },
      'Trois niveaux d\'engagement. Notre pharmacienne a présélectionné le vôtre.'));

    const algo = window.ParaDermiaAlgo;
    const cap = (algo.maxAllowedLevel(algo.collectInputs(state.answers)) || 'niveau_PREMIUM')
      .replace('niveau_', '');
    const recommended = (algo.computeRecommendedLevel(state.answers) || 'niveau_OPTIMAL')
      .replace('niveau_', '');

    // Pré-sélection = recommandation algo (badge visuel toujours OPTIMAL).
    if (!state.answers.tier_selected) {
      state.answers.tier_selected = recommended;
    }

    const LEVEL_DESC = {
      STARTER: 'Les essentiels qui fonctionnent.',
      OPTIMAL: 'Meilleur rapport qualité / résultat.',
      PREMIUM: 'Actifs concentrés dernière génération.'
    };
    const LEVEL_LABEL = { STARTER: 'Starter', OPTIMAL: 'Optimal', PREMIUM: 'Premium' };

    // V3.3 — Grille 3 cartes niveau (blanc pur, Playfair, hover tactile).
    // Badge "Recommandé" toujours sur OPTIMAL ; is-selected suit tier_selected.
    const grid = h('div', { class: 'pd-levels-grid' });
    ['STARTER','OPTIMAL','PREMIUM'].forEach(L => {
      const disabled = (L === 'PREMIUM' && cap !== 'PREMIUM') ||
                       (L === 'OPTIMAL' && cap === 'STARTER');
      const isSelected = state.answers.tier_selected === L && !disabled;
      // V7 FIX badge — Aligné sur computeRecommendedLevel (variable recommended
      // calculée plus haut l.1561), au lieu du hardcoded 'OPTIMAL' qui posait
      // le badge sur la mauvaise carte quand l'algo recommandait STARTER ou
      // PREMIUM. Cohérent avec renderPackAndTier qui a le même fix depuis
      // Sprint 4 refactor. && !disabled comme garde défensive.
      const isRecommendedVisual = (L === recommended) && !disabled;
      const card = h('div', {
        class: 'pd-level-card'
          + (isSelected ? ' is-selected' : '')
          + (disabled ? ' is-disabled' : ''),
        'data-value': L.toLowerCase()
      });
      if (isRecommendedVisual) {
        card.appendChild(h('span', { class: 'pd-level-badge' }, 'Recommandé'));
      }
      card.appendChild(h('p', { class: 'pd-level-name' }, LEVEL_LABEL[L]));
      card.appendChild(h('p', { class: 'pd-level-desc' }, LEVEL_DESC[L]));
      if (disabled) card.appendChild(h('p', { class: 'pd-step5-cap' }, 'Non disponible pour votre profil.'));
      if (!disabled) {
        card.addEventListener('click', () => {
          // Sélection unique : tier_selected → re-render → seule la cliquée porte is-selected.
          state.answers.tier_selected = L;
          saveState(state);
          app.render();
        });
      }
      grid.appendChild(card);
    });
    root.appendChild(grid);

    // Footer : back + Suivant explicite
    const footer = h('div', { class: 'pd-footer' });
    const back = h('button', { class: 'pd-btn pd-btn-ghost', type: 'button', 'data-action': 'back' },
      ICONS.back + ' Précédent');
    back.addEventListener('click', () => goPrev(state, app));
    const next = h('button', { class: 'pd-btn pd-btn-primary', type: 'button', 'data-action': 'next' },
      'Suivant →');
    next.addEventListener('click', () => goNext(state, app));
    footer.appendChild(back);
    footer.appendChild(next);
    root.appendChild(footer);
    // V3.2 — fix runtime border-left après l'injection DOM
    requestAnimationFrame(fixOptionBorders);
    return root;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  Mappings client-facing (UI ne doit pas dépendre de l'algo pour les libellés)
  // ────────────────────────────────────────────────────────────────────────────

  const PACK_FROM_Q23 = {
    A: 'pack_CLEAR',  B: 'pack_EVEN',    C: 'pack_LIFT',   D: 'pack_GLOW',
    E: 'pack_CALM',   F: 'pack_REPAIR',  G: 'pack_SAFE',   H: 'pack_STRETCH'
  };
  const ROUTINE_DISPLAY_UI = {
    pack_CLEAR:   { name: 'Routine CLEAR',   descriptor: 'Acné & Imperfections' },
    pack_CALM:    { name: 'Routine CALM',    descriptor: 'Sensibilité & Rougeurs' },
    pack_EVEN:    { name: 'Routine EVEN',    descriptor: 'Taches & Pigmentation' },
    pack_GLOW:    { name: 'Routine GLOW',    descriptor: 'Éclat & Anti-fatigue' },
    pack_REPAIR:  { name: 'Routine REPAIR',  descriptor: 'Sécheresse & Barrière' },
    pack_LIFT:    { name: 'Routine LIFT',    descriptor: 'Anti-âge & Fermeté' },
    pack_SAFE:    { name: 'Routine SAFE',    descriptor: 'Grossesse & Allaitement' },
    pack_STRETCH: { name: 'Routine STRETCH', descriptor: 'Vergetures (corps)' }
  };
  // Item 6 — couleurs pack appliquées via classes CSS (.pd-pack-XXX) sur results-wrapper.
  // Les variables CSS --pack-bg / --pack-accent sont définies dans quiz-paradermia.css.
  const PACK_CSS_CLASS = {
    pack_CLEAR:   'pd-pack-CLEAR',
    pack_CALM:    'pd-pack-CALM',
    pack_EVEN:    'pd-pack-EVEN',
    pack_GLOW:    'pd-pack-GLOW',
    pack_REPAIR:  'pd-pack-REPAIR',
    pack_LIFT:    'pd-pack-LIFT',
    pack_SAFE:    'pd-pack-SAFE',
    pack_STRETCH: 'pd-pack-STRETCH'
  };
  // Fallback colors (si un pack non listé) — utilisé comme inline style sur certains éléments.
  const PACK_COLORS_UI = {
    pack_CLEAR:   { primary: '#88cc40', secondary: '#5aa820' },
    pack_CALM:    { primary: '#a8d5e2', secondary: '#7ab8c8' },
    pack_EVEN:    { primary: '#C9A84C', secondary: '#e8c96a' },
    pack_GLOW:    { primary: '#d4a820', secondary: '#e8c040' },
    pack_REPAIR:  { primary: '#c8a882', secondary: '#a87850' },
    pack_LIFT:    { primary: '#9b8ec4', secondary: '#7b6aa4' },
    pack_SAFE:    { primary: '#88cc40', secondary: '#C9A84C' },
    pack_STRETCH: { primary: '#d4809a', secondary: '#c87890' }
  };

  // ────────────────────────────────────────────────────────────────────────────
  //  STEP 1 Hero — Item 1 : carte sombre signature, eyebrow + stats + halo
  // ────────────────────────────────────────────────────────────────────────────

  function renderHero(state, app) {
    // V3.17 — Dead code. renderStep0 est désormais l'entrée du quiz depuis
    // V3.16. Si ce console.warn apparaît, c'est qu'un appel renderHero
    // subsiste quelque part et doit être identifié + retiré.
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[ParaDermia V3.17] renderHero appelée — devrait être dead code. Trace : ', new Error().stack);
    }
    return document.createElement('div');
    // ─── Body original conservé ci-dessous (jamais exécuté à cause du return) ───
    // Pleine page vert foncé : .pd-hero (bg + ::before line) > .pd-hero-bg + .pd-hero-inner.
    const root = h('div', { class: 'pd-hero' });

    // Radial gradient en background absolu
    root.appendChild(h('div', { class: 'pd-hero-bg' }));

    const inner = h('div', { class: 'pd-hero-inner' });

    // Helper : ouvre la modale d'introduction (réutilisé par les 2 instances)
    const openIntroModal = () => openInfoModal('Analyse de peau Paradermia', HERO_CONTENT.info.join('\n\n'));

    // 0. Bouton info coin haut-droite (position absolue, bulle verte) — toujours visible
    inner.appendChild(h('div', {
      class: 'pd-info-icon pd-info-icon--corner',
      'data-action': 'open-modal',
      role: 'button',
      tabindex: '0',
      'aria-label': 'En savoir plus sur ce questionnaire',
      onclick: openIntroModal
    }, 'i'));

    // 1. Eyebrow
    inner.appendChild(h('div', { class: 'pd-hero-eyebrow' }, HERO_CONTENT.eyebrow));

    // 2. Titre avec <em>logique.</em>
    inner.appendChild(h('h1', { class: 'pd-hero-title', html: HERO_CONTENT.titleHtml }));

    // 3. Sous-titre
    inner.appendChild(h('p', { class: 'pd-hero-subtitle' }, HERO_CONTENT.subtitle));

    // 4. Hint avec caractère "i" inline (sans bulle) — discret
    const hint = h('div', { class: 'pd-hero-hint' });
    hint.appendChild(h('span', {
      class: 'pd-info-inline',
      'data-action': 'open-modal',
      role: 'button',
      tabindex: '0',
      'aria-label': 'En savoir plus sur ce questionnaire',
      onclick: openIntroModal
    }, 'i'));
    hint.appendChild(h('span', {}, HERO_CONTENT.infoHint));
    inner.appendChild(hint);

    // 5. CTA halo (animation pdHaloHero scopée hero, pas sur le bouton)
    const haloWrap = h('div', { class: 'pd-halo-wrap' });
    const cta = h('button', {
      class: 'pd-btn pd-btn-primary',
      type: 'button',
      'data-action': 'start'
    }, HERO_CONTENT.cta + ' →');
    cta.addEventListener('click', () => {
      state.heroSeen = true; saveState(state); app.render();
    });
    haloWrap.appendChild(cta);
    inner.appendChild(haloWrap);

    // 6. Divider fin
    inner.appendChild(h('div', { class: 'pd-hero-divider' }));

    // 7. Stats — 3 colonnes avec border-left CSS-géré
    const statsBar = h('div', { class: 'pd-hero-stats' });
    HERO_CONTENT.stats.forEach(s => {
      statsBar.appendChild(h('div', { class: 'pd-stat' }, [
        h('div', { class: 'pd-stat-value' }, s.value),
        h('div', { class: 'pd-stat-label' }, s.label)
      ]));
    });
    inner.appendChild(statsBar);

    // 8. Credentials avec dots séparateurs
    const creds = h('div', { class: 'pd-hero-credentials' });
    HERO_CONTENT.credentials.forEach((c, i) => {
      creds.appendChild(h('span', {}, c));
      if (i < HERO_CONTENT.credentials.length - 1) {
        creds.appendChild(h('div', { class: 'pd-hero-credentials-sep' }));
      }
    });
    inner.appendChild(creds);

    root.appendChild(inner);
    return root;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V3.15 STEP 0 — Sas de préparation (entre hero et questions)
  //  Activé via state.step0Seen = false. Au clic CTA "Je suis prêt(e)" :
  //  state.step0Seen = true + app.render() → bascule vers renderQuestion(0).
  // ════════════════════════════════════════════════════════════════════════

  function renderStep0(state, app) {
    // V3.34e — Refonte intro : choix DÈS l'intro entre Bilan complet (5min) et
    // Bilan rapide (2min). Le choix écrit state.intro_choice qui sera lu par
    // renderStep6Gate pour pré-sélectionner le CTA primaire (rétrocompat :
    // sessions sans intro_choice retombent sur écran bifurcation classique).
    // Palette à 2 couleurs : vert profond #1E3D10 + crème #F5EFE2 + vert clair
    // #7CA764 sur CTA primaire. Pas d'accent or. Logo via Liquid asset_url
    // (window.PARADERMIA_LOGO_URL) ; wordmark fallback en attendant l'upload.
    setQuizBgDark(true);
    document.body.classList.add('pd-quiz-active');

    const wrapperEl = document.querySelector('[data-quiz-root]');
    if (wrapperEl) {
      wrapperEl.classList.add('pd-step-sas');
      wrapperEl.classList.remove('pd-quiz-wrapper--hero-active');
    }

    const root = h('div', { class: 'pd-welcome pd-welcome-v2' });

    // 1. Bouton info corner (conservé)
    const infoBtn = h('button', {
      class: 'pd-welcome-info-corner',
      type: 'button',
      'aria-label': 'En savoir plus sur cette analyse',
      html: SVG.info
    });
    const WELCOME_MODAL_TEXT = [
      'Bienvenue.',
      'Cette analyse vise à vous recommander le protocole de soins qui vous convient le mieux.',
      'Votre peau est unique. Chaque question est pensée pour mieux la cerner et affiner les soins recommandés.',
      'L\'analyse se déroule en deux temps.',
      'La première partie (6 questions) identifie votre profil cutané et établit un protocole de base solide.',
      'La seconde partie (10 questions, optionnelle) personnalise davantage le protocole selon vos tolérances, vos habitudes et vos préférences.',
      'Vous avez le choix.',
      'Pour bien répondre :\n— Pensez à votre peau nue, comme au réveil.\n— Si vous hésitez sur une question, cliquez sur l\'icône ⓘ.'
    ].join('\n\n');
    const openWelcomeModal = (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      openInfoModal('Bienvenue chez Paradermia', WELCOME_MODAL_TEXT);
    };
    infoBtn.addEventListener('click', openWelcomeModal);
    infoBtn.addEventListener('touchend', openWelcomeModal);
    root.appendChild(infoBtn);

    // 2. Logo (vrai logo via Liquid asset_url ou wordmark fallback)
    const logoUrl = window.PARADERMIA_LOGO_URL || null;
    if (logoUrl) {
      const logoWrap = h('a', { class: 'pd-welcome-logo', href: '/', 'aria-label': 'Accueil ParaDermia' });
      const img = h('img', { class: 'pd-welcome-logo-img', alt: 'Paradermia' });
      img.src = logoUrl;
      logoWrap.appendChild(img);
      root.appendChild(logoWrap);
    } else {
      root.appendChild(h('a', { class: 'pd-welcome-wordmark', href: '/', 'aria-label': 'Accueil ParaDermia' }, 'PARADERMIA'));
    }

    // 3. Chips réassurance — UNIQUEMENT chip compteur 7j conditionnelle
    // (la chip "200+ produits" a été retirée : mensongère vs vraie preuve sociale.
    // Le compteur réel s'affichera quand le pipeline Klaviyo→metafield sera prêt.
    // Tips déplacés dans la modale info (bouton ⓘ en coin haut-droit).)
    const quizCount7d = window.PARADERMIA_QUIZ_COUNT_7D;
    if (typeof quizCount7d === 'number' && quizCount7d >= 50) {
      const chipsWrap = h('div', { class: 'pd-welcome-chips' });
      const chip = h('span', { class: 'pd-welcome-chip' });
      chip.appendChild(h('span', { class: 'pd-welcome-chip-icon', html: SVG.star }));
      chip.appendChild(document.createTextNode(quizCount7d + ' bilans · 7 derniers j'));
      chipsWrap.appendChild(chip);
      root.appendChild(chipsWrap);
    }

    // 4. Eyebrow + Titre (H1 compact 24-27px pour tenir sur mobile sans scroll)
    root.appendChild(h('div', { class: 'pd-welcome-eyebrow' }, 'Avant de commencer'));
    root.appendChild(h('h1', {
      class: 'pd-welcome-title pd-welcome-title-v2',
      html: 'Trouvons <em>votre routine.</em>'
    }));

    // 5. Bloc TIPS condensé (pastille POUR BIEN RÉPONDRE + 2 tirets)
    const tipsBlock = h('div', { class: 'pd-welcome-tips' });
    tipsBlock.appendChild(h('span', { class: 'pd-welcome-tips-label' }, 'POUR BIEN RÉPONDRE'));
    const tip1 = h('div', { class: 'pd-welcome-tip' });
    tip1.appendChild(h('span', { class: 'pd-welcome-tip-dash' }, '—'));
    tip1.appendChild(document.createTextNode('Pensez à votre peau nue, comme au réveil.'));
    tipsBlock.appendChild(tip1);
    const tip2 = h('div', { class: 'pd-welcome-tip' });
    tip2.appendChild(h('span', { class: 'pd-welcome-tip-dash' }, '—'));
    tip2.appendChild(document.createTextNode('Si vous hésitez, cliquez sur '));
    tip2.appendChild(h('span', { class: 'pd-welcome-tip-iicon', html: SVG.info_circle || SVG.info }));
    tipsBlock.appendChild(tip2);
    root.appendChild(tipsBlock);

    // 6. Phrase pivot italique (compactée en 1 ligne pour mobile)
    const pivot = h('div', { class: 'pd-welcome-pivot' });
    pivot.appendChild(document.createTextNode("Prenez le temps : votre routine n'en sera que plus juste."));
    root.appendChild(pivot);

    // 7. Les 2 CTAs intro (Bilan complet primaire + Bilan rapide ghost)
    const startQuizWithMode = (mode) => {
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Quiz Peau Démarré', {
          source: 'quiz_peau',
          started_at: new Date().toISOString(),
          mode: mode
        }]);
      } catch (err) { /* silent */ }
      state.step0Seen = true;
      state.intro_choice = mode; // 'rapide' | 'complet'
      saveState(state);
      app.render();
    };

    const buildIntroCta = (variant, label, time, desc, mode) => {
      const btn = h('button', {
        class: 'pd-intro-cta pd-intro-cta--' + variant,
        type: 'button',
        'data-mode': mode
      });
      const topRow = h('div', { class: 'pd-intro-cta-top' });
      topRow.appendChild(h('span', { class: 'pd-intro-cta-label' }, label));
      topRow.appendChild(h('span', { class: 'pd-intro-cta-time' }, time));
      btn.appendChild(topRow);
      btn.appendChild(h('span', { class: 'pd-intro-cta-desc' }, desc));
      btn.addEventListener('click', () => startQuizWithMode(mode));
      return btn;
    };

    const ctaWrap = h('div', { class: 'pd-intro-cta-wrap' });
    ctaWrap.appendChild(buildIntroCta(
      'primary', 'Bilan complet', '5 MIN',
      'Routine affinée selon vos tolérances, habitudes et objectifs.',
      'complet'
    ));
    ctaWrap.appendChild(buildIntroCta(
      'ghost', 'Bilan rapide', '2 MIN',
      'Routine essentielle adaptée à votre profil cutané, si vous êtes pressé(e).',
      'rapide'
    ));
    root.appendChild(ctaWrap);

    // 8. Footer trust line V2 (3 items : validé dermato / docteur pharmacie / confidentiel)
    const trustLine = h('div', { class: 'pd-welcome-trust pd-welcome-trust-v2' });
    const TRUST_ITEMS = [
      { svg: SVG.check,    text: 'Validé dermatologue' },
      { svg: SVG.pharmacy, text: 'Docteur en pharmacie' },
      { svg: SVG.lock,     text: 'Confidentiel' }
    ];
    TRUST_ITEMS.forEach((item, i) => {
      const tItem = h('span', { class: 'pd-welcome-trust-item' });
      tItem.appendChild(h('span', { class: 'pd-welcome-trust-icon', html: item.svg }));
      tItem.appendChild(document.createTextNode(item.text));
      trustLine.appendChild(tItem);
      if (i < TRUST_ITEMS.length - 1) {
        trustLine.appendChild(h('span', { class: 'pd-welcome-trust-sep' }));
      }
    });
    root.appendChild(trustLine);

    return root;
  }

  function renderResume(existingState, app) {
    const root = h('div', { class: 'pd-question pd-resume' });
    root.appendChild(h('h2', { class: 'pd-question-title' }, 'Vous avez une session en cours'));
    root.appendChild(h('p', { class: 'pd-question-prompt' }, 'Souhaitez-vous reprendre là où vous vous êtes arrêté(e) ?'));
    const row = h('div', { class: 'pd-gate-actions' });
    const resume = h('button', { class: 'pd-btn pd-btn-dark', type: 'button' }, 'Reprendre');
    resume.addEventListener('click', () => { app.state = existingState; app.render(); });
    const restart = h('button', { class: 'pd-btn pd-btn-ghost', type: 'button' }, 'Recommencer');
    restart.addEventListener('click', () => { clearState(); app.state = defaultState(); app.render(); });
    row.appendChild(resume); row.appendChild(restart);
    root.appendChild(row);
    return root;
  }

  // Item 13 — modale info en paragraphes (pas de tirets ni de liste plate)
  function openInfoModal(title, text) {
    const overlay = h('div', { class: 'pd-modal-overlay', onclick: (e) => { if (e.target === overlay) document.body.removeChild(overlay); } });
    const modal = h('div', { class: 'pd-modal' }, [
      h('button', {
        class: 'pd-modal-close', type: 'button',
        html: SVG.close,
        'aria-label': 'Fermer',
        onclick: () => document.body.removeChild(overlay)
      }),
      h('h3', { class: 'pd-modal-title' }, title),
      h('div', { class: 'pd-modal-text', html: text.split('\n').filter(Boolean).map(line => '<p>' + escapeHtml(line) + '</p>').join('') })
    ]);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  ACTIONS
  // ────────────────────────────────────────────────────────────────────────────

  let _advanceTimer = null;

  function handleSelection(q, value, state, app) {
    if (q.type === 'multi') {
      const cur = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];

      // Sprint 3.5 — aucunKey générique pour multi-select. Couvre Q7_ALLERGIES='E',
      // Q7_MEDICAMENTS='G', Q7_COMPLEMENTS='J'. Le cas QMDV reste hardcodé
      // ci-dessous (pas d'aucunKey posé sur QMDV, la branche générique ne s'y
      // déclenche pas).
      if (q.aucunKey != null) {
        if (value === q.aucunKey) {
          if (cur.indexOf(value) !== -1) {
            state.answers[q.id] = [];
          } else {
            state.answers[q.id] = [q.aucunKey];
          }
          saveState(state);
          app.render();
          return;
        }
        const aIdx = cur.indexOf(q.aucunKey);
        if (aIdx !== -1) cur.splice(aIdx, 1);
      }

      // V3.34d-MDV-OPTION-F-EXCLUSIVE — Sur QMDV uniquement, l'option F
      // "Tout va bien de ce côté-là." est exclusive des autres :
      //  - Cocher F → décoche A-E
      //  - Cocher A-E alors que F est cochée → décoche F
      // Le max 3 reste actif pour A-E (F seule n'occupe qu'1 slot).
      if (q.id === 'QMDV') {
        if (value === 'F') {
          if (cur.indexOf('F') !== -1) {
            // Toggle off F → array vide
            state.answers[q.id] = [];
          } else {
            // Toggle on F → exclure A-E
            state.answers[q.id] = ['F'];
          }
          saveState(state);
          app.render();
          return;
        }
        // Cocher A-E : retirer F si présente avant la logique multi générique
        const fIdx = cur.indexOf('F');
        if (fIdx !== -1) cur.splice(fIdx, 1);
      }

      const idx = cur.indexOf(value);
      if (idx !== -1) cur.splice(idx, 1);
      else if (q.max && cur.length >= q.max) return;
      else cur.push(value);
      state.answers[q.id] = cur;
      saveState(state);
      app.render();
      return;
    }
    state.answers[q.id] = value;
    saveState(state);
    app.render();
    if (_advanceTimer) clearTimeout(_advanceTimer);
    _advanceTimer = setTimeout(() => {
      _advanceTimer = null;
      goNext(state, app);
    }, 300);
  }

  function canGoBack(state, flow) {
    if (state.cursor <= 0) return false;
    const curQ = flow[state.cursor];
    if (curQ && curQ.id === 'Q2_1') return false;
    return true;
  }

  function goNext(state, app) {
    const flow = buildFlow(state.answers, state.skipped7);
    if (state.cursor >= flow.length - 1) {
      finalize(state, app);
      return;
    }
    state.cursor += 1;
    saveState(state);
    app.render();
  }

  function goPrev(state, app) {
    state.cursor = Math.max(0, state.cursor - 1);
    saveState(state);
    app.render();
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  V3 — Écran de transition : eyebrow + barre + spotlight + 5 lignes + final
  // ────────────────────────────────────────────────────────────────────────────

  // V3.34b-2 — Refonte timings et copies transition 2.
  // Intervalle régulier 0.5s entre checks (paramétrable via TRANSITION_INTERVAL_MS).
  // 5e phrase nutritionnelle ajoutée (les 4 premières reformulées).
  // Final block séquencé : label 3.0s, finalBlock 3.3s, footer 3.9s.
  // CTA décalé +0.3s par CSS transition-delay (cf .pd-transition-final .pd-btn-primary).
  const TRANSITION_PHRASES = [
    'Votre logique cutanée est décodée.',
    'Vos actifs alliés sont identifiés.',
    'Les associations gagnantes sont validées.',
    'Les incompatibilités sont écartées.',
    'Vos soutiens nutritionnels sont sélectionnés.'
  ];
  const TRANSITION_INTERVAL_MS = 500;            // V3.34b-2 : intervalle régulier paramétrable
  const TRANSITION_TIMINGS = TRANSITION_PHRASES.map((_, i) => (i + 1) * TRANSITION_INTERVAL_MS);
  // = [500, 1000, 1500, 2000, 2500] ms
  const TRANSITION_BAR_STEPS = [20, 40, 60, 80, 100];
  const TRANSITION_FINAL_LABEL_DELAY = 500;      // V3.34b-2 : 2500 + 500 = 3000ms (label)
  const TRANSITION_FINAL_STEP_DELAY = 300;       // V3.34b-2 : entre label, finalBlock, footer
  const TRANSITION_SAFETY_TIMEOUT_MS = 17400;    // safety timeout 17.4s (conservé)

  function showTransitionScreen(targetParent, onDone) {
    setQuizBgDark(false);
    // Construction du DOM
    const overlay = h('div', { class: 'pd-transition-overlay' });
    overlay.appendChild(h('div', { class: 'pd-gradient-line-top' }));

    const inner = h('div', { class: 'pd-transition-inner' });

    const eyebrow = h('p', { class: 'pd-transition-eyebrow' }, 'Votre analyse est en cours');
    inner.appendChild(eyebrow);

    const barTrack = h('div', { class: 'pd-transition-bar-track' });
    const barFill  = h('div', { class: 'pd-transition-bar-fill' });
    barTrack.appendChild(barFill);
    inner.appendChild(barTrack);

    const spotlight = h('div', { class: 'pd-transition-spotlight' });
    const spotlightText = h('p', { class: 'pd-transition-spotlight-text' });
    spotlight.appendChild(spotlightText);
    inner.appendChild(spotlight);

    const stepsList = h('div', { class: 'pd-transition-steps' });
    const lineRefs = TRANSITION_PHRASES.map(phrase => {
      const line = h('div', { class: 'pd-transition-line' });
      line.appendChild(h('p', { class: 'pd-transition-title' }, phrase));
      const status = h('div', { class: 'pd-transition-status' }, '✓');
      line.appendChild(status);
      stepsList.appendChild(line);
      return { line, status };
    });
    inner.appendChild(stepsList);

    const finalDivider = h('div', { class: 'pd-transition-final-divider' });
    inner.appendChild(finalDivider);

    const finalBlock = h('div', { class: 'pd-transition-final' });
    finalBlock.appendChild(h('h2', {
      class: 'pd-transition-final-title',
      html: 'Votre peau a <em>parlé.</em>'
    }));
    const finalCta = h('button', {
      class: 'pd-btn pd-btn-primary',
      type: 'button',
      'data-action': 'reveal-results'
    }, 'Voir mon protocole →');
    finalBlock.appendChild(finalCta);
    inner.appendChild(finalBlock);

    const footer = h('p', {
      class: 'pd-transition-footer',
      html: 'Protocole validé par notre <strong>pharmacienne</strong>'
    });
    inner.appendChild(footer);

    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    // Logique d'animation séquentielle
    let exited = false;
    function triggerExit() {
      if (exited) return;
      exited = true;
      overlay.classList.add('pd-fade-out');
      setTimeout(() => {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        onDone();
      }, 300);
    }
    finalCta.addEventListener('click', triggerExit);

    function showSpotlight(text) {
      spotlightText.classList.remove('is-active');
      setTimeout(() => {
        spotlightText.textContent = text;
        spotlightText.classList.add('is-active');
      }, 200);
    }

    // V3.34b-2 — Animation séquentielle refonte :
    // - Chaque ligne devient is-visible IMMÉDIATEMENT à son timing (pas après la suivante)
    // - Reveal final séquencé : label 3.0s, finalBlock 3.3s (CTA +0.3s par CSS), footer 3.9s
    TRANSITION_PHRASES.forEach((phrase, i) => {
      setTimeout(() => {
        showSpotlight(phrase);
        barFill.style.width = TRANSITION_BAR_STEPS[i] + '%';
        // V3.34b-2 : marque la ligne courante visible IMMÉDIATEMENT
        const cur = lineRefs[i];
        if (cur) {
          cur.line.classList.add('is-visible');
          cur.status.classList.add('is-visible');
        }
      }, TRANSITION_TIMINGS[i]);
    });

    // V3.34b-2 — Reveal final séquencé après le dernier check
    const lastTiming = TRANSITION_TIMINGS[TRANSITION_TIMINGS.length - 1];
    const finalLabelTime = lastTiming + TRANSITION_FINAL_LABEL_DELAY;  // 3000ms

    // 3.0s : label uppercase (eyebrow swap) + divider visible
    setTimeout(() => {
      spotlightText.classList.remove('is-active');
      eyebrow.textContent = '— VOTRE PROTOCOLE EST PRÊT —';
      eyebrow.classList.add('is-done');
      finalDivider.classList.add('is-visible');
    }, finalLabelTime);

    // 3.3s : finalBlock (titre apparaît immédiat, CTA décalé +0.3s par CSS transition-delay)
    setTimeout(() => {
      finalBlock.classList.add('is-visible');
    }, finalLabelTime + TRANSITION_FINAL_STEP_DELAY);

    // 3.9s : footer (signature)
    setTimeout(() => {
      footer.classList.add('is-visible');
    }, finalLabelTime + TRANSITION_FINAL_STEP_DELAY * 3);

    // Safety timeout 17.4s — conservé
    setTimeout(() => triggerExit(), TRANSITION_SAFETY_TIMEOUT_MS);
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  V3.34c-2 — Calcul tier_final selon Philosophie C + plafonds absolus
  //  Exécuté dans finalize() AVANT algo.run pour piloter la sélection produits.
  //  Aligne state.answers.tier_selected = tier_final (consommé par algo l.235).
  //  Conserve state.tier_user_choice intact (séparation choix vs résultat appliqué).
  // ────────────────────────────────────────────────────────────────────────────

  const TIER_ORDER = { STARTER: 0, OPTIMAL: 1, PREMIUM: 2 };
  function tierIsLower(a, b)  { return TIER_ORDER[a] < TIER_ORDER[b]; }
  function tierIsHigher(a, b) { return TIER_ORDER[a] > TIER_ORDER[b]; }

  function identifyDescentReason(state) {
    // Q7_6 (multi-select) contient C_lt3m -> RETINOL_DEBUTANT identifié.
    // Sinon descente générique (cas général de scores bas vs choix haut).
    const Q76 = state.answers.Q7_6;
    const arr = Array.isArray(Q76) ? Q76 : (Q76 ? [Q76] : []);
    if (arr.indexOf('C_lt3m') !== -1) return 'retinol_debutant';
    return 'generic_descent';
  }

  function computeTierFinal(state) {
    const algo = window.ParaDermiaAlgo;
    // Correction (demande Bilikiss) — source de vérité = state.answers.tier_selected
    // (la sélection réellement affichée/cliquée). state.tier_user_choice pouvait
    // désynchroniser (valeur périmée d'un run précédent en localStorage) et
    // produire une fausse alerte « ajusté de PREMIUM à … ». On privilégie donc
    // la sélection live.
    const tier_user_choice = state.answers.tier_selected
      || state.tier_user_choice
      || 'OPTIMAL';

    // tier_recalculated = niveau pur algo (ignore tier_override). On clone
    // answers sans tier_selected pour que computeRecommendedLevel calcule le
    // niveau scoré sans s'auto-référer au choix user.
    const cleanAnswers = Object.assign({}, state.answers);
    delete cleanAnswers.tier_selected;
    const inputs = algo.collectInputs(cleanAnswers);
    const tier_recalculated = (algo.computeRecommendedLevel(cleanAnswers)
      || 'niveau_OPTIMAL').replace('niveau_', '');

    let tier_final = tier_user_choice;
    let alert_type = null;
    let alert_reason = null;

    // ===== PHILOSOPHIE C (parcours personnalisé uniquement) =====
    if (state.parcours === 'personnalise') {
      if (tierIsLower(tier_recalculated, tier_user_choice)) {
        // Descente forcée — sécurité clinique
        tier_final = tier_recalculated;
        alert_type = 'descent';
        alert_reason = identifyDescentReason(state);
      } else if (tierIsHigher(tier_recalculated, tier_user_choice)) {
        // Hausse non imposée — choix bas respecté
        tier_final = tier_user_choice;
        alert_type = 'ascent_optional';
        alert_reason = 'hausse_respectee';
      }
      // égalité : tier_final = tier_user_choice, pas d'alerte
    }
    // En parcours standard : tier_final = tier_user_choice (déjà initialisé).
    // Les plafonds ci-dessous s'appliquent dans les 2 parcours.

    // ===== PLAFONDS ABSOLUS (alert_reason précis) =====
    // Note : algo.maxAllowedLevel les applique aussi mais on duplique ici pour
    // identifier précisément la raison de descente (consommée par V3.34c-3).
    // Plafonds idempotents : si déjà cappé par Philosophie C, ne descendent pas davantage.

    // age_moins_18 (Q7_1='A') -> cap PREMIUM -> OPTIMAL
    if (inputs.age_group === 'age_moins_18' && tier_final === 'PREMIUM') {
      tier_final = 'OPTIMAL';
      alert_type = 'descent';
      alert_reason = 'age_moins_18';
    }

    // barrière fragile (Q2_2='A' ou 'D') -> cap PREMIUM -> OPTIMAL
    const isBarrierFragile = inputs.barrier_status === 'profil_barriere_fragile' ||
                             inputs.barrier_status === 'profil_barriere_fragile_reactive';
    if (isBarrierFragile && tier_final === 'PREMIUM') {
      tier_final = 'OPTIMAL';
      alert_type = 'descent';
      alert_reason = 'barriere_fragile';
    }

    // EFFICACITE_BRUTE (Q7_7='B') + barrière fragile -> cap PREMIUM -> OPTIMAL
    if (inputs.preference_soin === 'B' && isBarrierFragile
        && tierIsHigher(tier_final, 'OPTIMAL')) {
      tier_final = 'OPTIMAL';
      alert_type = 'descent';
      alert_reason = 'efficacite_barriere_fragile';
    }

    // post_acte_actif (Q7_5='A' ou 'B') -> override absolu STARTER (le plus contraignant)
    // Appliqué EN DERNIER pour gagner sur tous les autres plafonds.
    // Sprint 1.5 — Étendu à 'B' (post-acte 0-2 sem) pour aligner avec quiz-algo.js
    // qui cap aussi STARTER pour Q7_5 ∈ {A, B}.
    if (state.answers.Q7_5 === 'A' || state.answers.Q7_5 === 'B') {
      tier_final = 'STARTER';
      alert_type = 'descent';
      alert_reason = 'post_acte_actif';
    }

    // ===== Stockage =====
    state.tier_final = tier_final;
    state.tier_recalculated = tier_recalculated;
    state.alert_type = alert_type;
    state.alert_reason = alert_reason;

    // CRITIQUE : aligne answers.tier_selected = tier_final pour que algo.run
    // utilise le bon niveau lors de la sélection produits (algo lit
    // a.tier_selected directement, cf quiz-algo.js l.235).
    state.answers.tier_selected = tier_final;

    saveState(state);
    return tier_final;
  }

  function finalize(state, app) {
    if (!window.ParaDermiaAlgo) {
      console.error('[ParaDermia] quiz-algo.js not loaded');
      return;
    }
    // V3.34c-2 — Calcul tier_final (Philosophie C + plafonds explicites) AVANT
    // algo.run. Aligne state.answers.tier_selected pour pilotage produits.
    computeTierFinal(state);

    const runAlgo = (catalogue) => {
      // V3.34d-2 — Approche D : neutralise QMDV en parcours standard sans
      // MDV-LIGHT répondu pour désactiver le bonus lifestyle de selectComplements
      // (cf quiz-algo.js l.728). Q7_2/Q7_4 ne sont pas posées en standard donc
      // bonus secondary_pack et phototype-depigmentant sont naturellement absents
      // (skipped7=true skip toutes Q7.* dans buildFlow l.379). Pas besoin de
      // logique défensive sur ces inputs — algo robuste par construction.
      const answersForAlgo = Object.assign({}, state.answers);
      if (state.parcours === 'standard' && !state.mdv_light_answered) {
        delete answersForAlgo.QMDV;
      }
      const output = window.ParaDermiaAlgo.run(pdAlgoAnswers(answersForAlgo), catalogue);
      // V8 (demande Bilikiss) — Enrichit les produits de l'output avec l'IMAGE,
      // le prix et le variantId depuis le catalogue live (joint par handle).
      // L'algo ne transmet pas ces champs ; sans ça la page résultats affiche
      // des vignettes placeholder et doit refetch les prix. On les pose à la
      // source pour que les vraies images produit + prix s'affichent direct.
      try {
        const _catByHandle = {};
        (catalogue || []).forEach((p) => { if (p && p.handle) _catByHandle[p.handle] = p; });
        const _enrichImgPrice = (arr) => {
          (arr || []).forEach((prod) => {
            const src = prod && prod.handle && _catByHandle[prod.handle];
            if (!src) return;
            if (src.image && !prod.image) prod.image = src.image;
            if (prod.price == null && src.price != null) {
              prod.price = (typeof src.price === 'string') ? parseFloat(src.price) : src.price;
            }
            if (src.variantId && !prod.variantId) prod.variantId = src.variantId;
          });
        };
        _enrichImgPrice(output.block2_products);
        _enrichImgPrice(output.block5_complements);
        _enrichImgPrice(output.body_products);
      } catch (_e) { /* enrichissement best-effort, non bloquant */ }
      output._meta = { email: state.email, firstName: state.firstName, startedAt: state.startedAt, completedAt: Date.now() };
      // On capture aussi les inputs pour les alertes UI (item 11)
      output._inputs = {
        answers: Object.assign({}, state.answers),
        skipped7: !!state.skipped7
      };
      // V3.34c-2-PATCH — Persistance des variables tier+alert au-delà de
      // clearState() pour consommation V3.34c-3 (affichage alerte STEP 8).
      // Note : tier_final est aussi accessible via output._inputs.answers.tier_selected
      // mais on le duplique en output.tier_final pour clarté de lecture.
      output.tier_final = state.tier_final;
      output.tier_user_choice = state.tier_user_choice;
      output.tier_recalculated = state.tier_recalculated;
      output.alert_type = state.alert_type;
      output.alert_reason = state.alert_reason;
      // V3.34d-2 — Persistance parcours + mdv_light_answered pour la mention
      // nice-to-have dans block5_complements UI (compléments).
      output.parcours = state.parcours;
      output.mdv_light_answered = !!state.mdv_light_answered;
      try { localStorage.setItem(OUTPUT_KEY, JSON.stringify(output)); } catch (_) {}
      try { localStorage.setItem(PACK_KEY, output.profile.primary_pack); } catch (_) {}
      pushToKlaviyo(state, output);
      clearState();

      const resultsRoot = document.querySelector('[data-quiz-results-root]');
      const quizRoot = document.querySelector('[data-quiz-root]');

      showTransitionScreen(quizRoot || (resultsRoot ? resultsRoot.parentElement : document.body), () => {
        if (resultsRoot) {
          if (quizRoot) quizRoot.style.display = 'none';
          resultsRoot.style.display = '';
          mountResults(resultsRoot);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          const resultsUrl = (window.PARADERMIA_RESULTS_URL) || '/pages/quiz-results';
          window.location.href = resultsUrl;
        }
      });
    };

    // V3.34f — Storefront live SEUL. Le fallback offline catalogue-v5.json a été
    // retiré (obsolète, jokers fantômes). Si Storefront échoue → alert explicite.
    if (!(window.Shopify && window.PARADERMIA_STOREFRONT_TOKEN)) {
      alert('Configuration Storefront manquante. Rechargez la page ou contactez support@paradermia.com.');
      return;
    }
    fetchCatalogueFromStorefront()
      .then(runAlgo)
      .catch(err => {
        console.error('[ParaDermia] Storefront error:', err);
        alert('Impossible de charger le catalogue produits. Vérifiez votre connexion et réessayez. Si le problème persiste : support@paradermia.com');
      });
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  STOREFRONT API (existant — préservé)
  // ────────────────────────────────────────────────────────────────────────────

  // 2026-09-03 (décision fondatrice) — Grossesse / allaitement (Q2_6 = A|B) :
  // le catalogue n'a aucun nettoyant visage adulte sans parfum ; l'étape
  // nettoyant SAFE est sautée (pool vide, joker filtré INCI) et le démaquillant
  // (Sensibio H2O, eau micellaire nettoyante, pack_SAFE) est proposé d'emblée,
  // même sans maquillage. Approche D : copie des réponses AVANT algo.run,
  // quiz-algo.js intouché ; state.answers n'est pas modifié.
  // 2026-10-06 — Forçage retiré : le catalogue a désormais un nettoyant SAFE
  // sans parfum (PD-0555 Round Lab 1025 Dokdo Cleanser, fragrance_free +
  // safe_grossesse + pack_SAFE rang 1, publié Headless). Le démaquillant
  // redevient conditionné à la réponse réelle Q7_10 (port de maquillage).
  // La fonction est conservée (3 appels) et renvoie une copie inchangée.
  function pdAlgoAnswers(a) {
    return Object.assign({}, a || {});
  }

  function fetchCatalogueFromStorefront() {
    const token = window.PARADERMIA_STOREFRONT_TOKEN;
    const shop = window.Shopify && window.Shopify.shop;
    if (!token || !shop) return Promise.reject(new Error('no storefront config'));

    const query = `
      query ($cursor: String) {
        products(first: 250, after: $cursor) {
          pageInfo { hasNextPage endCursor }
          edges { node {
            id handle title vendor tags availableForSale
            variants(first: 10) { edges { node { id title price { amount currencyCode } quantityAvailable } } }
            images(first: 1) { edges { node { url altText } } }
            metafield(namespace: "custom", key: "tiers") { value type }
          } }
        }
      }`;

    return new Promise((resolve, reject) => {
      const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      // Correction (demande Bilikiss) — timeout porté de 2s à 8s. Le catalogue
      // complet (250+ produits, paginé) dépassait régulièrement 2s sur la
      // preview / connexion mobile → fallback silencieux sur le catalogue
      // offline (prix figés à 0). 8s laisse le temps au fetch Storefront réel.
      const timer = setTimeout(() => { if (ctrl) ctrl.abort(); reject(new Error('timeout 8s')); }, 8000);

      const all = [];
      const fetchPage = (cursor) =>
        fetch(`https://${shop}/api/2024-01/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({ query, variables: { cursor } }),
          signal: ctrl ? ctrl.signal : undefined
        }).then(r => r.json());

      const step = (cursor) => fetchPage(cursor).then(data => {
        const edges = data && data.data && data.data.products && data.data.products.edges || [];
        edges.forEach(e => all.push(mapStorefrontProduct(e.node)));
        const pi = data.data.products.pageInfo;
        if (pi.hasNextPage) return step(pi.endCursor);
        clearTimeout(timer);
        resolve(all);
      });
      step(null).catch(err => { clearTimeout(timer); reject(err); });
    });
  }

  // V9.1 (consigne fondatrice 2026-08-28) — le quiz ne vend JAMAIS un format
  // découverte/mini/voyage : ces variantes sont exclues de la sélection du
  // bilan (prix, dispo, ajout panier). Elles restent achetables sur les
  // fiches produit. Si toutes les variantes sont des minis, on garde la liste
  // telle quelle (produit mono-format « voyage » assumé).
  const MINI_VARIANT_RE = /d[ée]couverte|mini\b|voyage|travel|[ée]chantillon|trial/i;
  function pdSellableVariants(variants) {
    const list = variants || [];
    const full = list.filter(v => !MINI_VARIANT_RE.test((v && v.title) || ''));
    return full.length ? full : list;
  }

  function mapStorefrontProduct(n) {
    const vNodes = (n.variants && n.variants.edges || []).map(e => e.node);
    const variant = pdSellableVariants(vNodes)[0];
    const qty = variant && typeof variant.quantityAvailable === 'number' ? variant.quantityAvailable : null;
    let pdId = null;
    (n.tags || []).forEach(t => { if (t.indexOf('PD-') === 0) pdId = t; });
    if (!pdId && n.handle) {
      const m = n.handle.match(/pd-\d+/i);
      if (m) pdId = m[0].toUpperCase();
    }
    let tiers = {};
    if (n.metafield && n.metafield.value) {
      try { tiers = JSON.parse(n.metafield.value); } catch (_) {}
    }
    return {
      id: pdId || n.id,
      handle: n.handle,
      brand: n.vendor,
      name: n.title,
      tags: n.tags || [],
      price: variant && variant.price && variant.price.amount,
      variantId: variant && variant.id,
      image: n.images && n.images.edges && n.images.edges[0] && n.images.edges[0].node && n.images.edges[0].node.url,
      available: !!n.availableForSale && (qty === null || qty > 0),
      tiers: tiers,
      step: (n.tags || []).find(t => t.indexOf('etape_') === 0 || t.indexOf('addon_') === 0) || null,
      level: (n.tags || []).find(t => t.indexOf('niveau_') === 0) || null,
      packs: (n.tags || []).filter(t => t.indexOf('pack_') === 0),
      familles_actif: (n.tags || []).filter(t => t.indexOf('famille_actif_') === 0),
      actifs: (n.tags || []).filter(t => t.indexOf('actif_') === 0),
      inci_safety: (n.tags || []).filter(t =>
        /^(fragrance_free|parfum_present|safe_grossesse|contre_indique_grossesse|contient_|INCI_)/i.test(t)),
      role: (n.tags || []).find(t => t.indexOf('role_') === 0) || null,
      usage: (n.tags || []).find(t => t.indexOf('usage_') === 0) || null,
      texture: (n.tags || []).find(t => t.indexOf('texture_') === 0) || null,
      type: (n.tags || []).indexOf('addon_complement') !== -1 ? 'complement' : 'topique'
    };
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(r => {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' on ' + url);
      return r.json();
    });
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  KLAVIYO
  // ────────────────────────────────────────────────────────────────────────────

  // Résumé e-mailable du protocole : duo héros + base (pré-cochés) puis
  // soins de confort et compléments, triés dans l'ordre d'application.
  function pdProtocolePayload(output, state) {
    const ORDER = ['etape_demaquillant', 'etape_nettoyant', 'etape_toner', 'etape_exfoliant', 'etape_serum', 'etape_hydratant', 'etape_zone_specifique', 'etape_spf', 'etape_corps'];
    const UTM = 'utm_source=klaviyo&utm_medium=email&utm_campaign=protocole_peau';
    const img = (u) => {
      if (!u) return '';
      let x = String(u); if (x.indexOf('//') === 0) x = 'https:' + x;
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(x)) x += (x.indexOf('?') === -1 ? '?' : '&') + 'width=240';
      return x;
    };
    const eur = (v) => (v == null || isNaN(v)) ? '' : (Number(v) > 999 ? Number(v) / 100 : Number(v)).toFixed(2).replace('.', ',') + ' €';
    const card = (p, role) => ({
      nom: p.name || '', marque: p.brand || '',
      etape: p.step === 'etape_corps' ? 'Soin corps' : stepDisplayName(p.step),
      role: role,
      url: 'https://paradermia.com/products/' + encodeURIComponent(p.handle || '') + '?' + UTM,
      image: img(p.image), prix: eur(p.price), variante: p.variantId ? String(p.variantId) : ''
    });
    const rank = (p) => { const i = ORDER.indexOf(p.step); return i === -1 ? 99 : i; };
    const g = computeDisplayGroups(output);
    const ordered = g.duo.concat(g.base).slice().sort((a, b) => rank(a) - rank(b));
    const heroIds = new Set(g.duo.map(p => p.id));
    const prof = output.profile || {};
    return {
      protocole_prenom: (state && state.firstName) || '',
      protocole_titre: prof.routine_name || prof.routine_short || '',
      protocole_descripteur: prof.routine_descriptor || '',
      protocole_niveau: output.tier_final || prof.niveau_label || '',
      protocole_routine: ordered.map(p => card(p, heroIds.has(p.id) ? 'hero' : 'essentiel')),
      protocole_confort: (g.confort || []).slice().sort((a, b) => rank(a) - rank(b)).map(p => card(p, 'confort')),
      protocole_complements: (output.block5_complements || []).filter(p => p && p.handle).slice(0, 3).map(p => card(Object.assign({}, p, { step: '' }), 'complement')),
      protocole_grossesse: !!(output._inputs && output._inputs.answers && (output._inputs.answers.Q2_6 === 'A' || output._inputs.answers.Q2_6 === 'B')),
      protocole_lien_bilan: 'https://paradermia.com/pages/quiz?' + UTM,
      protocole_panier: (function () {
        const ids = ordered.map(p => p.variantId).filter(Boolean);
        if (!ids.length) return '';
        return 'https://paradermia.com/cart/' + ids.map(id => id + ':1').join(',') +
          '?attributes[from_quiz_peau]=true&attributes[_pd_source]=email_protocole&' + UTM;
      })()
    };
  }

  function pushToKlaviyo(state, output) {
    try {
      window._learnq = window._learnq || [];
      const profile = Object.assign({}, output.klaviyo_properties);
      // Correction (demande Bilikiss) — précision texte libre du traitement
      // « Autre » (Q7_MEDICAMENTS option F). Non lu par l'algo, transmis à
      // Klaviyo pour le suivi par la pharmacienne.
      if (state.answers && state.answers.Q7_MEDICAMENTS_autre) {
        profile.medicaments_autre_detail = state.answers.Q7_MEDICAMENTS_autre;
      }
      if (state.email) {
        window._learnq.push(['identify', Object.assign({ $email: state.email, $first_name: state.firstName || undefined, quiz_peau_complete: true }, profile)]);
      }
      // E-mail « Votre protocole » (30/10/2026) : la routine affichée part
      // dans l'événement pour que Klaviyo l'envoie, dans l'ordre d'application.
      try {
        const ev = Object.assign({}, profile, pdProtocolePayload(output, state));
        window._learnq.push(['track', 'Quiz Peau Terminé', ev]);
      } catch (_p) {
        window._learnq.push(['track', 'Quiz Peau Terminé', profile]);
      }
    } catch (e) { /* silent */ }
  }

  // ════════════════════════════════════════════════════════════════════════
  //  ITEM 8 + 9 — CART INTEGRATION (lookup live /products/[handle].js)
  // ════════════════════════════════════════════════════════════════════════

  function showToast(message, opts) {
    opts = opts || {};
    const existing = document.querySelector('.pd-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    const toast = h('div', { class: 'pd-toast' + (opts.info ? ' pd-toast-info' : '') });
    if (typeof message === 'string') toast.appendChild(h('span', { html: message }));
    else toast.appendChild(message);
    document.body.appendChild(toast);
    setTimeout(() => {
      if (toast.parentNode) toast.classList.add('pd-fade-out');
      setTimeout(() => { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
    }, opts.duration || 4500);
  }

  // Cache des lookups variantId par handle (TTL session)
  const _variantCache = {};

  function lookupVariantId(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (_variantCache[handle]) return Promise.resolve(_variantCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(r => {
        if (!r.ok) throw new Error('handle introuvable');
        return r.json();
      })
      .then(p => {
        // V9.1 — jamais de format découverte/mini dans le panier du bilan.
        const sellable = pdSellableVariants(p.variants || []);
        const v = sellable.find(x => x.available !== false) || sellable[0];
        if (!v || !v.id) throw new Error('aucune variante disponible');
        const info = { variantId: v.id, price: v.price, productTitle: p.title };
        _variantCache[handle] = info;
        return info;
      });
  }

  // Fondation notice post-achat : attache les réponses du quiz en attribut de
  // commande (préfixe « _ » = masqué de l'UI panier, conservé sur la commande).
  // Permet de régénérer la notice personnalisée (ParaDermiaNotice) côté espace
  // membre / email APRÈS achat, sans rien exposer avant. Fire-and-forget.
  function persistQuizToCart() {
    try {
      var raw = localStorage.getItem(OUTPUT_KEY);
      if (!raw) return;
      var out = JSON.parse(raw);
      var ans = out && out._inputs && out._inputs.answers;
      if (!ans) return;
      var prof = out.profile || {};
      // V8 (demande Bilikiss) — Brique 2 : on attache le PROFIL RÉSOLU en attributs
      // de commande propres (un par champ), pour qu'un Shopify Flow puisse les
      // recopier 1:1 dans customer.metafields.paradermia.* (active la carte /
      // profil du dashboard + base des points). _pd_quiz_answers reste pour la notice.
      var actifs = [];
      (out.block2_products || []).forEach(function (p) {
        (p.actifs_display || []).forEach(function (a) { if (actifs.indexOf(a) === -1) actifs.push(a); });
      });
      var dateStr = '';
      try {
        var ts = out._meta && out._meta.completedAt;
        var d = ts ? new Date(ts) : new Date();
        dateStr = ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
      } catch (_e) {}
      var attrs = {
        _pd_quiz_answers: JSON.stringify(ans),
        from_quiz_peau: 'true',
        _pd_profil_peau: prof.routine_descriptor || prof.routine_name || prof.routine_short || '',
        _pd_routine: prof.routine_short || prof.routine_name || '',
        _pd_niveau: out.niveau_label || prof.niveau_label || '',
        _pd_actif_1: actifs[0] || '',
        _pd_actif_2: actifs[1] || '',
        _pd_date: dateStr
      };
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (_) {}
  }

  function addItemsToCart(items) {
    // items: [{ id: variantId, quantity: 1 }, ...]
    persistQuizToCart(); // attache les réponses à la commande (fondation notice post-achat)
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(r => {
      if (!r.ok) return r.json().then(j => { throw new Error(j.description || j.message || 'cart error'); });
      return r.json();
    });
  }

  function handleAddSingle(handle, productLabel) {
    if (!handle) {
      showToast('Ce produit sera disponible prochainement.', { info: true });
      return;
    }
    lookupVariantId(handle).then(info => {
      return addItemsToCart([{ id: info.variantId, quantity: 1 }]);
    }).then(() => {
      const msg = h('span', {}, [
        document.createTextNode((productLabel || 'Produit') + ' ajouté au panier ✓ '),
        h('a', { href: '/cart' }, 'Voir mon panier →')
      ]);
      showToast(msg);
    }).catch(() => {
      showToast('Ce produit sera disponible prochainement.', { info: true });
    });
  }

  function handleAddProtocol(items, packName) {
    // items: [{ handle, quantity, label }]
    if (!items.length) {
      showToast('Sélectionnez au moins un produit.', { info: true });
      return;
    }
    const lookups = items.map(it => lookupVariantId(it.handle)
      .then(info => ({ id: info.variantId, quantity: it.quantity || 1 }))
      .catch(() => null));
    Promise.all(lookups).then(results => {
      const ok = results.filter(Boolean);
      if (!ok.length) {
        showToast('Aucun produit n\'a pu être ajouté pour le moment.', { info: true });
        return;
      }
      addItemsToCart(ok).then(() => {
        const msg = h('span', {}, [
          document.createTextNode('Protocole ' + (packName || '') + ' ajouté au panier ✓ '),
          h('a', { href: '/cart' }, 'Voir mon panier →')
        ]);
        showToast(msg);
      }).catch(() => {
        showToast('Ajout au panier impossible — réessayez dans un instant.', { info: true });
      });
    });
  }

  // ════════════════════════════════════════════════════════════════════════
  //  SPRINT1-STICKY-CTA — Bandeau bottom-fixed mobile
  //  Slide-up après scroll past .pd-block-1 hero. Auto-hide quand
  //  .pd-block-checkout visible. Desktop ≥768px masqué via CSS.
  //  Cleanup propre via _stickyCtaCleanup si re-render.
  // ════════════════════════════════════════════════════════════════════════

  let _stickyCtaCleanup = null;
  let _stickyCtaUpdate = null;

  function mountStickyCTA(output) {
    if (_stickyCtaCleanup) _stickyCtaCleanup();

    const routineShort = (output && output.profile && output.profile.routine_short) || '';
    if (!routineShort) return;

    const sticky = h('div', { class: 'pd-sticky-cta', id: 'pd-sticky-cta', 'aria-hidden': 'true' });
    const info = h('div', { class: 'pd-sticky-cta-info' });
    info.appendChild(h('span', {
      class: 'pd-sticky-cta-pack',
      html: 'Routine <em>' + escapeHtml(routineShort) + '</em>'
    }));
    const countEl = h('span', { class: 'pd-sticky-cta-count' }, '');
    info.appendChild(countEl);
    // V7 FIX sticky CTA prix — Élément prix dynamique en plus du compteur.
    // Affiche le total des produits sélectionnés en € quand tous les prix sont
    // disponibles (post fetchPricesForResults), fallback "Calculé au panier".
    const priceEl = h('span', { class: 'pd-sticky-cta-price' }, '');
    const btn = h('button', { class: 'pd-sticky-cta-btn', type: 'button' }, 'Ajouter →');
    // V8 (demande Bilikiss) — Layout : produit (info) à GAUCHE, prix + bouton à
    // DROITE. Le prix n'est plus dans le bloc info ; info a flex:1 et pousse le
    // prix + le bouton vers la droite.
    sticky.appendChild(info);
    sticky.appendChild(priceEl);
    sticky.appendChild(btn);
    document.body.appendChild(sticky);

    // V7 FIX sticky CTA prix — Update combiné count + prix. Réutilise la même
    // logique que r6UpdateTotal mais sur le DOM du sticky CTA pour éviter une
    // duplication de logique de pricing. Appelée à chaque toggle CTA delegué.
    const updateCount = () => {
      const ids = Array.from(_r2Selection.added);
      const n = ids.length;
      countEl.textContent = n + ' produit' + (n > 1 ? 's' : '');
      // Calcul prix total uniquement si tous les sélectionnés ont leur prix
      let total = 0;
      let hasAllPrices = n > 0;
      ids.forEach(id => {
        const item = _r4ProductLookup.get(id);
        const p = item && item.price;
        if (typeof p === 'number' && p > 0) total += p;
        else hasAllPrices = false;
      });
      if (hasAllPrices && total > 0) {
        priceEl.textContent = total.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €';
      } else if (n > 0) {
        priceEl.textContent = 'calculé au panier';
      } else {
        priceEl.textContent = '';
      }
    };
    updateCount();
    // V7 FIX — Expose la fonction au scope module pour que applyPricesPatch
    // puisse la déclencher après le fetch des prix (sinon le sticky CTA reste
    // sur "calculé au panier" jusqu'au prochain click).
    _stickyCtaUpdate = updateCount;

    // Hook delegated click sur .pd-add-button → update count après handler natif
    const onClick = (e) => {
      if (e.target.closest && e.target.closest('.pd-add-button')) {
        setTimeout(updateCount, 0);
      }
    };
    document.addEventListener('click', onClick);

    // Click sticky-btn → scroll smooth vers CTA final
    btn.addEventListener('click', () => {
      const checkout = document.querySelector('.pd-block-checkout');
      if (checkout) checkout.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // IntersectionObservers : hero out + checkout visible
    let heroOut = false, checkoutVisible = false;
    const sync = () => {
      const visible = heroOut && !checkoutVisible;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    const hero = document.querySelector('.pd-block-1');
    const checkout = document.querySelector('.pd-block-checkout');
    const obsHero = hero ? new IntersectionObserver((entries) => {
      heroOut = !entries[0].isIntersecting;
      sync();
    }, { threshold: 0 }) : null;
    if (obsHero) obsHero.observe(hero);
    const obsCheckout = checkout ? new IntersectionObserver((entries) => {
      checkoutVisible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.3 }) : null;
    if (obsCheckout) obsCheckout.observe(checkout);

    _stickyCtaCleanup = () => {
      document.removeEventListener('click', onClick);
      if (obsHero) obsHero.disconnect();
      if (obsCheckout) obsCheckout.disconnect();
      if (sticky.parentNode) sticky.parentNode.removeChild(sticky);
      _stickyCtaCleanup = null;
      _stickyCtaUpdate = null;
    };
  }

  // ════════════════════════════════════════════════════════════════════════
  //  RESULTS RENDERER (page /pages/quiz-results)
  // ════════════════════════════════════════════════════════════════════════

  function renderResults(root) {
    // V3.20 — Restitue la nav Dawn dès l'affichage des résultats.
    showNav();
    // Correction UI (demande Bilikiss) — la page résultats possède déjà ses
    // propres blocs réassurance + contact pharmacienne + mention légale. Le
    // footer Dawn natif fait doublon en bas de page : on le re-masque APRÈS
    // showNav() (qui force display:block dessus via V3.30e). On ne touche que
    // les sélecteurs footer Dawn (tag <footer> + classes/ids Dawn), jamais le
    // <div class="pd-footer"> interne du quiz.
    [
      '.site-footer', '.section-footer', 'footer', 'footer[role="contentinfo"]',
      '#shopify-section-footer', '[id^="shopify-section-"][id*="footer"]'
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });
    setQuizBgDark(false);
    let output;
    try { output = JSON.parse(localStorage.getItem(OUTPUT_KEY) || 'null'); } catch (_) {}
    if (!output) {
      root.innerHTML = '<div class="pd-empty">Aucune analyse trouvée. <a href="/pages/quiz">Commencer mon analyse de peau</a></div>';
      return;
    }

    // Item 6 — applique la classe pack pour activer --pack-bg / --pack-accent
    const packKey = (output.profile && output.profile.primary_pack) || 'pack_LIFT';
    const packClass = PACK_CSS_CLASS[packKey] || 'pd-pack-LIFT';
    // Reset toutes les classes pack précédentes
    Object.values(PACK_CSS_CLASS).forEach(c => root.classList.remove(c));
    root.classList.add(packClass);

    root.innerHTML = '';
    root.appendChild(block1_profil(output));

    // V8 (demande Bilikiss) — CTA « Passer au niveau Premium » si Premium était
    // recommandé mais pas retenu (régénère le protocole en Premium sur place).
    const premiumCta = block_premium_upgrade(output, root);
    if (premiumCta) root.appendChild(premiumCta);

    // V3.35 SPRINT1-STICKY-CTA — Bandeau bottom-fixed mobile (auto-hide selon scroll)
    mountStickyCTA(output);

    // V6 SPRINT2 — 3 bandes structurées sous le hero (pattern card homepage)
    // Container .pd-bands hérite max-width 720px + gap 16px du CSS V6.
    const bands = h('div', { class: 'pd-bands' });

    // 1. Réussir votre routine — méthodologie universelle, accordéon fermé
    bands.appendChild(block_solution(output));

    // 2. Pourquoi cette routine pour vous ? — profil + actifs spécifiques
    const whyRoutine = block_why_routine(output);
    if (whyRoutine) bands.appendChild(whyRoutine);

    // 3. Vigilances — alertes sécurité (point unique, visible si présentes)
    const vigilances = block_vigilances(output);
    if (vigilances) bands.appendChild(vigilances);

    root.appendChild(bands);

    // V7 SPRINT2 — Bloc produits protocole (étapes 01-04 + 05 si STRETCH)
    root.appendChild(block2_products(output));

    // V9 DUO — STRETCH : les soins corps sont désormais les héros du duo
    // (cf computeDisplayGroups), les suivants rejoignent le groupe confort.
    // L'ancien appel blockBody était mort : blockBody se gate lui-même sur
    // pack_STRETCH alors que renderResults ne l'appendait QUE pour STRETCH —
    // les produits corps du pack vergetures n'étaient donc jamais affichés.
    const activePack = (output.profile && output.profile.primary_pack) || '';
    const isStretch = activePack === 'pack_STRETCH';

    // V7 — Carte Notice pharmacien standalone (clôt le pack routine)
    root.appendChild(block_notice_card());

    // V7.2 — Bandeau "Un Protocole Cohérent" déplacé dans block_recap
    // (accordéon en tête de "Votre protocole complet"). Position contextuelle :
    // l'utilisatrice voit la pédagogie pack au moment de la décision d'achat.

    // V7 — Compléments alimentaires
    if (output.block5_complements && output.block5_complements.length) {
      root.appendChild(block5_complements(output));
    }

    // V7 — Upsell corps : visible pour packs visage uniquement (pour STRETCH
    // le corps est déjà couvert par étape 05 / blockBody plus haut).
    // Pour STRETCH on pourrait afficher un upsell "soins ponctuels" plus tard
    // (masques, contour yeux) — pour l'instant le block reste désactivé.
    if (!isStretch) {
      const upsellEl = block_upsell_corps(output);
      if (upsellEl) root.appendChild(upsellEl);
    }

    // V3.10 R4 — Récap protocole (après R2 produits + R3 compléments + R5 corps
    // pour avoir _r2Selection complet ; live update via r4UpdateSelected).
    root.appendChild(block_recap(output));

    // V3.12 R6 — Checkout block (remplace blockCartSelector). V3.13 inclut
    // désormais la mention légale en dessous de la réassurance.
    root.appendChild(block_checkout(output));

    // V7 FIX retinoid_protocol — Rendu standalone supprimé.
    // Le protocole rétinoïde est désormais intégré dans block_vigilances comme
    // un item de type 'retinoid' (cf. block_vigilances ci-dessus). Centralise
    // toutes les vigilances cliniques dans le même accordéon, plus de note
    // orpheline en bas de page que l'utilisatrice ne pouvait pas relier au
    // reste des alertes.
    // V3.13 — blockCtaFinal supprimé (doublon avec block_checkout R6).
    // V3.13 — blockMentionLegale supprimé (mention légale déplacée dans
    // block_checkout sous la réassurance).
  }

  // ─── BLOCK 1 — Hero V6 (Sprint 2) ─────────────────────────────────────
  // Carte ivoire "ordonnance" : meta header (brand + référence/date) →
  // greeting → titre 2 lignes (pré-titre Playfair + nom pack italic accent) →
  // descripteur + niveau inline → filigrane gold ✦ → 3 stats hairlines.
  function block1_profil(o) {
    const p = o.profile || {};
    const prettyPhoto = (s) => ({
      phototype_I_II: 'I–II',
      phototype_III: 'III',
      phototype_IV_V_VI: 'IV–VI'
    }[s] || s || '—');

    const primaryPack = p.primary_pack || 'pack_LIFT';
    const packShort = primaryPack.replace('pack_', '');
    const packDescriptor = (ROUTINE_DISPLAY_UI[primaryPack] || {}).descriptor || '';
    const levelLabel = p.niveau_label || '';

    // Pré-titre dynamique selon parcours (skipped7 = parcours court)
    const titlePre = (o._inputs && o._inputs.skipped7)
      ? 'Votre routine de base'
      : 'Votre routine personnalisée';

    // Stats avec fallbacks
    const phototype = prettyPhoto(p.phototype) || '—';
    const barriere = barriereLabel(o) || '—';
    const toleranceValue = toleranceLabel(p.tolerance);

    // Greeting conditionnel
    const firstName = (o._meta && o._meta.firstName && o._meta.firstName.trim())
      ? o._meta.firstName.trim()
      : null;

    // Référence "N° 01 — date" — date = completedAt (snapshot, pas date du jour).
    // Counter per-person : pour la 1ère analyse hors espace membre, "01".
    // À brancher sur metafield Shopify customer.custom.analysis_count quand membre logué.
    const completedAtMs = (o._meta && o._meta.completedAt) ? o._meta.completedAt : Date.now();
    const dateStr = formatAnalysisDate(completedAtMs);
    const refNum = '01';

    const wrap = h('section', { class: 'pd-block pd-block-1' });
    const hero = h('article', { class: 'pd-rh' });

    // Méta header
    const meta = h('header', { class: 'pd-rh-meta' });
    meta.appendChild(h('span', { class: 'pd-rh-meta-brand' }, 'Analyse de peau Paradermia'));
    const serial = h('span', { class: 'pd-rh-meta-serial' });
    serial.appendChild(h('span', { class: 'pd-rh-meta-serial-num' }, 'N° ' + refNum));
    serial.appendChild(h('span', { class: 'pd-rh-meta-serial-sep' }, '—'));
    serial.appendChild(document.createTextNode(dateStr));
    meta.appendChild(serial);
    hero.appendChild(meta);

    // Greeting
    if (firstName) {
      hero.appendChild(h('p', { class: 'pd-rh-greeting' }, 'Pour ' + firstName + ','));
    }

    // Titre 2 lignes
    const titleWrap = h('h1', { class: 'pd-rh-title' });
    titleWrap.appendChild(h('span', { class: 'pd-rh-title-pre' }, titlePre));
    titleWrap.appendChild(h('span', { class: 'pd-rh-title-em' }, capitalize(packShort.toLowerCase()) + '.'));
    hero.appendChild(titleWrap);

    // Descripteur — "Peau {type} · Protocole {descriptor} · niveau <strong>{level}</strong>."
    // V9 DUO — le type de peau ouvre la phrase : diagnostic complet en une ligne.
    const skinTypeLabel = ({
      profil_peau_grasse: 'grasse', profil_peau_mixte: 'mixte',
      profil_peau_seche: 'sèche', profil_peau_normale: 'normale'
    })[p.skin_type] || null;
    const descriptorEl = h('p', { class: 'pd-rh-descriptor' });
    if (skinTypeLabel) {
      descriptorEl.appendChild(document.createTextNode('Peau ' + skinTypeLabel + ' · '));
    }
    if (packDescriptor) {
      descriptorEl.appendChild(document.createTextNode('Protocole ' + packDescriptor + ' · niveau '));
    } else {
      descriptorEl.appendChild(document.createTextNode('Niveau '));
    }
    descriptorEl.appendChild(h('strong', {}, levelLabel));
    descriptorEl.appendChild(document.createTextNode('.'));
    hero.appendChild(descriptorEl);

    // V6.4 — filigrane ✦ retiré (rendu plus pur, hairline divider suffit via CSS)
    // Stats
    const stats = h('div', { class: 'pd-rh-stats' });
    stats.appendChild(makeRhStat('Phototype', phototype));
    stats.appendChild(makeRhStat('Barrière', barriere));
    stats.appendChild(makeRhStat('Tolérance', toleranceValue, toleranceValue === 'Non renseignée' || toleranceValue === '—'));
    hero.appendChild(stats);

    wrap.appendChild(hero);
    return wrap;
  }

  function makeRhStat(label, value, isEmpty) {
    const item = h('div', { class: 'pd-rh-stat' });
    item.appendChild(h('span', { class: 'pd-rh-stat-label' }, label));
    const display = (isEmpty && (value === 'Non renseignée' || !value)) ? '—' : value;
    item.appendChild(h('span', {
      class: 'pd-rh-stat-value' + (isEmpty ? ' is-empty' : '')
    }, display));
    return item;
  }

  function formatAnalysisDate(ms) {
    try {
      const d = new Date(ms);
      const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    } catch (_) { return ''; }
  }

  function capitalize(s) {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function toleranceLabel(t) {
    return { A: 'Réactive', B: 'Sensible', C: 'Tolérante', D: 'Tolérante' }[t] || 'Non renseignée';
  }
  function barriereLabel(o) {
    // Déduit de Q2_2 dans inputs (si présent)
    const ans = o._inputs && o._inputs.answers;
    if (!ans) return '—';
    return { A: 'Fragile', B: 'Sensible', C: 'Stable', D: 'Réactive' }[ans.Q2_2] || '—';
  }

  // ─── V3.8 R2 — Produits par catégorie + toggle Matin/Soir + CTA roles ──
  // Mapping étape → catégorie : ordre fixe d'affichage des sections.
  const R2_CATEGORY_ORDER = [
    'etape_demaquillant', 'etape_nettoyant', 'etape_exfoliant', 'etape_toner',
    'etape_serum', 'etape_hydratant', 'etape_spf'
  ];
  const R2_CATEGORY_INFO = {
    etape_demaquillant: { label: 'Démaquillant', color: '#C9A84C' },
    etape_nettoyant:    { label: 'Nettoyant',    color: '#5A9E3A' },
    etape_exfoliant:    { label: 'Exfoliant',    color: '#C4845A' },
    etape_toner:        { label: 'Toner',        color: '#5B8FA8' },
    etape_serum:        { label: 'Sérum',        color: '#8A6BB0' },
    etape_hydratant:    { label: 'Hydratant',    color: '#4A9A7E' },
    etape_spf:          { label: 'SPF',          color: '#C4A020' },
    // V9 DUO — étapes auparavant absentes de l'affichage (les cartes traitement
    // et contour des yeux sortaient de l'algo mais n'étaient jamais rendues).
    etape_traitement:      { label: 'Traitement ciblé', color: '#7A4030' },
    etape_zone_specifique: { label: 'Contour des yeux', color: '#8A6BB0' },
    etape_corps:           { label: 'Soin corps',       color: '#d4809a' },
    etape_complement:      { label: 'Complément',       color: '#2D6A3F' }
  };

  // ═══ V9 DUO SIGNATURE — curation des 2 héros par pack ═══════════════════
  // Règle déterministe : pour chaque pack, liste ordonnée des étapes
  // « signature » ; le duo = les 2 premières étapes présentes dans
  // block2_products. Aucun ID produit codé en dur : la curation survit aux
  // changements de catalogue (le produit tier-1 de l'étape reste le héros).
  // Justification clinique par pack :
  //  CLEAR   sérum actif + traitement ciblé (paire jour/soir anti-imperfections)
  //  EVEN    sérum anti-taches + SPF (dépigmentant sans photoprotection = échec)
  //  LIFT    sérum anti-âge + crème fondamentale
  //  GLOW    sérum vitamine C + exfoliant (éclat = actif + renouvellement)
  //  CALM    sérum apaisant + crème barrière
  //  REPAIR  sérum réparateur + crème réparatrice (la crème EST le traitement)
  //  SAFE    sérum toléré grossesse + crème
  //  STRETCH les héros sont les soins corps (traités à part dans computeDisplayGroups)
  const PACK_HERO_STEPS = {
    pack_CLEAR:   ['etape_serum', 'etape_traitement', 'etape_nettoyant', 'etape_hydratant'],
    pack_EVEN:    ['etape_serum', 'etape_spf', 'etape_traitement', 'etape_hydratant'],
    pack_LIFT:    ['etape_serum', 'etape_hydratant', 'etape_traitement'],
    pack_GLOW:    ['etape_serum', 'etape_exfoliant', 'etape_hydratant'],
    pack_CALM:    ['etape_serum', 'etape_hydratant', 'etape_traitement'],
    pack_REPAIR:  ['etape_serum', 'etape_hydratant', 'etape_traitement'],
    pack_SAFE:    ['etape_serum', 'etape_hydratant'],
    pack_STRETCH: ['etape_traitement', 'etape_hydratant', 'etape_serum']
  };
  // Étapes « base » : indispensables de toute routine (socle incompressible).
  const PD_BASE_STEPS = ['etape_demaquillant', 'etape_nettoyant', 'etape_hydratant', 'etape_spf'];

  // Rôle d'affichage par produit (id → 'hero' | 'essentiel' | 'optionnel').
  // Rempli par computeDisplayGroups à chaque rendu ; consulté par les cartes,
  // le récap (force-add des essentiels) et les états initiaux du panier.
  const _pdDisplayRole = new Map();

  // Regroupe block2_products en { duo, base, confort } selon le pack.
  //  duo     = 2 héros mis en avant (pré-cochés)
  //  base    = nettoyant / démaquillant / hydratant / SPF hors duo (pré-cochés,
  //            le SPF ne se lâche jamais)
  //  confort = toner / exfoliant / traitement / contour hors duo (repliés,
  //            non cochés par défaut)
  // STRETCH : les soins corps (body_products) deviennent les héros ; les
  // suivants éventuels rejoignent le groupe confort avec le label Soin corps.
  function computeDisplayGroups(o) {
    _pdDisplayRole.clear();
    const pack = (o.profile && o.profile.primary_pack) || '';
    const prods = o.block2_products || [];
    const byStep = {};
    prods.forEach(p => { if (!byStep[p.step]) byStep[p.step] = p; });

    const duo = [];
    const confortExtra = [];
    if (pack === 'pack_STRETCH') {
      const body = (o.body_products || []).filter(b => b && b.id);
      body.forEach((b, i) => {
        const item = Object.assign({}, b, { step: 'etape_corps' });
        if (i < 2) duo.push(item); else confortExtra.push(item);
      });
    }
    const prefs = PACK_HERO_STEPS[pack] || ['etape_serum', 'etape_hydratant'];
    for (const st of prefs) {
      if (duo.length >= 2) break;
      if (byStep[st]) duo.push(byStep[st]);
    }
    // Filet : routine minimaliste (ex. régularité occasionnelle) — compléter
    // avec les premières étapes disponibles pour toujours montrer un duo.
    if (duo.length < 2) {
      for (const p of prods) {
        if (duo.length >= 2) break;
        if (duo.indexOf(p) === -1) duo.push(p);
      }
    }
    const duoIds = new Set(duo.map(p => p.id));
    const base = prods.filter(p => !duoIds.has(p.id) && PD_BASE_STEPS.indexOf(p.step) !== -1);
    const confort = prods.filter(p => !duoIds.has(p.id) && PD_BASE_STEPS.indexOf(p.step) === -1)
      .concat(confortExtra);

    duo.forEach(p => _pdDisplayRole.set(p.id, 'hero'));
    base.forEach(p => _pdDisplayRole.set(p.id, 'essentiel'));
    confort.forEach(p => _pdDisplayRole.set(p.id, 'optionnel'));
    return { duo: duo, base: base, confort: confort };
  }

  // État local de sélection R2 (lookup id → in-routine boolean).
  // À connecter en R4/R6 pour le récap et le total panier.
  const _r2Selection = { added: new Set(), state: new Map() };

  function r2DeriveMoment(productId, output) {
    const morningIds = (output.block3_routine && output.block3_routine.morning || [])
      .map(s => s.product && s.product.id).filter(Boolean);
    const eveningIds = (output.block3_routine && output.block3_routine.evening || [])
      .map(s => s.product && s.product.id).filter(Boolean);
    const inMorning = morningIds.indexOf(productId) !== -1;
    const inEvening = eveningIds.indexOf(productId) !== -1;
    if (inMorning && inEvening) return 'both';
    if (inMorning) return 'matin';
    if (inEvening) return 'soir';
    return 'both';
  }

  function r2DeriveRoleClass(role) {
    // V9 DUO — accepte aussi les rôles « nus » des compléments
    // ('essentiel'/'recommande'/'optionnel') en plus des tags catalogue role_*.
    if (role === 'role_essentiel' || role === 'role_obligatoire' || role === 'essentiel') return 'essentiel';
    if (role === 'role_selon_profil' || role === 'recommande') return 'recommande';
    return 'optionnel';
  }

  // V9 DUO — rôle d'affichage unifié : la curation Duo/Base/Confort prime sur
  // les tags catalogue role_* (incohérents entre étapes — ex. toner tagué
  // role_essentiel). Fallback sur l'ancien mapping pour les produits hors
  // curation (compléments, upsell corps).
  function pdRoleFor(product) {
    return _pdDisplayRole.get(product.id) || r2DeriveRoleClass(product.role);
  }

  function r2CtaText(role, state) {
    // V3.34f UX2 — Retrait libre débloqué sur TOUS les rôles (client libre).
    // Plus de state 'is-locked'. Un essentiel démarre coché mais reste
    // décochable — juste avec badge visuel « Essentiel ».
    if (state === 'is-added')       return '✓ Ajouté';
    if (state === 'is-recommended') return '+ Ajouter';
    if (state === 'is-optional')    return '+ Ajouter';
    return '+ Ajouter';
  }

  function r2InitialState(role) {
    // V9 DUO — héros + essentiels démarrent ajoutés ; recommandé (complément
    // mis en avant) aussi ; confort replié démarre non coché : tout ce qui est
    // compté dans le total doit être visible d'un coup d'œil.
    if (role === 'hero')       return 'is-added';
    if (role === 'essentiel')  return 'is-added';
    if (role === 'recommande') return 'is-added';
    return 'is-optional';
  }

  function r2NextState(role, current) {
    // V3.34f UX2 — Toggle simple pour tous les rôles (retrait libre).
    // L'essentiel garde son badge visuel mais n'est plus verrouillé.
    if (role === 'hero' || role === 'essentiel' || role === 'recommande') {
      return current === 'is-added' ? 'is-recommended' : 'is-added';
    }
    return current === 'is-optional' ? 'is-added' : 'is-optional';
  }

  // V7 SPRINT2 — Carte produit horizontale (image gauche + content droite)
  // Pattern card homepage avec radius 16, hover #EFF5E8, pills V6, status check
  // pour Essentiel, accordéon "Pourquoi pour vous" pré-câblé (copy injectée
  // depuis WHY_PRODUCT_FOR_YOU table — placeholder si absente).
  function r2BuildProductCard(product, output, opts) {
    opts = opts || {};
    const moment = r2DeriveMoment(product.id, output);
    // V9 DUO — rôle d'affichage : override explicite > curation Duo/Base/Confort
    // > tags catalogue.
    const roleClass = opts.role || pdRoleFor(product);
    const isHero = roleClass === 'hero';
    const isEssential = roleClass === 'essentiel' || isHero;
    const initialCtaState = opts.initialState || r2InitialState(roleClass);

    // Track in selection state.
    _r2Selection.state.set(product.id, initialCtaState);
    if (initialCtaState === 'is-locked' || initialCtaState === 'is-added') {
      _r2Selection.added.add(product.id);
    }

    const card = h('article', {
      class: 'pd-prod-v7' + (isEssential ? ' is-essential' : '') +
        (isHero ? ' pd-prod-v7--hero' : '') +
        (opts.compact ? ' pd-prod-v7--compact' : ''),
      'data-product-id': product.id,
      'data-product-step': product.step,
      'data-product-role': roleClass,
      'data-moment': moment
    });

    const row = h('div', { class: 'pd-prod-v7-row' });

    // V7.7 — Image et nom cliquables → page produit Shopify si handle dispo.
    // target="_blank" pour préserver l'état du quiz/cart en cours.
    const productHref = product.handle ? '/products/' + product.handle : null;

    // Image gauche
    const imgZone = productHref
      ? h('a', {
          class: 'pd-prod-v7-image pd-prod-v7-image-link',
          href: productHref,
          target: '_blank',
          rel: 'noopener',
          'aria-label': 'Voir ' + (product.name || 'le produit')
        })
      : h('div', { class: 'pd-prod-v7-image' });
    if (product.image_url || product.image) {
      imgZone.appendChild(h('img', {
        src: product.image_url || product.image,
        alt: product.name || '',
        loading: 'lazy'
      }));
    } else {
      imgZone.appendChild(h('span', { html: SVG.bottle }));
    }
    if (productHref) {
      imgZone.addEventListener('click', (e) => e.stopPropagation());
    }
    row.appendChild(imgZone);

    // Content droite
    const content = h('div', { class: 'pd-prod-v7-content' });
    if (product.brand) {
      content.appendChild(h('div', { class: 'pd-prod-v7-eyebrow' }, product.brand));
    }
    if (productHref) {
      const nameLink = h('a', {
        class: 'pd-prod-v7-name pd-prod-v7-name-link',
        href: productHref,
        target: '_blank',
        rel: 'noopener'
      }, product.name || '');
      nameLink.addEventListener('click', (e) => e.stopPropagation());
      content.appendChild(h('h3', { class: 'pd-prod-v7-name-wrap' }, [nameLink]));
    } else {
      content.appendChild(h('h3', { class: 'pd-prod-v7-name' }, product.name || ''));
    }
    if (Array.isArray(product.actifs_display) && product.actifs_display.length) {
      content.appendChild(h('p', { class: 'pd-prod-v7-desc' },
        product.actifs_display.slice(0, 2).join(' · ')));
    }

    // Pills row : étape + tier + moment + (OBLIGATOIRE si SPF + phototype IV-V-VI)
    const pills = h('div', { class: 'pd-prod-v7-pills' });
    // V9 DUO — pill étape en tête : les sections numérotées par étape ont
    // disparu, chaque carte porte donc son étape (Nettoyant, Sérum…).
    const stepInfo = R2_CATEGORY_INFO[product.step];
    if (stepInfo) {
      pills.appendChild(h('span', {
        class: 'pd-prod-v7-pill pd-prod-v7-pill--step'
      }, stepInfo.label));
    }
    const tierLabels = { hero: 'Duo signature', essentiel: 'Essentiel', recommande: 'Recommandé', optionnel: 'Confort' };
    const tierPillClass = roleClass === 'hero' ? 'hero'
      : (roleClass === 'optionnel' ? 'confort' : roleClass);
    pills.appendChild(h('span', {
      class: 'pd-prod-v7-pill pd-prod-v7-pill--' + tierPillClass
    }, tierLabels[roleClass] || ''));
    // V9 DUO — icône dans un span dédié : le CSS ≤480px passe la pill en
    // font-size:0 et n'affiche que .pd-prod-v7-pill-icon (avant ce fix la
    // pill devenait une bulle vide sur mobile, l'icône n'existait pas).
    const momentIcon = { matin: '☼', soir: '☽', both: '☼☽' }[moment];
    const momentText = { matin: 'Matin', soir: 'Soir', both: 'Matin / Soir' }[moment];
    const momentPill = h('span', { class: 'pd-prod-v7-pill pd-prod-v7-pill--moment' });
    momentPill.appendChild(h('span', { class: 'pd-prod-v7-pill-icon' }, momentIcon));
    momentPill.appendChild(document.createTextNode(' ' + momentText));
    pills.appendChild(momentPill);
    // SPF OBLIGATOIRE si phototype IV-V-VI
    if (product.step === 'etape_spf' && output.profile && output.profile.phototype === 'phototype_IV_V_VI') {
      pills.appendChild(h('span', {
        class: 'pd-prod-v7-pill pd-prod-v7-pill--obligatoire'
      }, 'Obligatoire'));
    }
    content.appendChild(pills);

    // V9 DUO — frequency_hint (slot traitement) : consigne d'usage jamais
    // affichée jusqu'ici alors que l'algo la fournit (« 2 à 3 fois par
    // semaine, en alternance avec votre sérum »).
    if (product.frequency_hint) {
      content.appendChild(h('p', { class: 'pd-prod-v7-freq' }, product.frequency_hint));
    }

    // Bottom row : pourquoi-toggle + spacer + price + status/CTA
    const bottom = h('div', { class: 'pd-prod-v7-bottom' });

    const whyToggle = h('button', {
      class: 'pd-prod-v7-why', type: 'button', 'aria-expanded': 'false'
    });
    whyToggle.appendChild(h('span', { class: 'pd-prod-v7-why-chevron' }, '▾'));
    whyToggle.appendChild(document.createTextNode(' Pourquoi pour vous'));
    whyToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const opened = card.classList.toggle('is-why-open');
      whyToggle.setAttribute('aria-expanded', opened ? 'true' : 'false');
    });
    bottom.appendChild(whyToggle);
    bottom.appendChild(h('span', { class: 'pd-prod-v7-spacer' }));

    if (typeof product.price !== 'undefined' && product.price !== null && product.price !== '') {
      bottom.appendChild(h('span', { class: 'pd-prod-v7-price' },
        formatPrice(product.price)));
    }

    // V3.34f UX2 — Retrait débloqué : plus de "Inclus" fixe. CTA cliquable
    // pour tous rôles, y compris essentiels (client libre d'enlever).
    const cta = h('button', {
      class: 'pd-prod-v7-cta ' + initialCtaState,
      type: 'button',
      'data-role': roleClass,
      'data-product-id': product.id
    }, r2CtaText(roleClass, initialCtaState));
    cta.addEventListener('click', (e) => {
      e.stopPropagation();
      r2HandleCtaClick(cta, roleClass, product.id);
    });
    bottom.appendChild(cta);
    content.appendChild(bottom);
    row.appendChild(content);
    card.appendChild(row);

    // Why-pour-vous accordion body — copy depuis WHY_PRODUCT_FOR_YOU table
    // (placeholder en attendant la livraison dermato).
    const whyText = resolveWhyForYou(product, output);
    const whyBody = h('div', { class: 'pd-prod-v7-why-body' });
    const whyInner = h('div', { class: 'pd-prod-v7-why-inner', html: whyText });
    whyBody.appendChild(whyInner);
    card.appendChild(whyBody);

    return card;
  }

  // Format prix : "14,90 €" depuis nombre ou string
  function formatPrice(p) {
    if (typeof p === 'string') return p;
    if (typeof p === 'number') {
      return p.toFixed(2).replace('.', ',') + ' €';
    }
    return '';
  }

  // V7 — Table "Pourquoi pour vous" par produit (à enrichir avec dermato).
  // Format: WHY_PRODUCT_FOR_YOU[productId] = { variants: [{when, text}], default: '...' }
  // when conditions sont évaluées sur output.profile + output._inputs.answers.
  // Première variante qui matche gagne, sinon default. Si pas d'entrée du tout,
  // placeholder "Détails personnalisés bientôt disponibles".
  const WHY_PRODUCT_FOR_YOU = {};

  function resolveWhyForYou(product, output) {
    const entry = WHY_PRODUCT_FOR_YOU[product.id] || WHY_PRODUCT_FOR_YOU[product.handle];
    if (!entry) {
      return '<em>Détails personnalisés bientôt disponibles.</em>';
    }
    const profile = output.profile || {};
    const ans = (output._inputs && output._inputs.answers) || {};
    if (Array.isArray(entry.variants)) {
      for (const v of entry.variants) {
        if (matchVariantConditions(v.when, profile, ans)) return v.text;
      }
    }
    return entry.default || '<em>Détails personnalisés bientôt disponibles.</em>';
  }

  function matchVariantConditions(when, profile, ans) {
    if (!when || typeof when !== 'object') return true;
    for (const key of Object.keys(when)) {
      const expected = when[key];
      const actual = profile[key] !== undefined ? profile[key] : ans[key];
      if (Array.isArray(expected)) {
        if (expected.indexOf(actual) === -1) return false;
      } else {
        if (actual !== expected) return false;
      }
    }
    return true;
  }

  function r2HandleCtaClick(btn, role, productId) {
    const current = _r2Selection.state.get(productId) || r2InitialState(role);
    const next = r2NextState(role, current);
    _r2Selection.state.set(productId, next);
    if (next === 'is-locked' || next === 'is-added') {
      _r2Selection.added.add(productId);
    } else {
      _r2Selection.added.delete(productId);
    }
    // Reset toutes les classes is-* puis applique la nouvelle.
    btn.classList.remove('is-locked', 'is-added', 'is-recommended', 'is-optional');
    btn.classList.add(next);
    btn.textContent = r2CtaText(role, next);
    // V3.10 — Live update du bloc R4 récap "Sélectionnés".
    if (typeof r4UpdateSelected === 'function') r4UpdateSelected();
    // V3.12 — Live update du compteur + total R6.
    if (typeof r6UpdateTotal === 'function') r6UpdateTotal();
  }

  // V9 DUO — dead code : le filtre Matin/Soir a été retiré de block2_products
  // (le moment vit dans la pill de chaque carte + la notice pharmacien).
  function r2ApplyMomentFilter(filter) {
    const cards = document.querySelectorAll('.pd-prod-v7[data-moment]');
    cards.forEach(card => {
      const m = card.getAttribute('data-moment');
      const visible = filter === 'all' || m === 'both' || m === filter;
      card.style.display = visible ? '' : 'none';
    });
    // Masquer les sections catégorie devenues vides après filtrage.
    document.querySelectorAll('.pd-prod-cat-section').forEach(section => {
      const visibleCount = Array.from(section.querySelectorAll('.pd-prod-v7'))
        .filter(c => c.style.display !== 'none').length;
      section.style.display = visibleCount === 0 ? 'none' : '';
    });
  }

  // ─── BLOCK 2 V3.8 — Refonte R2 : produits par catégorie ───────────────
  function block2_products(o) {
    const wrap = h('section', { class: 'pd-block pd-block-2' });

    // V9 DUO — Refonte « 1 diagnostic → 2 héros → 1 base → confort en option ».
    // Remplace : bannière UX1 + filtre Matin/Soir + sections numérotées par
    // étape. Chaque carte porte désormais sa pill étape ; l'ordre matin/soir
    // vit dans la pill moment + la notice pharmacien.
    const groups = computeDisplayGroups(o);
    const descriptor = (o.profile && o.profile.routine_descriptor) || '';

    // Reset état R2 pour nouveau rendu
    _r2Selection.added.clear();
    _r2Selection.state.clear();

    // ── 1. LE DUO SIGNATURE ──────────────────────────────────────────────
    const duoTitle = h('div', { class: 'pd-section-v7 pd-duo-head' });
    duoTitle.appendChild(h('div', { class: 'pd-section-v7-eyebrow' }, 'Votre protocole'));
    duoTitle.appendChild(h('h2', { class: 'pd-section-v7-h2' }, 'Votre duo signature'));
    duoTitle.appendChild(h('p', { class: 'pd-section-v7-sub' },
      descriptor
        ? 'Les deux soins qui traitent votre priorité : ' + descriptor.toLowerCase() + '.'
        : 'Les deux soins qui traitent votre priorité.'));
    wrap.appendChild(duoTitle);

    const duoSection = h('div', { class: 'pd-duo-section' });
    groups.duo.forEach((p, i) => {
      const card = r2BuildProductCard(p, o, { role: 'hero' });
      card.setAttribute('data-duo-index', String(i + 1));
      duoSection.appendChild(card);
    });
    wrap.appendChild(duoSection);

    // ── 2. LA BASE QUOTIDIENNE ───────────────────────────────────────────
    if (groups.base.length) {
      const baseHeader = h('div', { class: 'pd-prod-cat pd-base-head' });
      baseHeader.appendChild(h('span', { class: 'pd-prod-cat-line' }));
      baseHeader.appendChild(h('span', { class: 'pd-prod-cat-label' }, 'Votre base quotidienne'));
      baseHeader.appendChild(h('span', { class: 'pd-prod-cat-count' },
        groups.base.length + (groups.base.length > 1 ? ' produits' : ' produit')));
      wrap.appendChild(baseHeader);
      wrap.appendChild(h('p', { class: 'pd-base-sub' },
        'Les indispensables de toute routine — nettoyage, hydratation, protection.'));
      groups.base.forEach(p => {
        wrap.appendChild(r2BuildProductCard(p, o, { compact: true }));
      });
    }

    // ── 3. LE CONFORT (optionnel, replié) ────────────────────────────────
    if (groups.confort.length) {
      const confortGroup = h('div', { class: 'pd-confort-group is-collapsed' });
      const cToggle = h('button', {
        class: 'pd-confort-toggle', type: 'button', 'aria-expanded': 'false'
      });
      const cLabelWrap = h('span', { class: 'pd-confort-toggle-text' });
      cLabelWrap.appendChild(h('span', { class: 'pd-confort-toggle-label' },
        'Pour aller plus loin'));
      cLabelWrap.appendChild(h('span', { class: 'pd-confort-toggle-count' },
        groups.confort.length + ' soin' + (groups.confort.length > 1 ? 's' : '') + ' confort · optionnel'));
      cToggle.appendChild(cLabelWrap);
      cToggle.appendChild(h('span', { class: 'pd-confort-toggle-chevron' }, '▾'));
      cToggle.addEventListener('click', () => {
        const wasCollapsed = confortGroup.classList.contains('is-collapsed');
        confortGroup.classList.toggle('is-collapsed');
        cToggle.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
      });
      confortGroup.appendChild(cToggle);

      const cBody = h('div', { class: 'pd-confort-body-wrap' });
      const cInner = h('div', { class: 'pd-confort-body' });
      cInner.appendChild(h('p', { class: 'pd-confort-intro' },
        'Votre duo et votre base suffisent. Ces soins enrichissent votre routine quand le rythme est installé — à votre main.'));
      groups.confort.forEach(p => {
        cInner.appendChild(r2BuildProductCard(p, o, { compact: true }));
      });
      cBody.appendChild(cInner);
      confortGroup.appendChild(cBody);
      wrap.appendChild(confortGroup);
    }

    return wrap;
  }

  // ─── V7 BANDEAU "Un Protocole Cohérent" ─────────────────────────────
  // Pédagogie commerciale (différent de "Pourquoi cette routine" qui est
  // pédagogie produit). Légitimise le pack indissociable + escape valve
  // vers le catalogue parapharmacie pour ceux qui ne veulent qu'un produit.
  function block_indissociable_band() {
    const wrap = h('aside', { class: 'pd-prod-bandeau' });
    const text = h('div', { class: 'pd-prod-bandeau-text' });
    text.appendChild(h('p', { class: 'pd-prod-bandeau-title' }, 'Un Protocole Cohérent.'));
    const body = h('p', { class: 'pd-prod-bandeau-body' });
    body.appendChild(document.createTextNode('Chaque produit a été sélectionné pour la cohérence de l’ensemble — l’efficacité naît de leur synergie. '));
    body.appendChild(h('strong', {}, 'Cette routine se commande comme un : les essentiels ne peuvent être retirés à l’unité.'));
    text.appendChild(body);
    wrap.appendChild(text);
    wrap.appendChild(h('a', {
      href: '/collections',
      target: '_blank',
      rel: 'noopener',
      class: 'pd-prod-bandeau-link'
    }, 'Voir au catalogue'));
    return wrap;
  }

  // ─── V7 CARTE NOTICE PHARMACIEN (standalone) ─────────────────────────
  // Pas un produit à acheter — une carte qui annonce ce que la cliente
  // recevra dans son colis et son espace membre. Badge Inclus, accordéon
  // court avec le message de réception.
  function block_notice_card() {
    const card = h('article', { class: 'pd-prod-v7' });
    const row = h('div', { class: 'pd-prod-v7-row' });

    const imgZone = h('div', {
      class: 'pd-prod-v7-image',
      style: 'background:rgba(136,204,64,0.06);'
    });
    imgZone.appendChild(h('span', {
      html: SVG.documentCheck,
      style: 'transform:scale(2.4);color:#2D6A3F;'
    }));
    row.appendChild(imgZone);

    const content = h('div', { class: 'pd-prod-v7-content' });
    content.appendChild(h('div', { class: 'pd-prod-v7-eyebrow' }, 'Paradermia · Document Routine'));
    content.appendChild(h('h3', { class: 'pd-prod-v7-name' }, 'Notice pharmacien'));
    content.appendChild(h('p', { class: 'pd-prod-v7-desc' },
      'Mode d’emploi détaillé de votre protocole personnel.'));

    // V7.4 — Pills row : pill OFFERT (pas de check, pas d'icône)
    // Bottom row : status [✓ Inclus] uniquement (suppression du "Offert" texte)
    const pills = h('div', { class: 'pd-prod-v7-pills' });
    pills.appendChild(h('span', {
      class: 'pd-prod-v7-pill pd-prod-v7-pill--offert'
    }, 'Offert'));
    content.appendChild(pills);

    const bottom = h('div', { class: 'pd-prod-v7-bottom' });
    const whyToggle = h('button', {
      class: 'pd-prod-v7-why', type: 'button', 'aria-expanded': 'false'
    });
    whyToggle.appendChild(h('span', { class: 'pd-prod-v7-why-chevron' }, '▾'));
    whyToggle.appendChild(document.createTextNode(' En savoir plus'));
    whyToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const opened = card.classList.toggle('is-why-open');
      whyToggle.setAttribute('aria-expanded', opened ? 'true' : 'false');
    });
    bottom.appendChild(whyToggle);
    bottom.appendChild(h('span', { class: 'pd-prod-v7-spacer' }));
    bottom.appendChild(h('span', { class: 'pd-prod-v7-status' }, 'Inclus'));
    content.appendChild(bottom);
    row.appendChild(content);
    card.appendChild(row);

    const whyBody = h('div', { class: 'pd-prod-v7-why-body' });
    whyBody.appendChild(h('div', { class: 'pd-prod-v7-why-inner', html:
      'Vous recevrez votre <strong>notice détaillée</strong> dans votre colis et dans votre <strong>espace membre</strong> après achat. Application, fréquence, ordre, précautions — tout y est consigné pour réussir votre protocole sur la durée.'
    }));
    card.appendChild(whyBody);

    return card;
  }

  // ─── V7 BLOC UPSELL CORPS / SOINS COMPLÉMENTAIRES ────────────────────
  // Toujours visible, titre conditionnel selon pack :
  //  - STRETCH (corps déjà couvert par étape 05) : "Vos soins méritent..."
  //  - Visage : "Votre corps mérite..."
  // Source des produits = output.upsell_products (à brancher sur l'algo)
  // ou fallback sur output.body_products (existant).
  // V8 (demande Bilikiss) — Régénère le protocole au niveau PREMIUM sur la page
  // résultats (l'algo est chargé ici), à partir des réponses sauvegardées, puis
  // re-monte. Sans toucher l'algo : on relance ParaDermiaAlgo.run avec
  // tier_selected='PREMIUM'.
  // V9.2 (bug bloquant signalé 2026-08-29) — Régénère le protocole au niveau
  // demandé SANS JAMAIS quitter la page résultats.
  //
  // Bug corrigé : l'ancienne version redirigeait vers /pages/quiz dès que le
  // catalogue Storefront était indisponible — or window.PARADERMIA_STOREFRONT_TOKEN
  // n'est pas injecté sur la page résultats (réglage de section vide), donc le
  // fetch échouait À TOUS LES COUPS et le clic renvoyait systématiquement au
  // questionnaire, bilan perdu. Désormais : aucune redirection, le protocole
  // affiché reste intact et l'échec est signalé à la cliente.
  //
  // `onDone(ok)` permet à l'appelant de restaurer son bouton.
  function pdRebuildAtTier(tier, root, onDone) {
    let cur = {};
    try { cur = JSON.parse(localStorage.getItem(OUTPUT_KEY) || '{}'); } catch (_) {}
    const answers = Object.assign({}, (cur._inputs && cur._inputs.answers) || {});
    answers.tier_selected = tier;
    const fail = (msg) => {
      showToast(msg || 'Impossible de mettre à jour votre protocole pour le moment. Réessayez dans un instant.');
      if (typeof onDone === 'function') onDone(false);
    };
    if (!window.ParaDermiaAlgo || typeof fetchCatalogueFromStorefront !== 'function') {
      fail();
      return;
    }
    fetchCatalogueFromStorefront().then(catalogue => {
      const out = window.ParaDermiaAlgo.run(pdAlgoAnswers(answers), catalogue);
      try {
        const byH = {};
        (catalogue || []).forEach(p => { if (p && p.handle) byH[p.handle] = p; });
        const enr = (arr) => (arr || []).forEach(prod => {
          const s = prod && prod.handle && byH[prod.handle];
          if (!s) return;
          if (s.image && !prod.image) prod.image = s.image;
          if (prod.price == null && s.price != null) prod.price = (typeof s.price === 'string') ? parseFloat(s.price) : s.price;
          if (s.variantId && !prod.variantId) prod.variantId = s.variantId;
        });
        enr(out.block2_products); enr(out.block5_complements); enr(out.body_products);
      } catch (_e) {}
      out._meta = cur._meta; out._inputs = cur._inputs;
      // Le niveau AFFICHÉ est celui que l'algo a réellement appliqué (il peut
      // rester plafonné pour raison clinique) — jamais une valeur forcée.
      out.tier_final = (out.profile && out.profile.niveau_label) || tier;
      out.tier_user_choice = tier;
      // Mémorise le niveau d'origine pour permettre le retour en arrière.
      out.tier_previous = cur.tier_final || cur.tier_user_choice || null;
      out.tier_recalculated = cur.tier_recalculated;
      out.parcours = cur.parcours; out.mdv_light_answered = cur.mdv_light_answered;
      try { localStorage.setItem(OUTPUT_KEY, JSON.stringify(out)); } catch (_e) {}
      if (typeof onDone === 'function') onDone(true);
      mountResults(root);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }).catch(() => fail());
  }

  // V8 (demande Bilikiss) — CTA « Passer au niveau Premium » sur la page résultats
  // quand Premium était recommandé mais pas le niveau retenu. null sinon.
  function block_premium_upgrade(output, root) {
    const LABEL = { STARTER: 'Starter', OPTIMAL: 'Optimal', PREMIUM: 'Premium' };
    const current = output.tier_final || (output.profile && output.profile.niveau_label) || '';
    const pretty = (t) => LABEL[t] || (t || '').toLowerCase();

    // V9.2 — Retour en arrière après un passage au Premium depuis cette page.
    // Sans ça, l'ajustement était sans issue : il fallait refaire tout le quiz.
    if (current === 'PREMIUM' && output.tier_previous && output.tier_previous !== 'PREMIUM') {
      const back = h('div', { class: 'pd-premium-upgrade is-revert' });
      back.appendChild(h('p', { class: 'pd-premium-upgrade-text' },
        'Votre protocole est passé au niveau Premium, avec des actifs plus concentrés.'));
      const backBtn = h('button', { class: 'pd-premium-upgrade-btn', type: 'button' },
        'Revenir au niveau ' + pretty(output.tier_previous));
      backBtn.addEventListener('click', () => {
        const label = backBtn.textContent;
        backBtn.disabled = true;
        backBtn.textContent = 'Mise à jour de votre protocole…';
        pdRebuildAtTier(output.tier_previous, root, (ok) => {
          if (!ok) { backBtn.disabled = false; backBtn.textContent = label; }
        });
      });
      back.appendChild(backBtn);
      return back;
    }

    if (output.tier_recalculated !== 'PREMIUM' || current === 'PREMIUM') return null;

    // V9.2 — Message reformulé. L'ancien disait « Notre pharmacienne
    // recommandait le niveau Premium », ce qui contredisait frontalement
    // l'écran de choix : à ce moment du parcours le badge « Recommandé » est
    // calculé AVANT les questions de personnalisation (expertise, ancienneté),
    // donc il porte souvent sur Optimal. Ce sont les réponses complémentaires
    // qui font monter le score ensuite. On dit donc ce qui est vrai — le
    // profil s'est précisé — et on assume que le choix de la cliente est tenu.
    const banner = h('div', { class: 'pd-premium-upgrade' });
    banner.appendChild(h('p', {
      class: 'pd-premium-upgrade-text',
      html: 'Vos réponses complémentaires affinent votre profil : votre peau est prête pour des actifs plus concentrés. Nous avons gardé le niveau <strong>'
        + escapeHtml(pretty(current)) + '</strong> que vous avez choisi. Vous pouvez passer au Premium — c’est réversible.'
    }));
    const btn = h('button', { class: 'pd-premium-upgrade-btn', type: 'button' }, 'Découvrir mon protocole Premium →');
    btn.addEventListener('click', () => {
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Mise à jour de votre protocole…';
      pdRebuildAtTier('PREMIUM', root, (ok) => {
        if (!ok) { btn.disabled = false; btn.textContent = label; }
      });
    });
    banner.appendChild(btn);
    return banner;
  }

  // V8 (demande Bilikiss) — Défilement automatique du carousel corps sur mobile.
  // Avance d'une carte toutes les ~3,5 s, revient au début en boucle. Se met en
  // pause définitive dès que l'utilisatrice interagit (touch / clic / scroll
  // manuel). N'agit qu'en mode carousel (≤ 720px) ; inactif sinon.
  function startCorpsAutoScroll(track) {
    if (!track) return;
    let paused = false;
    ['touchstart', 'pointerdown', 'wheel'].forEach(ev =>
      track.addEventListener(ev, () => { paused = true; }, { passive: true }));
    const isCarousel = () => window.matchMedia('(max-width: 720px)').matches;
    const tick = () => {
      if (!document.body.contains(track)) return; // démonté → stop
      if (!paused && isCarousel() && track.children.length > 1) {
        const first = track.children[0];
        const cardW = first.getBoundingClientRect().width + 14; // + gap approx
        const maxScroll = track.scrollWidth - track.clientWidth;
        let next = track.scrollLeft + cardW;
        if (next > maxScroll + 2) next = 0; // boucle
        track.scrollTo({ left: next, behavior: 'smooth' });
      }
      setTimeout(tick, 3500);
    };
    setTimeout(tick, 3500);
  }

  // V8 (demande Bilikiss) — Récupère en live les produits corps ADAPTÉS à la
  // routine : tag addon_corps + pack_<pack>. L'algo ne remplit body_products que
  // pour STRETCH ; ceci couvre les autres routines SANS toucher l'algo. Exclut
  // bébé. Renvoie [] si rien (→ le lien catalogue reste affiché).
  function fetchBodyProductsForPack(pack) {
    const shop = (window.Shopify && window.Shopify.shop) || window.PARADERMIA_SHOP;
    const token = window.PARADERMIA_STOREFRONT_TOKEN;
    if (!shop || !token || !pack) return Promise.resolve([]);
    // V9.2 (demande fondatrice 2026-08-29) — l'upsell corps affichait un simple
    // lien catalogue au lieu des produits : la requête exigeait `addon_corps ET
    // pack_<pack>`, or la quasi-totalité des soins corps ne porte aucun tag de
    // pack → 0 résultat. On interroge donc tout le rayon corps et on trie côté
    // client (produits du pack d'abord, puis la sélection éditoriale).
    const queryStr = 'tag:addon_corps';
    const gql = `query { products(first: 40, query: ${JSON.stringify(queryStr)}) {
      edges { node {
        id handle title vendor tags availableForSale
        variants(first: 10) { edges { node { id title price { amount } quantityAvailable } } }
        images(first: 1) { edges { node { url } } }
      } }
    } }`;
    return fetch(`https://${shop}/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: gql })
    })
    .then(r => r.json())
    .then(data => {
      const edges = (data && data.data && data.data.products && data.data.products.edges) || [];
      return edges.map(e => {
        const n = e.node;
        // V9.1 — même règle que le bilan : pas de format découverte/mini.
        const v = pdSellableVariants((n.variants && n.variants.edges || []).map(x => x.node))[0];
        const qty = v && typeof v.quantityAvailable === 'number' ? v.quantityAvailable : null;
        let pdId = null;
        (n.tags || []).forEach(t => { if (t.indexOf('PD-') === 0) pdId = t; });
        if (!pdId && n.handle) { const m = n.handle.match(/pd-\d+/i); if (m) pdId = m[0].toUpperCase(); }
        const actifs = (n.tags || []).filter(t => t.indexOf('actif_') === 0).map(t => t.replace('actif_', ''));
        return {
          id: pdId || n.id, handle: n.handle, brand: n.vendor, name: n.title,
          tags: n.tags || [],
          price: v && v.price ? parseFloat(v.price.amount) : null,
          variantId: v && v.id,
          image: n.images && n.images.edges && n.images.edges[0] && n.images.edges[0].node && n.images.edges[0].node.url,
          available: !!n.availableForSale && (qty === null || qty > 0),
          actifs: actifs, actifs_display: actifs
        };
      })
      .filter(p => p.available && (p.tags || []).indexOf('addon_bebe') === -1)
      // V9.2 — hors sujet « soin corps » d'un bilan peau : capillaire,
      // matériel d'épilation, soins bébé (nom explicite faute de tag).
      .filter(p => !/shampoing|anti-?chute|capillaire|pelliculaire|s[ée]borrh[ée]|chauffe-?cire|cire\b|b[ée]b[ée]|croûtes de lait|liniment|change/i.test(p.name || ''))
      // Soins maternité : réservés aux profils grossesse (pack SAFE).
      .filter(p => pack === 'pack_SAFE'
        || !/maternit|grossesse|post-?partum|vergetur/i.test(p.name || ''))
      // Priorité : produits portant le pack de la routine, puis la sélection
      // éditoriale voulue (lait corps, huile, savon/gommage), puis le reste.
      .sort((a, b) => pdBodyRank(a, pack) - pdBodyRank(b, pack))
      .slice(0, 6);
    })
    .catch(() => []);
  }

  // V9.2 — Ordre de mise en avant du rayon corps (demande fondatrice) :
  // huile et lait corps (IN'OYA / Oxyprolane) d'abord, puis savon/gommage.
  function pdBodyRank(p, pack) {
    const name = p.name || '';
    const inPack = pack && (p.tags || []).indexOf(pack) !== -1;
    let rank = 50;
    if (/huile/i.test(name)) rank = 10;
    else if (/lait corps|lait /i.test(name)) rank = 11;
    else if (/savon|gommage/i.test(name)) rank = 20;
    else if (/gel lavant|nettoyant/i.test(name)) rank = 30;
    // Un produit ciblé sur la routine passe devant, à catégorie équivalente.
    if (inPack) rank -= 5;
    return rank;
  }

  function block_upsell_corps(output) {
    const profile = output.profile || {};
    const pack = profile.primary_pack || '';
    const isStretch = pack === 'pack_STRETCH';

    const upsellProducts = (output.upsell_products && output.upsell_products.length)
      ? output.upsell_products
      : (output.body_products || []);

    const wrap = h('section', { class: 'pd-block pd-block-upsell' });

    const titleBlock = h('div', { class: 'pd-section-v7' });
    titleBlock.appendChild(h('div', { class: 'pd-section-v7-eyebrow' },
      isStretch ? 'En complément' : 'Et le corps ?'));
    titleBlock.appendChild(h('h2', { class: 'pd-section-v7-h2' },
      isStretch
        ? 'Vos soins méritent aussi une attention particulière.'
        : 'Votre corps mérite aussi une délicate attention.'));
    titleBlock.appendChild(h('p', { class: 'pd-section-v7-sub' },
      upsellProducts.length
        ? 'Ces produits sont sélectionnés spécifiquement pour votre profil et pour répondre à ses besoins.'
        : 'Découvrez notre sélection de soins corps dans notre catalogue parapharmacie pour compléter votre routine.'));
    wrap.appendChild(titleBlock);

    if (upsellProducts.length) {
      upsellProducts.forEach(p => {
        // Force tier 'optionnel' (Confort dashed) pour les upsells
        const upsellProd = Object.assign({}, p, { role: p.role || 'optionnel' });
        wrap.appendChild(r2BuildProductCard(upsellProd, output));
      });
    } else {
      // Fallback affiché tout de suite : CTA collection soins corps.
      const cta = h('a', {
        href: '/collections/soins-corps',
        target: '_blank',
        rel: 'noopener',
        class: 'pd-prod-bandeau-link',
        style: 'margin-top:1.6rem;align-self:flex-start;'
      }, 'Voir notre catalogue');
      wrap.appendChild(cta);

      // V8 (demande Bilikiss) — Sélection corps ADAPTÉE à la routine : on cherche
      // en live les produits addon_corps + pack_<pack> ; si on en trouve, on
      // remplace le lien catalogue par de vraies cartes corps. Sans toucher l'algo.
      if (pack && !isStretch) {
        fetchBodyProductsForPack(pack).then(prods => {
          if (!prods || !prods.length) return;
          // Ajoute au lookup recap pour que « + Ajouter » compte + affiche le prix.
          prods.forEach(p => {
            if (!_r4ProductLookup.has(p.id)) {
              _r4ProductLookup.set(p.id, { kind: 'body', id: p.id, brand: p.brand, name: p.name, role: 'optionnel', handle: p.handle, price: p.price });
            }
          });
          if (cta.parentNode) cta.parentNode.removeChild(cta);
          const sub = wrap.querySelector('.pd-section-v7-sub');
          if (sub) sub.textContent = 'Ces soins corps complètent votre routine '
            + pack.replace('pack_', '') + ', sélectionnés pour le même objectif.';
          // V8 (demande Bilikiss) — Les cartes corps vont dans un carousel à
          // défilement (auto-scroll sur mobile) pour gagner de la place.
          const track = h('div', { class: 'pd-corps-carousel' });
          prods.forEach(p => {
            const upsellProd = Object.assign({}, p, { role: 'optionnel', step: 'addon_corps' });
            track.appendChild(r2BuildProductCard(upsellProd, output));
          });
          wrap.appendChild(track);
          startCorpsAutoScroll(track);
        }).catch(function () {});
      }
    }

    return wrap;
  }

  function productCard(p) {
    const card = h('article', {
      class: 'pd-product-card' + (p._role_ux ? ' pd-role-' + p._role_ux : ''),
      dataset: { step: p.step, pdId: p.id, roleUx: p._role_ux || '' }
    });
    // V3.34f UX1 — Badge rôle UX (essentiel/recommande/confort) — top-left overlay
    if (p._role_ux) {
      const roleLabels = { essentiel: 'Essentiel', recommande: 'Recommandé', confort: 'Confort' };
      card.appendChild(h('span', {
        class: 'pd-ux1-role-badge pd-ux1-tag pd-ux1-tag--' + p._role_ux
      }, roleLabels[p._role_ux] || 'Confort'));
    }
    const img = h('div', { class: 'pd-product-image' });
    if (p.image) {
      img.appendChild(h('img', { src: p.image, alt: p.name || '', loading: 'lazy', style: 'width:100%;height:100%;object-fit:cover;' }));
    } else {
      img.appendChild(h('span', { class: 'pd-product-placeholder' }, p.brand ? p.brand.charAt(0) : '?'));
    }
    card.appendChild(img);

    const body = h('div', { class: 'pd-product-body' }, [
      h('div', { class: 'pd-step-label' }, stepDisplayName(p.step)),
      h('div', { class: 'pd-product-brand' }, p.brand || ''),
      h('h3', { class: 'pd-product-name' }, p.name || '')
    ]);
    if (Array.isArray(p.actifs_display) && p.actifs_display.length) {
      body.appendChild(h('div', { class: 'pd-product-actifs' },
        'Actifs : ' + p.actifs_display.join(', ')));
    }
    if (p.role === 'role_essentiel' || p.role === 'role_obligatoire') {
      const label = roleBadgeLabel(p.role);
      if (label) body.appendChild(h('div',
        { class: 'pd-product-badge pd-badge-' + p.role.replace('role_','') }, label));
    } else if (p.role === 'role_optionnel') {
      // Affiche "Recommandé" pour les optionnels (charte item 7)
      body.appendChild(h('div', { class: 'pd-product-badge pd-badge-recommande' }, 'Recommandé'));
    }

    if (Array.isArray(p.notices) && p.notices.length) {
      const ul = h('ul', { class: 'pd-product-notices' });
      p.notices.forEach(n => ul.appendChild(h('li', {}, n)));
      body.appendChild(ul);
    }

    // Item 8 — bouton +Ajouter individuel
    const addBtn = h('button', {
      class: 'pd-add-button', type: 'button',
      'aria-label': 'Ajouter ' + (p.name || 'ce produit') + ' au panier'
    }, '+ Ajouter');
    addBtn.addEventListener('click', () => handleAddSingle(p.handle, p.name));
    body.appendChild(addBtn);

    card.appendChild(body);
    return card;
  }

  function stepDisplayName(step) {
    return {
      etape_demaquillant: 'Démaquillant',
      etape_nettoyant:    'Nettoyant',
      etape_toner:        'Toner',
      etape_exfoliant:    'Exfoliant',
      etape_serum:        'Sérum',
      etape_hydratant:    'Hydratant',
      etape_spf:          'SPF',
      etape_zone_specifique: 'Contour des yeux'
    }[step] || step;
  }

  // Item 7 — libellés rôle harmonisés
  // V3.34d-RESULTS-PRODUCTS-LAYOUT-REDESIGN — role_optionnel et optionnel
  // affichent désormais "Confort" pour cohérence avec leur état non-sélectionné
  // par défaut (CTA "+ Ajouter"). Valeurs internes inchangées côté algo.
  function roleBadgeLabel(role) {
    return {
      role_essentiel:    'Essentiel',
      role_optionnel:    'Confort',
      role_selon_profil: 'Selon profil',
      role_obligatoire:  'Essentiel'
    }[role] || null;
  }
  function complementRoleLabel(role) {
    return {
      essentiel:  'Essentiel',
      recommande: 'Recommandé',
      optionnel:  'Confort'
    }[role] || null;
  }

  function block3_routine(o) {
    const wrap = h('section', { class: 'pd-block pd-block-3' }, [
      h('h2', { class: 'pd-block-title' }, 'Votre routine matin & soir')
    ]);
    const row = h('div', { class: 'pd-routine-row' });
    row.appendChild(routineColumn('matin', 'Matin', SVG.sun, o.block3_routine.morning));
    row.appendChild(routineColumn('soir',  'Soir',  SVG.moon, o.block3_routine.evening));
    wrap.appendChild(row);
    return wrap;
  }

  function routineColumn(cls, title, iconSvg, items) {
    // BUG 3 V3.1 — structure explicite icone + texte pour garantir l'affichage du label
    const header = h('h3', { class: 'pd-routine-title' });
    header.appendChild(h('span', { class: 'pd-routine-title-icon', html: iconSvg }));
    header.appendChild(h('span', { class: 'pd-routine-title-text' }, title));
    const col = h('div', { class: 'pd-routine-col pd-routine-' + cls }, [header]);
    const list = h('ol', { class: 'pd-routine-list' });
    items.forEach((it, i) => {
      list.appendChild(h('li', { class: 'pd-routine-item' }, [
        h('span', { class: 'pd-routine-n' }, String(i + 1)),
        h('div', { class: 'pd-routine-info' }, [
          h('div', { class: 'pd-routine-step' }, stepDisplayName(it.step)),
          h('div', { class: 'pd-routine-product' }, (it.product.brand ? it.product.brand + ' — ' : '') + (it.product.name || ''))
        ])
      ]));
    });
    col.appendChild(list);
    return col;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  ITEM 11 — Alertes personnalisées (5 types, override UI complet)
  // ════════════════════════════════════════════════════════════════════════

  // Construit la liste finale d'alertes à partir de l'output algo + des inputs.
  // Les triggers viennent de l'algo (block4_alerts) ; les copys et l'enrichissement
  // (isotrétinoïne, phototype IV-VI) sont pilotés ici.
  function computeAlertsList(o) {
    const list = [];
    const ans = (o._inputs && o._inputs.answers) || {};
    const profile = o.profile || {};
    const algoAlerts = Array.isArray(o.block4_alerts) ? o.block4_alerts : [];

    const has = (icon) => algoAlerts.some(a => a.icon === icon);

    // 1. Grossesse / Allaitement (SAFE)
    if (has('pregnancy') || ans.Q2_6 === 'A' || ans.Q2_6 === 'B') {
      list.push({
        type: 'pregnancy',
        icon: 'bottle',
        text: 'Votre protocole a été construit avec des critères de sécurité renforcés. Chaque produit est validé compatible grossesse et allaitement par notre pharmacienne.'
      });
    }

    // 2. Acné installée (Q2_3=A + Q2_4=D + Q2_5=C)
    if (ans.Q2_3 === 'A' && ans.Q2_4 === 'D' && ans.Q2_5 === 'C') {
      list.push({
        type: 'acne_severe',
        icon: 'warning',
        text: 'Une acné installée a été détectée dans votre profil. Un suivi dermatologique peut accélérer significativement vos résultats. En attendant, voici le protocole le mieux adapté à votre profil.'
      });
    }

    // 3. Rosacée (Q7_3=A + Q7_3_rosacee=true)
    if (ans.Q7_3 === 'A' && (ans.Q7_3_rosacee === true || ans.Q7_3_rosacee === 'oui')) {
      list.push({
        type: 'rosacee',
        icon: 'warning',
        text: 'Votre profil présente des signes compatibles avec une rosacée. Notre pharmacienne a sélectionné les actifs les moins irritants. Une consultation dermatologique reste recommandée pour un diagnostic précis.'
      });
    }

    // 4. Récupération post-procédure (Q7_5='A' récupération pleine OU 'B' <2 sem) — proxy
    // Sprint 1.5 — Étendu à 'B' pour cohérence avec cap STARTER algo + alert_reason post_acte_actif.
    if (ans.Q7_5 === 'A' || ans.Q7_5 === 'B') {
      list.push({
        type: 'isotretinoine',
        icon: 'warning',
        text: 'Votre récupération post-procédure nécessite une réintroduction progressive des actifs. Votre protocole a été adapté en conséquence — consultez votre dermatologue avant d\'introduire les exfoliants.'
      });
    }

    // 5. Phototype élevé (IV-VI) avec risque PIH
    if (profile.phototype === 'phototype_IV_V_VI') {
      list.push({
        type: 'phototype',
        icon: 'sun_strong',
        text: 'Votre phototype nécessite une vigilance particulière vis-à-vis des actifs photosensibilisants. Votre protocole intègre cette donnée — l\'application du SPF est non négociable.'
      });
    }

    // Sun_strong générique (Q7_4bis=B) — si pas déjà couvert par phototype
    if (has('sun_strong') && profile.phototype !== 'phototype_IV_V_VI') {
      list.push({
        type: 'phototype',
        icon: 'sun_strong',
        text: 'Votre exposition UV élevée demande une protection solaire stricte. Le SPF de votre protocole est conçu pour vous accompagner au quotidien — n\'oubliez pas la réapplication toutes les 2h en extérieur.'
      });
    }

    return list;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V3.34c-3 — Alerte clinique tier adjustment (Note clinique sur niveau)
  //  Affichée en tête du BLOCK 4 alertes si output.alert_type !== null.
  //  Lit output.alert_type/_reason/tier_user_choice/tier_recalculated/tier_final
  //  (persistés par V3.34c-2-PATCH dans output, survivent à clearState).
  //  Pattern indépendant des alertes dermato (sélecteurs .pd-alert-tier vs
  //  .pd-result-alert*) pour clarté visuelle et style propre.
  // ════════════════════════════════════════════════════════════════════════

  function getTierAlertText(output) {
    var aType   = output.alert_type;
    var aReason = output.alert_reason;
    var uChoice = output.tier_user_choice;
    var uRecalc = output.tier_recalculated;
    var uFinal  = output.tier_final;

    // Cas 5 — post_acte_actif (override absolu STARTER) — prioritaire car
    // le plus contraignant cliniquement
    if (aType === 'descent' && aReason === 'post_acte_actif') {
      return 'Votre niveau a été ajusté à STARTER pour respecter la phase de '
        + 'récupération post-acte de votre peau. Reprenez progressivement votre '
        + 'routine sur avis de votre praticien.';
    }
    // Cas 6 — EFFICACITE_BRUTE + barrière fragile
    if (aType === 'descent' && aReason === 'efficacite_barriere_fragile') {
      return 'Votre niveau a été ajusté à OPTIMAL pour préserver l\'équilibre '
        + 'de votre barrière cutanée. Bien que votre préférence soit l\'efficacité '
        + 'brute, un protocole plus concentré pourrait fragiliser votre peau '
        + 'actuellement.';
    }
    // Cas 4 — age_moins_18
    if (aType === 'descent' && aReason === 'age_moins_18') {
      return 'Votre niveau a été ajusté à OPTIMAL. Pour les peaux jeunes, un '
        + 'protocole concentré n\'est pas recommandé. Votre routine reste '
        + 'pleinement efficace pour vos besoins actuels.';
    }
    // Cas 3 — barrière fragile
    if (aType === 'descent' && aReason === 'barriere_fragile') {
      return 'Votre niveau a été ajusté à OPTIMAL pour préserver l\'équilibre '
        + 'de votre barrière cutanée. Un protocole plus concentré pourrait '
        + 'fragiliser votre peau actuellement. Vous pourrez intensifier votre '
        + 'routine une fois votre barrière renforcée.';
    }
    // Cas 1 — Descente RETINOL_DEBUTANT spécifique PREMIUM -> STARTER
    if (aType === 'descent' && aReason === 'retinol_debutant'
        && uChoice === 'PREMIUM' && uFinal === 'STARTER') {
      return 'Votre niveau a été ajusté de PREMIUM à STARTER. Vos réponses '
        + 'indiquent que vous débutez avec les actifs concentrés, et une '
        + 'montée en puissance progressive est cliniquement préférable pour '
        + 'votre profil. Vous pourrez faire évoluer votre routine '
        + 'ultérieurement, en toute sécurité.';
    }
    // Cas 2 — Descente générique (et retinol_debutant non spécifique)
    if (aType === 'descent' && (aReason === 'generic_descent'
        || aReason === 'retinol_debutant')) {
      return 'Votre niveau a été ajusté de ' + uChoice + ' à ' + uFinal + '. '
        + 'Vos réponses indiquent qu\'une montée en puissance progressive est '
        + 'cliniquement préférable pour votre profil. Vous pourrez intensifier '
        + 'votre routine ultérieurement, en toute sécurité.';
    }
    // Cas 7 — Hausse respectée (parcours perso, recalcul > choix)
    if (aType === 'ascent_optional') {
      return 'Suite à votre analyse, votre profil correspond à un protocole '
        + uRecalc + '. Vous avez choisi ' + uChoice + ' — votre routine reste '
        + 'calibrée à ce niveau. Vous pourrez la faire évoluer à tout moment.';
    }
    // Fallback générique (ne devrait pas arriver)
    return 'Votre niveau a été ajusté à ' + uFinal + ' pour des raisons '
      + 'cliniques. Votre routine reste pleinement adaptée à votre profil.';
  }

  // V3.34d-RESULTS-ALERTS-COLLAPSIBLE — Helper pattern accordéon exclusif :
  // au clic d'un toggle, fermer toutes les alertes (.pd-result-alert +
  // .pd-alert-tier) puis ouvrir l'alerte cliquée si elle était fermée.
  function _toggleAlertExclusive(alertEl) {
    var wasCollapsed = alertEl.classList.contains('is-collapsed');
    var allAlerts = document.querySelectorAll('.pd-result-alert, .pd-alert-tier');
    allAlerts.forEach(function(a) { a.classList.add('is-collapsed'); });
    if (wasCollapsed) alertEl.classList.remove('is-collapsed');
  }

  function renderTierAdjustmentAlert(output) {
    if (!output || !output.alert_type) return null;

    var text = getTierAlertText(output);
    // V3.34d-RESULTS-ALERTS-COLLAPSIBLE — État fermé par défaut, accordéon
    // exclusif. Bouton × retiré (redondant avec le toggle d'accordéon).
    var alertEl = h('div', { class: 'pd-alert-tier pd-alert-info is-collapsed' });

    var toggle = h('button', {
      class: 'pd-alert-tier-toggle', type: 'button', 'aria-expanded': 'false'
    });
    var header = h('div', { class: 'pd-alert-tier-header' });
    header.appendChild(h('span', { class: 'pd-alert-icon' }, 'ⓘ'));
    header.appendChild(h('span', { class: 'pd-alert-title' },
      'Note clinique sur votre niveau'));
    toggle.appendChild(header);
    toggle.appendChild(h('span', { class: 'pd-alert-tier-chevron' }, '▾'));
    toggle.addEventListener('click', function() {
      _toggleAlertExclusive(alertEl);
      toggle.setAttribute('aria-expanded',
        alertEl.classList.contains('is-collapsed') ? 'false' : 'true');
    });
    alertEl.appendChild(toggle);

    var bodyWrap = h('div', { class: 'pd-alert-tier-body-wrap' });
    bodyWrap.appendChild(h('p', { class: 'pd-alert-body' }, text));
    alertEl.appendChild(bodyWrap);

    return alertEl;
  }

  // V3.13 — Refonte block4_alerts : structure .pd-result-alert*, copy
  // figée pour acne_severe + rosacee (per spec), fallback texte algo + titre
  // dérivé pour les autres types.
  const ALERT_COPY = {
    acne_severe: {
      title: 'Acné installée détectée',
      body: 'Pour une acné installée, une consultation dermatologique peut accélérer significativement vos résultats. En attendant, voici le protocole le mieux adapté à votre profil.'
    },
    rosacee: {
      title: 'Rougeurs persistantes',
      body: 'Des rougeurs persistantes peuvent indiquer une rosacée. Un diagnostic dermatologique est recommandé pour une prise en charge précise. Votre protocole a été ajusté avec les actifs les mieux tolérés pour ce profil.'
    },
    pregnancy: { title: 'Sécurité grossesse' },
    isotretinoine: { title: 'Récupération post-procédure' },
    phototype: { title: 'Phototype élevé' }
  };

  function block4_alerts(alerts) {
    // V3.34d-RESULTS-ALERTS-COLLAPSIBLE — Pattern accordéon exclusif. Toutes
    // les alertes sont fermées par défaut au chargement, une seule peut
    // s'ouvrir à la fois (cohérence avec .pd-alert-tier).
    const wrap = h('section', { class: 'pd-result-alerts' });
    alerts.forEach(a => {
      const copy = ALERT_COPY[a.type] || {};
      const title = copy.title || (a.type ? a.type.charAt(0).toUpperCase() + a.type.slice(1) : 'Information');
      const body = copy.body || a.text || '';
      const alertEl = h('div', { class: 'pd-result-alert is-collapsed' });

      const toggle = h('button', {
        class: 'pd-result-alert-toggle', type: 'button', 'aria-expanded': 'false'
      });
      const header = h('div', { class: 'pd-result-alert-header' });
      header.appendChild(h('span', { class: 'pd-result-alert-icon', html: SVG.warning }));
      header.appendChild(h('span', { class: 'pd-result-alert-title' }, title));
      toggle.appendChild(header);
      toggle.appendChild(h('span', { class: 'pd-result-alert-chevron' }, '▾'));
      toggle.addEventListener('click', function() {
        _toggleAlertExclusive(alertEl);
        toggle.setAttribute('aria-expanded',
          alertEl.classList.contains('is-collapsed') ? 'false' : 'true');
      });
      alertEl.appendChild(toggle);

      const bodyWrap = h('div', { class: 'pd-result-alert-body-wrap' });
      bodyWrap.appendChild(h('p', { class: 'pd-result-alert-body' }, body));
      alertEl.appendChild(bodyWrap);

      wrap.appendChild(alertEl);
    });
    return wrap;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V6 SPRINT2-BANDS — Pattern card homepage (radius 20, hover #EFF5E8)
  //  ─────────────────────────────────────────────────────────────────────
  //  3 bandes structurées sous le hero :
  //    1. block_solution()    → "Réussir votre routine" — accordéon, méthodo
  //    2. block_why_routine() → "Pourquoi cette routine pour vous ?" — profil + actifs
  //    3. block_vigilances()  → "Vigilances" — alertes sécurité (visible)
  //
  //  Helper bandFrame() construit le squelette card commun (icon + content
  //  + header [title + chevron] + body). Variants via classes pd-band-{name}.
  //  Convention accordéon : .is-collapsed (cohérent avec autres modules Dawn).
  // ════════════════════════════════════════════════════════════════════════

  // Fabrique le squelette d'une bande card homepage-pattern.
  // opts: { variant: string, icon: SVG html, title: string, pill?: string,
  //         accordion?: boolean, collapsed?: boolean (default true if accordion) }
  // Retourne { wrap, content, headerEl, body } pour que le caller remplisse body.
  function bandFrame(opts) {
    const isAccordion = !!opts.accordion;
    const isCollapsed = isAccordion && opts.collapsed !== false;
    const variantClass = opts.variant ? ' pd-band-' + opts.variant : '';
    const wrap = h('section', {
      class: 'pd-band' + variantClass + (isCollapsed ? ' is-collapsed' : '')
    });
    if (isAccordion) wrap.setAttribute('data-accordion', 'true');

    const inner = h('div', { class: 'pd-band-inner' });

    const iconZone = h('div', {
      class: 'pd-band-icon',
      html: opts.icon || '',
      'aria-hidden': 'true'
    });
    inner.appendChild(iconZone);

    const content = h('div', { class: 'pd-band-content' });

    if (opts.title || isAccordion) {
      const headerEl = h('div', { class: 'pd-band-header' });
      if (opts.title) headerEl.appendChild(h('span', { class: 'pd-band-title' }, opts.title));
      if (isAccordion) headerEl.appendChild(h('span', { class: 'pd-band-chevron' }, '▾'));
      content.appendChild(headerEl);
    }

    inner.appendChild(content);
    wrap.appendChild(inner);

    // V7 FIX accordéon — Listener click restreint au HEADER, plus sur le wrap
    // entier. Bug original (depuis création bandFrame commit 632502f) : un
    // click n'importe où dans la section togglait l'accordéon, donc cliquer
    // dans le body pour lire ou sélectionner du texte le fermait. Désormais
    // seul le header (titre + chevron + pill) est cliquable, le body reste
    // libre. Pattern cohérent avec les autres accordéons du quiz
    // (pd-result-alert-toggle, pd-alert-tier-toggle).
    if (isAccordion) {
      const headerEl = content.querySelector('.pd-band-header');
      if (headerEl) {
        headerEl.addEventListener('click', () => {
          wrap.classList.toggle('is-collapsed');
        });
      }
    }

    return { wrap: wrap, content: content };
  }

  // ─── BLOCK SOLUTION — "Réussir votre routine" ─────────────────────────
  // Bloc générique méthodologie (universel, indépendant du profil).
  // Accordéon fermé par défaut. 4 piliers : cohérence, patience, in&out, observance.
  function block_solution(_output) {
    const f = bandFrame({
      variant: 'solution',
      icon: SVG.heart,
      title: 'Réussir votre routine',
      accordion: true,
      collapsed: true
    });

    const body = h('div', { class: 'pd-band-body' });
    const inner = h('div', { class: 'pd-band-body-inner' });

    inner.appendChild(h('h4', {}, 'Une routine cohérente, pas une liste au hasard.'));
    inner.appendChild(h('p', {}, 'Votre pharmacienne a sélectionné chaque produit pour répondre à votre profil unique — peau, mode de vie, objectifs. Rien d’aléatoire, rien de superflu.'));

    inner.appendChild(h('h4', {}, 'La patience est la règle.'));
    const pPatience = h('p', {});
    pPatience.appendChild(document.createTextNode('La peau a son tempo. Comptez '));
    pPatience.appendChild(h('strong', {}, '4 à 8 semaines'));
    pPatience.appendChild(document.createTextNode(' avant les premiers résultats visibles : c’est le temps qu’il lui faut pour s’adapter et révéler le changement.'));
    inner.appendChild(pPatience);

    inner.appendChild(h('h4', {}, 'Une approche in & out.'));
    inner.appendChild(h('p', {}, 'Soins topiques et soutien nutritionnel ont été pensés ensemble. Une peau qui rayonne se construit autant de l’intérieur que de l’extérieur — c’est la cohérence du protocole qui crée la différence.'));

    inner.appendChild(h('h4', {}, 'Tenir, c’est gagner.'));
    const pTenir = h('p', {});
    pTenir.appendChild(document.createTextNode('Un protocole bien suivi donne de vrais résultats. Mieux vaut une routine simple, que vous tenez, qu’un rituel ambitieux abandonné. '));
    pTenir.appendChild(h('strong', {}, 'La régularité prime sur la quantité.'));
    inner.appendChild(pTenir);

    body.appendChild(inner);
    f.content.appendChild(body);

    // Pill "Conseil pharmacienne" sous le header, alignée droite (CSS handles)
    f.content.appendChild(h('span', { class: 'pd-band-pill' }, 'Conseil pharmacienne'));

    return f.wrap;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V3.35 SPRINT1-WHY-ROUTINE — Bloc accordéon "Pourquoi cette routine pour vous ?"
  //  V6 SPRINT2 — Refonte : ne contient plus QUE profil + actifs.
  //  Les alertes (computeAlertsList + tier_alert + grossesse) sont migrées
  //  dans block_vigilances() (point unique de sécurité).
  // ════════════════════════════════════════════════════════════════════════

  const WHY_ACTIFS = {
    CLEAR: [
      { actif: 'Acide salicylique', why: 'pénètre le pore obstrué et dissout la kératine en excès.' },
      { actif: 'Niacinamide', why: 'régule la production de sébum et réduit l’inflammation.' },
      { actif: 'SPF 50+', why: 'prévient les marques post-acné qui s’installent en quelques jours.' }
    ],
    CALM: [
      { actif: 'Centella asiatica', why: 'apaise les rougeurs et accélère la cicatrisation cutanée.' },
      { actif: 'Céramides', why: 'restaurent la barrière fragilisée qui laisse passer les irritants.' },
      { actif: 'Panthénol', why: 'hydrate en profondeur sans déclencher de réaction inflammatoire.' }
    ],
    EVEN: [
      { actif: 'Niacinamide 10%', why: 'régule la production de mélanine et unifie progressivement le teint.' },
      { actif: 'Acide tranexamique', why: 'cible spécifiquement les marques post-inflammatoires persistantes.' },
      { actif: 'SPF 50+ phototype', why: 'protection indispensable sans laquelle les actifs éclaircissants perdent leur efficacité.' }
    ],
    GLOW: [
      { actif: 'Acide glycolique', why: 'exfolie en douceur les cellules mortes qui ternissent le teint.' },
      { actif: 'Vitamine C stabilisée', why: 'stimule l’éclat et neutralise les radicaux libres du quotidien.' },
      { actif: 'Rétinol doux', why: 'accélère le renouvellement cellulaire pour une texture affinée.' }
    ],
    REPAIR: [
      { actif: 'Céramides', why: 'reconstruisent les jonctions serrées d’une barrière très fragilisée.' },
      { actif: 'Acide hyaluronique', why: 'restaure la capacité de rétention d’eau perdue par la barrière.' },
      { actif: 'Allantoïne', why: 'favorise la cicatrisation et réduit l’irritabilité chronique.' }
    ],
    LIFT: [
      { actif: 'Rétinol', why: 'stimule la synthèse de collagène et réduit visiblement les rides établies.' },
      { actif: 'Peptides', why: 'signalent aux fibroblastes de produire davantage de collagène et d’élastine.' },
      { actif: 'SPF 50+', why: 'le facteur n°1 du vieillissement cutané est le soleil — protection quotidienne indispensable.' }
    ],
    SAFE: [
      { actif: 'Formulation sans fragrance', why: 'élimine la première cause de sensibilisation cutanée.' },
      { actif: 'Sans rétinoïdes ni acides forts', why: 'respecte les critères de sécurité pour les peaux hypersensibles.' },
      { actif: 'Céramides & panthénol', why: 'renforcent la barrière sans risque de réaction.' }
    ],
    STRETCH: [
      { actif: 'Centella asiatica', why: 'stimule la production de collagène dans les zones de tension.' },
      { actif: 'Beurre de karité', why: 'nourrit en profondeur et améliore l’élasticité cutanée.' },
      { actif: 'Huile de rose musquée', why: 'atténue les vergetures existantes par action sur le tissu cicatriciel.' }
    ]
  };

  const WHY_SKIN_TYPE = {
    profil_peau_grasse: 'grasse',
    profil_peau_mixte: 'mixte',
    profil_peau_seche: 'sèche',
    profil_peau_normale: 'normale'
  };
  const WHY_BARRIER = {
    profil_barriere_normale: 'équilibrée',
    profil_barriere_fragile: 'fragile',
    profil_barriere_fragile_reactive: 'fragile et réactive'
  };
  const WHY_PHOTOTYPE = {
    phototype_I_II: 'I–II',
    phototype_III: 'III',
    phototype_IV_V_VI: 'IV–VI'
  };
  const WHY_CONCERN = {
    A: 'vos imperfections',
    B: 'vos taches brunes ou marques',
    C: 'vos rides ou la fermeté de votre peau',
    D: 'votre éclat et la fatigue cutanée',
    E: 'vos rougeurs ou votre sensibilité',
    F: 'votre sécheresse cutanée',
    G: 'votre masque de grossesse',
    H: 'vos vergetures'
  };
  const WHY_CRITICAL_TYPES = ['pregnancy', 'isotretinoine', 'acne_severe', 'rosacee'];

  function block_why_routine(output) {
    const profile = output.profile || {};
    const ans = (output._inputs && output._inputs.answers) || {};
    const packKey = profile.primary_pack || 'pack_LIFT';
    const packShort = packKey.replace('pack_', '');

    // Section "Votre profil" — texte dynamique
    const skinType = WHY_SKIN_TYPE[profile.skin_type];
    const barrier = WHY_BARRIER[profile.barrier_status];
    const photo = WHY_PHOTOTYPE[profile.phototype];
    const concern = WHY_CONCERN[ans.Q2_3];
    let profilText = '';
    if (skinType && barrier && photo) {
      profilText = 'Vous avez une peau ' + skinType + ' avec une barrière '
        + barrier + ' et un phototype ' + photo + '.';
    }
    if (concern) {
      profilText += (profilText ? ' ' : '') + 'Votre objectif principal est ' + concern + '.';
    }

    // Section "Pourquoi ces actifs"
    const actifs = WHY_ACTIFS[packShort] || [];

    // V7.3 — Notice SAFE pack (politique de sélection stricte) migrée ici
    // depuis ancien rendu standalone block2_header_notice.
    const safeNotice = output.block2_header_notice || null;

    // Si rien à afficher → return null
    if (!profilText && !actifs.length && !safeNotice) return null;

    const f = bandFrame({
      variant: 'why',
      icon: SVG.info,
      title: 'Pourquoi cette routine pour vous ?',
      accordion: true,
      collapsed: true
    });

    const body = h('div', { class: 'pd-band-body' });
    const inner = h('div', { class: 'pd-band-body-inner' });

    if (profilText) {
      inner.appendChild(h('h4', {}, 'Votre profil'));
      inner.appendChild(h('p', {}, profilText));
    }

    if (actifs.length) {
      inner.appendChild(h('h4', {}, 'Pourquoi ces actifs'));
      actifs.forEach(a => {
        inner.appendChild(h('p', {}, a.actif + ' : ' + a.why));
      });
    }

    // SAFE pack notice (sélection stricte grossesse/allaitement)
    if (safeNotice) {
      inner.appendChild(h('h4', {}, 'Politique de sélection SAFE'));
      inner.appendChild(h('p', {}, safeNotice));
    }

    body.appendChild(inner);
    f.content.appendChild(body);

    return f.wrap;
  }

  // ─── BLOCK VIGILANCES — alertes sécurité (accordéon ouvert par défaut) ─
  // V7.3 : passage en accordéon (was: visible non-accordéon). Ouvert au load
  // (signal "à lire") mais l'utilisatrice peut replier après lecture.
  // Source : computeAlertsList(output) + tier_alert + flag grossesse.
  // Point unique : ces données ne doivent plus apparaître ailleurs.
  // Retourne null si aucune alerte (le bloc n'apparaît que si nécessaire).
  function block_vigilances(output) {
    const profile = output.profile || {};
    const allAlerts = computeAlertsList(output);
    const tierAlertText = (output && output.alert_type) ? getTierAlertText(output) : null;
    const isPregnancy = profile.is_pregnant || profile.is_breastfeeding;

    // Construction de la liste d'items texte (1 entrée par alerte)
    const items = [];

    if (tierAlertText) {
      items.push({ text: tierAlertText, type: 'tier' });
    }

    allAlerts.forEach(a => {
      const copy = ALERT_COPY[a.type] || {};
      const text = copy.body || a.text || '';
      if (text) items.push({ text: text, type: a.type });
    });

    // Mention grossesse (si pas déjà couverte par l'alerte 'pregnancy')
    if (isPregnancy && !allAlerts.some(a => a.type === 'pregnancy')) {
      items.push({
        text: 'Demandez l’avis de votre médecin ou sage-femme avant de débuter.',
        type: 'pregnancy_mention'
      });
    }

    // V7 FIX retinoid_protocol — Intégration dans le même accordéon Vigilances
    // au lieu d'une note orpheline en bas de page. Le protocole rétinoïde
    // (RETINOL_DEBUTANT progressivité hebdo OU RETINOL_HABITUE 1 soir sur 2)
    // est une vigilance d'usage qui doit être lue par la cliente avant de
    // démarrer sa routine — il a sa place avec les autres alertes cliniques.
    if (output.retinoid_protocol && output.retinoid_protocol.protocol) {
      const profileLabel = output.retinoid_protocol.profile === 'RETINOL_DEBUTANT'
        ? 'Débutant(e)' : 'Habitué(e)';
      items.push({
        text: 'Protocole rétinoïde — ' + profileLabel + ' : ' + output.retinoid_protocol.protocol,
        type: 'retinoid'
      });
    }

    if (!items.length) return null;

    // Compte affiché dans le pill ("Sécurité · 2 points")
    const countLabel = items.length === 1 ? '1 point' : items.length + ' points';

    // V7 FIX — Accordéon fermé par défaut (cohérent avec les autres accordéons
    // du quiz), SAUF si une alerte critique est présente. Critères critiques :
    // pregnancy (grossesse/allaitement = filtres INCI stricts à connaître),
    // isotretinoine (récupération post-procédure = adaptation actifs),
    // tier (descent forcée par sécurité clinique = à comprendre). Ces 3 types
    // demandent lecture immédiate. Les autres (phototype, rosacee, acne_severe,
    // pregnancy_mention) restent dans l'accordéon fermé que la cliente ouvre
    // quand elle veut lire.
    const CRITICAL_TYPES = ['pregnancy', 'isotretinoine', 'tier'];
    const hasCritical = items.some(it => CRITICAL_TYPES.indexOf(it.type) !== -1);

    const f = bandFrame({
      variant: 'vigilance',
      icon: SVG.warning,
      title: 'Vigilances',
      accordion: true,
      collapsed: !hasCritical
    });

    // Insertion du pill en fin de header (aligné droite via CSS margin-left:auto)
    const header = f.content.querySelector('.pd-band-header');
    if (header) {
      header.insertBefore(
        h('span', { class: 'pd-band-pill' }, 'Sécurité · ' + countLabel),
        header.querySelector('.pd-band-chevron')
      );
    }

    // V7.3 — Liste enveloppée dans .pd-band-body pour que la transition
    // max-height de l'accordéon fonctionne sur la liste des vigilances.
    const body = h('div', { class: 'pd-band-body' });
    const list = h('ul', { class: 'pd-band-vigilance-list' });

    // V7 FIX ascent_optional — CTA "Passer à <TIER>" affiché sous l'item tier
    // quand l'algo a recalculé un niveau supérieur au choix initial de la cliente
    // (ex : choix OPTIMAL en Partie 1, profil expert détecté en Partie 2 →
    // tier_recalculated PREMIUM). On garde la philosophie respect du choix
    // initial (le protocole affiché reste sur le choix), MAIS on offre une
    // porte de sortie 1-clic au moment où la cliente lit la note clinique
    // qui explique pourquoi son profil correspondrait à un autre niveau.
    const showAscentCTA = output.alert_type === 'ascent_optional'
      && output.tier_recalculated
      && output.tier_recalculated !== output.tier_final;
    const targetTier = showAscentCTA ? output.tier_recalculated : null;

    items.forEach(it => {
      const li = h('li', { class: 'pd-band-vigilance-item' });
      li.appendChild(h('span', { class: 'pd-band-vigilance-bullet' }));
      const textWrap = h('div', { class: 'pd-band-vigilance-text-wrap' });
      textWrap.appendChild(h('p', { class: 'pd-band-vigilance-text' }, it.text));
      if (showAscentCTA && it.type === 'tier') {
        const cta = h('button', {
          class: 'pd-band-vigilance-cta',
          type: 'button'
        }, 'Passer à ' + targetTier + ' →');
        cta.addEventListener('click', (e) => {
          e.stopPropagation();
          upgradeTierToRecalculated(targetTier);
        });
        textWrap.appendChild(cta);
      }
      li.appendChild(textWrap);
      list.appendChild(li);
    });
    body.appendChild(list);
    f.content.appendChild(body);

    return f.wrap;
  }

  // V7 FIX ascent_optional — Handler du CTA "Passer à <TIER>". Relit l'output
  // depuis localStorage, modifie answers.tier_selected, re-fetch le catalogue,
  // relance ParaDermiaAlgo.run, écrit le nouveau output et reload la page.
  // Le reload est plus robuste qu'un re-render manuel : il garantit que tous
  // les blocs (produits, compléments, notices, etc.) reflètent le nouveau
  // niveau sans état résiduel.
  function upgradeTierToRecalculated(newTier) {
    var output;
    try { output = JSON.parse(localStorage.getItem(OUTPUT_KEY) || 'null'); }
    catch (_) { output = null; }
    if (!output || !output._inputs || !output._inputs.answers) {
      alert('Impossible de récupérer vos réponses. Recommencez le quiz.');
      return;
    }
    var answers = Object.assign({}, output._inputs.answers);
    answers.tier_selected = newTier;
    // V3.34f — Storefront live SEUL (plus de fallback catalogue offline).
    if (!(window.Shopify && window.PARADERMIA_STOREFRONT_TOKEN)) {
      alert('Configuration Storefront manquante pour ré-évaluer le niveau. Rechargez la page.');
      return;
    }
    fetchCatalogueFromStorefront().then(function(catalogue) {
      var newOutput = window.ParaDermiaAlgo.run(pdAlgoAnswers(answers), catalogue);
      // Préserve méta + flags ascent désormais éteints (on a accepté la hausse)
      newOutput._meta = output._meta;
      newOutput._inputs = Object.assign({}, output._inputs, { answers: answers });
      newOutput.tier_final = newTier;
      newOutput.tier_user_choice = newTier;
      newOutput.tier_recalculated = newTier;
      newOutput.alert_type = null;
      newOutput.alert_reason = null;
      newOutput.parcours = output.parcours;
      newOutput.mdv_light_answered = output.mdv_light_answered;
      try { localStorage.setItem(OUTPUT_KEY, JSON.stringify(newOutput)); } catch (_) {}
      window.location.reload();
    }).catch(function(err) {
      alert('Erreur lors de l\'ajustement du niveau : ' + (err && err.message ? err.message : err));
    });
  }

  // ─── BLOCK 5 — Compléments (item 11 sub : mention compatibilité grossesse) ──
  // V3.34d-RESULTS-COMPLEMENTS-LAYOUT-REDESIGN — Refonte du layout cartes
  // pour cohérence avec V3.34d-RESULTS-PRODUCTS-LAYOUT-REDESIGN (R2). Mobile :
  // carte horizontale image 150px gauche / contenu droite. Desktop : grille
  // 3 colonnes, cartes verticales image haut. Réutilise les sub-classes
  // génériques (.pd-product-image-zone, .pd-product-body, .pd-tier-badge,
  // .pd-add-button) pour bénéficier des styles R2 existants. Intro en
  // accordéon mobile avec label court "Une sélection pensée pour agir
  // de l'intérieur." Desktop : intro reste en plein texte.
  function block5_complements(o) {
    const wrap = h('section', { class: 'pd-block pd-block-5' });

    // V7 — Section title pattern unifié (eyebrow gold + Playfair + Raleway sub)
    const titleBlock = h('div', { class: 'pd-section-v7' });
    titleBlock.appendChild(h('div', { class: 'pd-section-v7-eyebrow' }, 'Soutien inside-out'));
    titleBlock.appendChild(h('h2', { class: 'pd-section-v7-h2' }, 'Vos compléments alimentaires'));
    titleBlock.appendChild(h('p', { class: 'pd-section-v7-sub' },
      'Une sélection pensée pour agir de l\'intérieur, en complément de votre routine topique.'));
    wrap.appendChild(titleBlock);

    const ans = (o._inputs && o._inputs.answers) || {};
    const isPregnant = ans.Q2_6 === 'A' || ans.Q2_6 === 'B';

    // V9 DUO — 1 complément mis en avant (le premier : l'algo ordonne
    // essentiel → recommandé → optionnel), le reste replié en accordéon et
    // non coché par défaut : le total affiché ne contient que du visible.
    const buildComplementCard = (c, featured) => {
      // Adaptation : compléments ont .notice qui devient la desc principale
      // si actifs_display absent. step="etape_complement" pour ne pas matcher
      // les règles SPF/OBLIGATOIRE de produits.
      const cProduct = Object.assign({}, c, {
        step: c.step || 'etape_complement',
        actifs_display: c.actifs_display || (c.notice ? [c.notice] : [])
      });
      const roleClass = featured ? r2DeriveRoleClass(c.role) : 'optionnel';
      _pdDisplayRole.set(c.id, roleClass);
      const card = r2BuildProductCard(cProduct, o, {
        role: roleClass,
        initialState: featured ? undefined : 'is-optional',
        compact: !featured
      });

      // Inject pregnancy line si profil enceinte (info clinique préservée)
      if (isPregnant) {
        const compat = c.pregnancy_status || c.pregnancy_notice;
        const line = (typeof compat === 'string' && /conditionnel/i.test(compat))
          ? 'Apport à adapter selon votre trimestre.'
          : 'Apport validé pendant la grossesse.';
        const pregLine = h('p', {
          class: 'pd-prod-v7-pregnancy',
          style: 'font-family:Raleway,sans-serif;font-size:1.15rem;color:#2D6A3F;font-style:italic;margin:0.4rem 1.8rem 1.2rem;padding:0.6rem 1.2rem;background:rgba(136,204,64,0.08);border-radius:8px;'
        }, line);
        // Insert avant le why-body
        const whyBody = card.querySelector('.pd-prod-v7-why-body');
        if (whyBody) card.insertBefore(pregLine, whyBody);
        else card.appendChild(pregLine);
      }
      return card;
    };

    const cpls = o.block5_complements || [];
    if (cpls.length) wrap.appendChild(buildComplementCard(cpls[0], true));
    const others = cpls.slice(1);
    if (others.length) {
      const moreGroup = h('div', { class: 'pd-confort-group is-collapsed' });
      const mToggle = h('button', {
        class: 'pd-confort-toggle', type: 'button', 'aria-expanded': 'false'
      });
      const mLabelWrap = h('span', { class: 'pd-confort-toggle-text' });
      mLabelWrap.appendChild(h('span', { class: 'pd-confort-toggle-label' },
        'Autres soutiens'));
      mLabelWrap.appendChild(h('span', { class: 'pd-confort-toggle-count' },
        others.length + ' complément' + (others.length > 1 ? 's' : '') + ' · optionnel'));
      mToggle.appendChild(mLabelWrap);
      mToggle.appendChild(h('span', { class: 'pd-confort-toggle-chevron' }, '▾'));
      mToggle.addEventListener('click', () => {
        const wasCollapsed = moreGroup.classList.contains('is-collapsed');
        moreGroup.classList.toggle('is-collapsed');
        mToggle.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
      });
      moreGroup.appendChild(mToggle);
      const mBody = h('div', { class: 'pd-confort-body-wrap' });
      const mInner = h('div', { class: 'pd-confort-body' });
      others.forEach(c => mInner.appendChild(buildComplementCard(c, false)));
      mBody.appendChild(mInner);
      moreGroup.appendChild(mBody);
      wrap.appendChild(moreGroup);
    }

    // Encadré médecin si grossesse — accordéon mobile (label court + corps).
    // Desktop : toggle masqué via CSS, corps toujours visible.
    if (isPregnant) {
      const pregnancyNotice = h('div', { class: 'pd-r3-pregnancy-notice is-collapsed' });
      const pToggle = h('button', {
        class: 'pd-r3-pregnancy-notice-toggle', type: 'button', 'aria-expanded': 'false'
      });
      pToggle.appendChild(h('span', { class: 'pd-r3-pregnancy-notice-label' },
        'Avis médical recommandé'));
      pToggle.appendChild(h('span', { class: 'pd-r3-pregnancy-notice-chevron' }, '▾'));
      pToggle.addEventListener('click', function() {
        const wasCollapsed = pregnancyNotice.classList.contains('is-collapsed');
        pregnancyNotice.classList.toggle('is-collapsed');
        pToggle.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
      });
      pregnancyNotice.appendChild(pToggle);
      const pBody = h('div', { class: 'pd-r3-pregnancy-notice-body-wrap' });
      pBody.appendChild(h('p', { class: 'pd-r3-pregnancy-notice-body' },
        'Demandez l\'avis de votre médecin ou sage-femme avant de débuter.'));
      pregnancyNotice.appendChild(pBody);
      wrap.appendChild(pregnancyNotice);
    }
    // V3.34d-2 — Mention nice-to-have : si parcours standard ET MDV-LIGHT skipé,
    // suggérer à la cliente de retoucher son quiz pour des recommandations
    // nutritionnelles plus personnalisées. parcours/mdv_light_answered persistés
    // dans output par finalize (cf V3.34d-2 modif runAlgo).
    // V3.34d-RESULTS-COMPLEMENTS-LAYOUT-REDESIGN — Passage en accordéon mobile.
    if (o.parcours === 'standard' && !o.mdv_light_answered) {
      const mdvMention = h('div', { class: 'pd-r3-mdv-mention is-collapsed' });
      const mToggle = h('button', {
        class: 'pd-r3-mdv-mention-toggle', type: 'button', 'aria-expanded': 'false'
      });
      mToggle.appendChild(h('span', { class: 'pd-r3-mdv-mention-label' },
        'Affiner mes recommandations'));
      mToggle.appendChild(h('span', { class: 'pd-r3-mdv-mention-chevron' }, '▾'));
      mToggle.addEventListener('click', function() {
        const wasCollapsed = mdvMention.classList.contains('is-collapsed');
        mdvMention.classList.toggle('is-collapsed');
        mToggle.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
      });
      mdvMention.appendChild(mToggle);
      const mBody = h('div', { class: 'pd-r3-mdv-mention-body-wrap' });
      mBody.appendChild(h('p', { class: 'pd-r3-mdv-mention-body' },
        'Pour des recommandations nutritionnelles plus personnalisées, vous pouvez retoucher votre quiz et indiquer vos habitudes de vie.'));
      mdvMention.appendChild(mBody);
      wrap.appendChild(mdvMention);
    }
    return wrap;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V3.10 R4 — Récap protocole : 2 accordéons (Essentiels statique +
  //  Sélectionnés dynamique branché sur _r2Selection).
  // ════════════════════════════════════════════════════════════════════════

  // Lookup id → { kind, brand, name, role, step? } construit à chaque rendu.
  const _r4ProductLookup = new Map();
  // V8 (demande Bilikiss) — Map handle→URL image récupérée via Storefront sur la
  // page résultats. Permet de patcher les vignettes produit MÊME sur un résultat
  // ancien (généré avant l'enrichissement image à la source dans finalize).
  const _resultsImageByHandle = {};
  // Refs DOM pour live update du bloc Sélectionnés.
  let _r4SelectedListEl = null;
  let _r4SelectedHeaderCount = null;
  let _r4SelectedBlockEl = null;
  // V7 FIX total recap — Refs DOM de la ligne total en pied du recap.
  let _r4TotalCountEl = null;
  let _r4TotalPriceEl = null;

  function r4BuildLookup(o) {
    _r4ProductLookup.clear();
    // V9 DUO — rôle unifié via _pdDisplayRole (curation Duo/Base/Confort).
    // 'hero' compte comme essentiel côté récap (locked + force-add) ; les
    // soins confort repliés ne sont plus force-ajoutés même si leur tag
    // catalogue est role_essentiel.
    const recapRole = (id, fallback) => {
      const r = _pdDisplayRole.get(id);
      if (r === 'hero') return 'essentiel';
      return r || fallback;
    };
    (o.block2_products || []).forEach(p => {
      _r4ProductLookup.set(p.id, {
        kind: 'product',
        id: p.id,
        brand: p.brand || '',
        name: p.name || '',
        role: recapRole(p.id, r2DeriveRoleClass(p.role)),
        step: p.step,
        handle: p.handle || ''
      });
    });
    (o.block5_complements || []).forEach(c => {
      _r4ProductLookup.set(c.id, {
        kind: 'complement',
        id: c.id,
        brand: c.brand || '',
        name: c.name || '',
        role: recapRole(c.id, c.role || 'recommande'),
        handle: c.handle || ''
      });
    });
    // V7.7 — Inclure les produits upsell corps (body_products) au lookup
    // pour qu'ils apparaissent dans le recap "Recommandés" lors d'un + Ajouter.
    // V9 DUO — pour STRETCH, les 2 premiers body_products sont les héros du
    // duo : recapRole les remonte en essentiel.
    const upsellProducts = (o.upsell_products && o.upsell_products.length)
      ? o.upsell_products
      : (o.body_products || []);
    upsellProducts.forEach(b => {
      if (_r4ProductLookup.has(b.id)) return; // dedup si déjà dans block2/block5
      _r4ProductLookup.set(b.id, {
        kind: 'body',
        id: b.id,
        brand: b.brand || '',
        name: b.name || '',
        role: recapRole(b.id, b.role || 'optionnel'),
        handle: b.handle || ''
      });
    });
  }

  function r4PluralProduit(n) {
    return n + ' produit' + (n > 1 ? 's' : '');
  }

  // V7 FIX prix recap — Formatage prix euros standard, partagé avec le total
  // recap et les blocs checkout/sticky. Décode aussi un Number sans virgule.
  function formatPriceEur(price) {
    if (typeof price !== 'number' || price <= 0) return null;
    return price.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €';
  }

  function r4BuildRecapRow(item, locked) {
    const row = h('div', {
      class: 'pd-recap-row' + (locked ? ' is-locked' : ''),
      // V7 FIX — data-product-id permet à applyPricesPatch de patcher le prix
      // après fetch (sinon le bloc Essentiels statique resterait sur "—").
      'data-product-id': item.id
    });
    row.appendChild(h('div', { class: 'pd-recap-check', html: SVG.check }));

    const info = h('div', { class: 'pd-recap-row-info' });
    info.appendChild(h('div', { class: 'pd-recap-row-brand' }, item.brand));
    info.appendChild(h('h4', { class: 'pd-recap-row-name' }, item.name));
    row.appendChild(info);

    const badgeText = ({ essentiel: 'Essentiel', recommande: 'Recommandé', optionnel: 'Confort' })[item.role];
    if (badgeText) {
      row.appendChild(h('span', {
        class: 'pd-recap-row-badge is-' + item.role
      }, badgeText));
    }

    // V7 FIX prix recap — Affiche le prix réel si disponible dans le lookup
    // (post fetch /products.js ou Storefront). Fallback "—" tant que le fetch
    // n'a pas peuplé item.price. applyPricesPatch ré-écrira ce span via le
    // data-product-id de la row pour les rows Essentiels qui sont statiques.
    const priceText = formatPriceEur(item.price) || '—';
    row.appendChild(h('span', { class: 'pd-recap-row-price' }, priceText));
    return row;
  }

  function r4UpdateSelected() {
    if (!_r4SelectedListEl || !_r4SelectedBlockEl || !_r4SelectedHeaderCount) return;

    const selectedItems = [];
    _r2Selection.added.forEach(id => {
      const item = _r4ProductLookup.get(id);
      if (item && item.role !== 'essentiel') selectedItems.push(item);
    });

    _r4SelectedListEl.innerHTML = '';
    if (selectedItems.length === 0) {
      _r4SelectedBlockEl.classList.add('is-hidden');
    } else {
      _r4SelectedBlockEl.classList.remove('is-hidden');
      selectedItems.forEach(item => _r4SelectedListEl.appendChild(r4BuildRecapRow(item, false)));
    }
    _r4SelectedHeaderCount.textContent = '— ' + r4PluralProduit(selectedItems.length);
    // V7 FIX total recap — Update synchrone du total après toute modif de sélection.
    r4UpdateTotal();
  }

  // V7 FIX total recap — Calcule le compteur et le prix total à afficher dans
  // la ligne de pied du recap. Compteur = nombre total d'items inclus (essentiels
  // locked + recommandés/optionnels sélectionnés). Prix = somme des item.price
  // disponibles. Si au moins un item du panier n'a pas son prix, fallback
  // "Calculé au panier" (cohérent avec checkout/sticky CTA).
  function r4UpdateTotal() {
    if (!_r4TotalCountEl || !_r4TotalPriceEl) return;
    const ids = Array.from(_r2Selection.added);
    const count = ids.length;
    _r4TotalCountEl.textContent = count + ' produit' + (count > 1 ? 's' : '');
    let total = 0;
    let hasAllPrices = count > 0;
    ids.forEach(id => {
      const item = _r4ProductLookup.get(id);
      const p = item && item.price;
      if (typeof p === 'number' && p > 0) total += p;
      else hasAllPrices = false;
    });
    if (hasAllPrices && total > 0) {
      _r4TotalPriceEl.textContent = formatPriceEur(total);
    } else {
      _r4TotalPriceEl.textContent = 'Calculé au panier';
    }
    // V8 (demande Bilikiss) — Sync le compteur + prix du sticky CTA en même
    // temps que le recap. Sans ça le sticky restait figé : son handler n'écoutait
    // que les clics .pd-add-button, pas les .pd-prod-v7-cta des cartes routine,
    // d'où la désync « recap = 6 / sticky = 5 ».
    if (typeof _stickyCtaUpdate === 'function') _stickyCtaUpdate();
  }

  function block_recap(o) {
    r4BuildLookup(o);

    const wrap = h('section', { class: 'pd-block pd-r4-section' });

    // Header
    const header = h('div', { class: 'pd-r4-header' });
    header.appendChild(h('h2', { class: 'pd-r4-title' }, 'Votre protocole complet'));
    header.appendChild(h('p', { class: 'pd-r4-subtitle' },
      'Ajustez votre sélection puis ajoutez le tout à votre panier.'));
    wrap.appendChild(header);

    // V7.4 — Accordéon "Un Protocole Cohérent" en tête du recap. Titre
    // hérite du style standard .pd-recap-block-title (Raleway uppercase),
    // cohérent avec Essentiels / Sélectionnés.
    const indBlock = h('div', { class: 'pd-recap-block pd-recap-indissociable is-collapsed' });
    const indHeader = h('div', { class: 'pd-recap-block-header' });
    indHeader.appendChild(h('span', { class: 'pd-recap-block-title' }, 'Un protocole cohérent'));
    indHeader.appendChild(h('span', { class: 'pd-recap-chevron', html: SVG.chevron }));
    indHeader.addEventListener('click', () => indBlock.classList.toggle('is-collapsed'));
    indBlock.appendChild(indHeader);
    const indBody = h('div', { class: 'pd-recap-block-body pd-recap-indissociable-body' });
    const indNote = h('p', { class: 'pd-recap-indissociable-text' });
    indNote.appendChild(document.createTextNode(
      'Chaque produit a été sélectionné pour la cohérence de l’ensemble, l’efficacité naît de leur synergie. '));
    indNote.appendChild(h('strong', {},
      'Cette routine ne peut exister sans ses essentiels.'));
    indBody.appendChild(indNote);
    const indCta = h('p', { class: 'pd-recap-indissociable-cta' });
    indCta.appendChild(document.createTextNode('Vous souhaitez un produit isolé ? '));
    indCta.appendChild(h('a', {
      href: '/collections',
      target: '_blank',
      rel: 'noopener',
      class: 'pd-recap-indissociable-link-inline'
    }, 'Consultez notre catalogue →'));
    indBody.appendChild(indCta);
    indBlock.appendChild(indBody);
    wrap.appendChild(indBlock);

    // Collecte des essentiels (locked, statiques)
    const essentialItems = [];
    _r4ProductLookup.forEach(item => {
      if (item.role === 'essentiel') {
        essentialItems.push(item);
        // V8 (demande Bilikiss) — Les essentiels (y compris un complément marqué
        // essentiel type PD-0342) sont TOUJOURS inclus dans le protocole : on les
        // ajoute à la sélection pour qu'ils soient comptés dans le total. Sinon un
        // essentiel affiché « inclus » dans le recap n'était pas compté → total <
        // nombre de lignes visibles (ex. recap 6 lignes mais total 5).
        _r2Selection.added.add(item.id);
      }
    });

    // BLOC 1 — Essentiels (accordéon ouvert par défaut)
    if (essentialItems.length > 0) {
      const block1 = h('div', { class: 'pd-recap-block' });
      const h1 = h('div', { class: 'pd-recap-block-header' });
      const t1 = h('span', { class: 'pd-recap-block-title' }, 'Essentiels');
      t1.appendChild(h('span', { class: 'pd-recap-block-title-count' },
        '— ' + r4PluralProduit(essentialItems.length)));
      h1.appendChild(t1);
      h1.appendChild(h('span', { class: 'pd-recap-chevron', html: SVG.chevron }));
      h1.addEventListener('click', () => block1.classList.toggle('is-collapsed'));
      block1.appendChild(h1);

      const body1 = h('div', { class: 'pd-recap-block-body' });
      essentialItems.forEach(item => body1.appendChild(r4BuildRecapRow(item, true)));

      // V7 — Footer note inline retiré : la pédagogie pack est désormais
      // gérée par le bandeau "Un Protocole Cohérent" plus haut dans le flow.

      block1.appendChild(body1);
      wrap.appendChild(block1);
    }

    // BLOC 2 — Sélectionnés (dynamique, mis à jour via r4UpdateSelected)
    _r4SelectedBlockEl = h('div', { class: 'pd-recap-block' });
    const h2 = h('div', { class: 'pd-recap-block-header' });
    const t2 = h('span', { class: 'pd-recap-block-title' }, 'Recommandés');
    _r4SelectedHeaderCount = h('span', { class: 'pd-recap-block-title-count' }, '— 0 produit');
    t2.appendChild(_r4SelectedHeaderCount);
    h2.appendChild(t2);
    h2.appendChild(h('span', { class: 'pd-recap-chevron', html: SVG.chevron }));
    h2.addEventListener('click', () => _r4SelectedBlockEl.classList.toggle('is-collapsed'));
    _r4SelectedBlockEl.appendChild(h2);

    const body2 = h('div', { class: 'pd-recap-block-body' });
    _r4SelectedListEl = h('div', { class: 'pd-recap-list' });
    body2.appendChild(_r4SelectedListEl);
    _r4SelectedBlockEl.appendChild(body2);
    wrap.appendChild(_r4SelectedBlockEl);

    // V7 FIX total recap — Ligne total en pied du recap, dynamique. Affiche
    // le nombre total d'items inclus dans le protocole (essentiels + sélectionnés)
    // et le prix cumulé. Update à chaque toggle CTA via r4UpdateSelected qui
    // appelle r4UpdateTotal, et après fetch des prix via applyPricesPatch.
    const totalRow = h('div', { class: 'pd-recap-total-row' });
    const totalLeft = h('div', { class: 'pd-recap-total-left' });
    totalLeft.appendChild(h('span', { class: 'pd-recap-total-label' }, 'Total protocole'));
    _r4TotalCountEl = h('span', { class: 'pd-recap-total-count' }, '0 produit');
    totalLeft.appendChild(_r4TotalCountEl);
    totalRow.appendChild(totalLeft);
    _r4TotalPriceEl = h('span', { class: 'pd-recap-total-price' }, 'Calculé au panier');
    totalRow.appendChild(_r4TotalPriceEl);
    wrap.appendChild(totalRow);

    // Population initiale (recommandés default + optionnels init non-ajoutés)
    // r4UpdateSelected déclenche aussi r4UpdateTotal pour synchroniser la ligne total.
    r4UpdateSelected();

    return wrap;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V3.11 R5 — Upsell corps : carrousel + arrows + dots + swipe touch
  //  Source : output.body_products (algo) + collection éditoriale "corps"
  //  (à venir avec Storefront token). Gate : skip si pack_STRETCH (corps =
  //  protocole principal pour ce pack, pas d'upsell additionnel).
  // ════════════════════════════════════════════════════════════════════════

  // V3.34d-RESULTS-ADDON-CORPS — Refonte visuelle des cartes corps pour
  // adopter le pattern Compléments redesign (sub-classes génériques
  // .pd-product-image-zone, .pd-product-body, .pd-tier-badge, .pd-add-button).
  // Tous les produits corps sont en tier Confort (rôle optionnel) par défaut.
  // Pas de badge moment (matin/soir non pertinent pour les soins corps).
  function r5BuildBodyCard(product, fromAlgo) {
    const role = 'optionnel';
    const initialCtaState = r2InitialState(role);
    _r2Selection.state.set(product.id, initialCtaState);

    const card = h('article', {
      class: 'pd-body-card',
      'data-product-id': product.id,
      'data-role': role
    });

    // Image zone (réutilise classe générique R2/Compléments)
    const imgZone = h('div', { class: 'pd-product-image-zone' });
    if (product.image_url || product.image) {
      imgZone.appendChild(h('img', {
        src: product.image_url || product.image,
        alt: product.name || '', loading: 'lazy'
      }));
    } else {
      const placeholder = h('div', { class: 'pd-product-image-placeholder' });
      placeholder.appendChild(h('div', { class: 'pd-product-image-placeholder-icon', html: SVG.bottle }));
      placeholder.appendChild(h('span', { class: 'pd-product-image-placeholder-label' }, 'Photo produit'));
      imgZone.appendChild(placeholder);
    }
    // Badge tier "Confort" top-left (pattern unifié)
    imgZone.appendChild(h('span', { class: 'pd-tier-badge pd-tier-' + role }, 'Confort'));
    // Tag "Pour votre profil" (cas algo) préservé
    if (fromAlgo) {
      const tag = h('span', { class: 'pd-body-profile-tag' });
      tag.appendChild(h('span', { html: SVG.star, style: 'display:inline-flex' }));
      tag.appendChild(document.createTextNode('Pour votre profil'));
      imgZone.appendChild(tag);
    }
    card.appendChild(imgZone);

    // Body : brand + nom + tags max 2 + CTA
    const body = h('div', { class: 'pd-product-body' });
    body.appendChild(h('div', { class: 'pd-product-brand' }, product.brand || ''));
    body.appendChild(h('h3', { class: 'pd-product-name' }, product.name || ''));

    const actifsArr = product.actifs_display || product.actifs || [];
    if (Array.isArray(actifsArr) && actifsArr.length) {
      const actifs = h('div', { class: 'pd-product-actifs' });
      actifsArr.slice(0, 2).forEach(a => actifs.appendChild(h('span', { class: 'pd-actif-tag' }, a)));
      body.appendChild(actifs);
    }

    // CTA "+ Ajouter" en is-optional (pattern unifié, alimente _r2Selection)
    const cta = h('button', {
      class: 'pd-add-button ' + initialCtaState,
      type: 'button',
      'data-role': role,
      'data-product-id': product.id
    }, r2CtaText(role, initialCtaState));
    cta.addEventListener('click', () => r5HandleBodyClick(cta, product));
    body.appendChild(cta);

    card.appendChild(body);
    return card;
  }

  // V3.34d-RESULTS-ADDON-CORPS — Wrapper qui assure que le produit corps est
  // dans _r4ProductLookup AVANT l'update r4UpdateSelected (les produits corps
  // ne sont ni dans block2_products ni dans block5_complements donc absents
  // du lookup construit par r4BuildLookup).
  function r5HandleBodyClick(btn, product) {
    if (!_r4ProductLookup.has(product.id)) {
      _r4ProductLookup.set(product.id, {
        kind: 'body', id: product.id,
        brand: product.brand || '', name: product.name || '',
        role: 'optionnel',
        handle: product.handle || ''
      });
    }
    r2HandleCtaClick(btn, 'optionnel', product.id);
  }

  // r5ToggleBodyAdd : conservée pour rétro-compat (cas migrations état),
  // pas appelée dans la nouvelle implémentation.
  function r5ToggleBodyAdd(btn, product, fromAlgo) {
    const isAdded = btn.classList.toggle('is-added');
    btn.textContent = isAdded ? '✓ Ajouté' : '+ Ajouter';
    if (isAdded) {
      _r2Selection.added.add(product.id);
      _r2Selection.state.set(product.id, 'is-added');
      if (!_r4ProductLookup.has(product.id)) {
        _r4ProductLookup.set(product.id, {
          kind: 'body', id: product.id,
          brand: product.brand || '', name: product.name || '',
          role: 'optionnel',
          handle: product.handle || ''
        });
      }
    } else {
      _r2Selection.added.delete(product.id);
      _r2Selection.state.set(product.id, 'is-optional');
    }
    if (typeof r4UpdateSelected === 'function') r4UpdateSelected();
    if (typeof r6UpdateTotal === 'function') r6UpdateTotal();
  }

  function r5InitCarousel(viewport, track, arrowLeft, arrowRight, dots) {
    const cards = track.querySelectorAll('.pd-body-card');
    if (!cards.length) return;
    const GAP = 14;
    let visible = 3;
    let cardWidth = 0;
    let currentIndex = 0;
    let maxIndex = 0;

    function applyLayout() {
      const wrapWidth = viewport.clientWidth;
      if (wrapWidth < 480) visible = 1;
      else if (wrapWidth < 760) visible = 2;
      else visible = 3;
      cardWidth = (wrapWidth - GAP * (visible - 1)) / visible;
      cards.forEach(c => { c.style.flex = '0 0 ' + cardWidth + 'px'; });

      if (cards.length <= visible) {
        track.style.transform = 'translateX(0)';
        maxIndex = 0; currentIndex = 0;
        arrowLeft.disabled = true;
        arrowRight.disabled = true;
        dots.style.display = 'none';
        return;
      }
      maxIndex = cards.length - visible;
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      dots.style.display = '';
      updateTransform();
      buildDots();
      updateArrows();
    }

    function updateTransform() {
      const offset = currentIndex * (cardWidth + GAP);
      track.style.transform = 'translateX(-' + offset + 'px)';
    }
    function updateArrows() {
      arrowLeft.disabled = currentIndex <= 0;
      arrowRight.disabled = currentIndex >= maxIndex;
    }
    function markActiveDot() {
      dots.querySelectorAll('.pd-carousel-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === currentIndex);
      });
    }
    function buildDots() {
      dots.innerHTML = '';
      const dotCount = maxIndex + 1;
      for (let i = 0; i < dotCount; i++) {
        const d = h('button', {
          class: 'pd-carousel-dot' + (i === currentIndex ? ' is-active' : ''),
          type: 'button',
          'aria-label': 'Position ' + (i + 1)
        });
        d.addEventListener('click', () => {
          currentIndex = i; updateTransform(); updateArrows(); markActiveDot();
        });
        dots.appendChild(d);
      }
    }

    arrowLeft.addEventListener('click', () => {
      if (currentIndex > 0) { currentIndex--; updateTransform(); updateArrows(); markActiveDot(); }
    });
    arrowRight.addEventListener('click', () => {
      if (currentIndex < maxIndex) { currentIndex++; updateTransform(); updateArrows(); markActiveDot(); }
    });

    // Touch swipe
    let touchStart = null;
    track.addEventListener('touchstart', e => { touchStart = e.changedTouches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      if (touchStart == null) return;
      const delta = e.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 40) {
        if (delta < 0 && currentIndex < maxIndex) currentIndex++;
        else if (delta > 0 && currentIndex > 0) currentIndex--;
        updateTransform(); updateArrows(); markActiveDot();
      }
      touchStart = null;
    }, { passive: true });

    // Resize debounced
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyLayout, 150);
    });

    applyLayout();
  }

  // V9 DUO — dead code : plus appelé depuis renderResults. Les soins corps
  // STRETCH sont intégrés au duo/confort via computeDisplayGroups ; les autres
  // packs passent par block_upsell_corps.
  function blockBody(o) {
    // Gate user spec : skip si pack_STRETCH (corps = protocole principal).
    if (o.profile && o.profile.primary_pack === 'pack_STRETCH') return null;

    const algoProducts = o.body_products || [];
    // TODO Storefront : merger produits éditoriaux collection "corps" ici.
    const editorialProducts = [];

    if (algoProducts.length === 0 && editorialProducts.length === 0) return null;

    const wrap = h('section', { class: 'pd-block pd-r5-section' });

    // Section divider
    wrap.appendChild(h('div', { class: 'pd-section-divider' }, 'N\'oubliez pas votre corps'));

    // Header avec titre + arrows
    const header = h('div', { class: 'pd-r5-header' });
    const headerLeft = h('div');
    headerLeft.appendChild(h('h2', { class: 'pd-r5-title' },
      'Une routine corps adaptée à votre profil'));
    headerLeft.appendChild(h('p', { class: 'pd-r5-subtitle' },
      'Une sélection pensée pour compléter votre routine visage, du quotidien au soin ciblé.'));
    header.appendChild(headerLeft);

    const controls = h('div', { class: 'pd-r5-controls' });
    const arrowLeft = h('button', {
      class: 'pd-carousel-arrow', type: 'button', 'aria-label': 'Précédent', html: SVG.arrow_left
    });
    const arrowRight = h('button', {
      class: 'pd-carousel-arrow', type: 'button', 'aria-label': 'Suivant', html: SVG.arrow_right
    });
    controls.appendChild(arrowLeft);
    controls.appendChild(arrowRight);
    header.appendChild(controls);
    wrap.appendChild(header);

    // Viewport + track
    const viewport = h('div', { class: 'pd-carousel-viewport' });
    const track = h('div', { class: 'pd-carousel-track' });
    // Algo en premier (avec badge "Pour votre profil"), puis éditoriaux (sans badge)
    algoProducts.forEach(p => track.appendChild(r5BuildBodyCard(p, true)));
    editorialProducts.forEach(p => track.appendChild(r5BuildBodyCard(p, false)));
    viewport.appendChild(track);
    wrap.appendChild(viewport);

    // Dots
    const dots = h('div', { class: 'pd-carousel-dots' });
    wrap.appendChild(dots);

    // Wire après injection DOM (clientWidth dispo)
    requestAnimationFrame(() => r5InitCarousel(viewport, track, arrowLeft, arrowRight, dots));

    return wrap;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  V3.12 R6 — Checkout block : total + 3 boutons + réassurance footer
  //  Remplace blockCartSelector. Branché sur _r2Selection.added (état partagé
  //  R2/R3/R5) avec live update via r6UpdateTotal sur chaque toggle CTA.
  // ════════════════════════════════════════════════════════════════════════

  let _r6TotalCountEl = null;
  let _r6TotalPriceEl = null;
  let _r6PrimaryBtnEl = null;

  function r6UpdateTotal() {
    if (!_r6TotalCountEl || !_r6TotalPriceEl) return;
    const ids = Array.from(_r2Selection.added);
    const count = ids.length;
    _r6TotalCountEl.textContent = count + ' produit' + (count > 1 ? 's' : '');
    // V7.13 — Calcul total quand prix Storefront disponibles dans le lookup.
    // Si tous les essentiels n'ont pas leur prix → fallback "Calculé au panier".
    let total = 0;
    let hasAllPrices = count > 0;
    ids.forEach(id => {
      const item = _r4ProductLookup.get(id);
      const p = item && item.price;
      if (typeof p === 'number' && p > 0) {
        total += p;
      } else {
        hasAllPrices = false;
      }
    });
    if (hasAllPrices && total > 0) {
      _r6TotalPriceEl.textContent = total.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €';
    } else {
      _r6TotalPriceEl.textContent = 'Calculé au panier';
    }
    if (_r6PrimaryBtnEl) _r6PrimaryBtnEl.disabled = (count === 0);
  }

  // V7.13 — Fetch Storefront prix pour les produits du résultat. Non-bloquant.
  // Patch _r4ProductLookup avec les prix puis re-render les cartes + total.
  // Si pas de token configuré → no-op (Storefront token est optionnel).
  function fetchPricesForResults(output) {
    // V7 FIX prix dynamique — Refactor pour utiliser /products/{handle}.js qui
    // est public (PAS besoin de Storefront token), via le helper lookupVariantId
    // existant qui cache déjà les résultats. Avant : la fonction dépendait du
    // Storefront token configuré dans Theme Editor ; sans token elle retournait
    // null et aucun prix n'était récupéré, d'où le fallback permanent "Calculé
    // au panier" sur le total et l'absence de prix sur les cards produits.
    // Nouveau pattern : Promise.all de lookupVariantId pour chaque handle, en
    // parallèle, avec catch local pour qu'un handle 404 ne casse pas le batch.
    // Si window.PARADERMIA_STOREFRONT_TOKEN est défini, la fonction l'utilise
    // toujours en GraphQL Storefront (plus efficace, 1 requête vs N) ; sinon
    // fallback Promise.all /products/{handle}.js public.
    const handles = new Set();
    (output.block2_products || []).forEach(p => p.handle && handles.add(p.handle));
    (output.block5_complements || []).forEach(c => c.handle && handles.add(c.handle));
    (output.body_products || []).forEach(b => b.handle && handles.add(b.handle));
    if (handles.size === 0) return Promise.resolve(null);
    const handlesArr = Array.from(handles);

    // Voie 1 — Storefront GraphQL si token configuré (plus efficace).
    if (window.PARADERMIA_STOREFRONT_TOKEN && window.Shopify && window.Shopify.shop) {
      const queryParts = handlesArr.map((handle, i) =>
        `p${i}: productByHandle(handle: ${JSON.stringify(handle)}) {
          handle
          variants(first: 10) { edges { node { title price { amount } } } }
          images(first: 1) { edges { node { url } } }
        }`
      );
      const query = `query { ${queryParts.join('\n')} }`;
      return fetch(`https://${window.Shopify.shop}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.PARADERMIA_STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query })
      })
      .then(r => r.json())
      .then(data => {
        if (!data || !data.data) return null;
        const prices = {};
        Object.values(data.data).forEach(p => {
          if (!p || !p.handle) return;
          // V9.1 — prix de la variante vendable (jamais un format découverte).
          const variant = pdSellableVariants((p.variants && p.variants.edges || []).map(x => x.node))[0];
          const amount = variant && variant.price && parseFloat(variant.price.amount);
          if (!isNaN(amount) && amount > 0) prices[p.handle] = amount;
          // V8 — collecte l'URL image pour patcher les vignettes (couvre les
          // résultats anciens sans image enrichie à la source).
          const imgNode = p.images && p.images.edges && p.images.edges[0] && p.images.edges[0].node;
          if (imgNode && imgNode.url) _resultsImageByHandle[p.handle] = imgNode.url;
        });
        applyImagesPatch();
        return prices;
      })
      .catch(err => {
        console.warn('[ParaDermia] Storefront prices fetch failed, fallback /products.js:', err);
        return fetchPricesViaProductsJson(handlesArr);
      });
    }

    // Voie 2 — Fallback public /products/{handle}.js (pas de token requis).
    return fetchPricesViaProductsJson(handlesArr);
  }

  // V7 FIX prix dynamique — Fallback public via /products/{handle}.js. Parallel
  // via Promise.all. lookupVariantId retourne {price} en CENTIMES Shopify
  // (entier), on divise par 100 pour avoir des euros décimaux compatibles
  // avec le format de r6UpdateTotal.
  function fetchPricesViaProductsJson(handlesArr) {
    if (!handlesArr || handlesArr.length === 0) return Promise.resolve(null);
    const lookups = handlesArr.map(handle =>
      lookupVariantId(handle)
        .then(info => ({ handle: handle, price: info && info.price }))
        .catch(() => null)
    );
    return Promise.all(lookups).then(results => {
      const prices = {};
      results.forEach(r => {
        if (!r || !r.handle || typeof r.price !== 'number') return;
        // /products/X.js retourne TOUJOURS le prix en centimes (entier).
        // Conversion inconditionnelle. L'ancienne heuristique (> 1000) laissait
        // passer les prix < 10 € tels quels : 499 centimes s'affichait 499 €
        // (vu en test réel sur la variante Découverte 4,99 € du Nettoyant Lacté).
        const eur = r.price / 100;
        if (eur > 0) prices[r.handle] = eur;
      });
      return Object.keys(prices).length > 0 ? prices : null;
    }).catch(err => {
      console.warn('[ParaDermia] /products.js fallback failed:', err);
      return null;
    });
  }

  // V7.13 — Patch lookup + DOM cards + total après fetch Storefront.
  function applyPricesPatch(prices) {
    if (!prices || Object.keys(prices).length === 0) return;
    // Patch lookup
    _r4ProductLookup.forEach((item) => {
      if (item.handle && prices[item.handle]) {
        item.price = prices[item.handle];
      }
    });
    // Patch rendered card prices
    document.querySelectorAll('.pd-prod-v7[data-product-id]').forEach(card => {
      const id = card.dataset.productId;
      const item = _r4ProductLookup.get(id);
      if (item && typeof item.price === 'number' && item.price > 0) {
        const priceEl = card.querySelector('.pd-prod-v7-price:not(.pd-prod-v7-price--free)');
        if (priceEl) {
          priceEl.textContent = item.price.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €';
        }
      }
    });
    r6UpdateTotal();
    // V7 FIX sticky CTA prix — Trigger update du sticky après que les prix
    // sont patché dans le lookup, sinon le sticky reste sur "calculé au
    // panier" jusqu'au prochain click.
    if (typeof _stickyCtaUpdate === 'function') _stickyCtaUpdate();
    // V7 FIX prix recap — Patch les prix dans les rows du recap (bloc
    // Essentiels rendu statiquement au montage + bloc Recommandés dynamique).
    // Sans ce patch, le bloc Essentiels resterait sur "—" même après fetch.
    document.querySelectorAll('.pd-recap-row[data-product-id]').forEach(row => {
      const id = row.dataset.productId;
      const item = _r4ProductLookup.get(id);
      if (item && typeof item.price === 'number' && item.price > 0) {
        const priceEl = row.querySelector('.pd-recap-row-price');
        if (priceEl) priceEl.textContent = formatPriceEur(item.price);
      }
    });
    // V7 FIX total recap — Re-render la ligne total après patch des prix.
    if (typeof r4UpdateTotal === 'function') r4UpdateTotal();
  }

  // V8 (demande Bilikiss) — Patch les VIGNETTES produit après fetch Storefront.
  // L'enrichissement à la source (finalize) couvre les nouveaux parcours ; ce
  // patch couvre EN PLUS les résultats anciens (sans image) et tout cas où la
  // carte est restée en placeholder : si l'image manque, on l'injecte par handle.
  function applyImagesPatch() {
    if (!_resultsImageByHandle || Object.keys(_resultsImageByHandle).length === 0) return;
    const setImg = (zone, url, alt) => {
      if (!zone || !url) return;
      const existing = zone.querySelector('img');
      if (existing) { if (!existing.getAttribute('src')) existing.setAttribute('src', url); return; }
      const ph = zone.querySelector('.pd-product-image-placeholder, span');
      if (ph) ph.remove();
      const img = document.createElement('img');
      img.src = url; img.alt = alt || ''; img.loading = 'lazy';
      zone.appendChild(img);
    };
    document.querySelectorAll('[data-product-id]').forEach(card => {
      const item = _r4ProductLookup.get(card.dataset.productId);
      const url = item && item.handle && _resultsImageByHandle[item.handle];
      if (!url) return;
      const zone = card.querySelector('.pd-prod-v7-image, .pd-product-image-zone, .pd-product-image');
      setImg(zone, url, item.name);
    });
  }

  // V3.34d-RESULTS-CTA-CHECKOUT-REDESIGN — Bloc final unifié vert sombre.
  // Structure : recap (eyebrow + count + titre routine), total estimé, CTA
  // principal OR, liens secondaires (email + restart), zone trust (badges
  // raccourcis + mention pharmacien + mention légale).
  // V7.8 SPRINT2 — Refonte block_checkout : footer du recap intégré.
  // Fond cream rgba(45,106,63,0.04), pas de bg vert foncé saturé.
  // Titre "Protocole [Pack] Niveau" avec accent italique sur le pack uniquement.
  // Dédicace "— pour {firstName} —" en Raleway italic vert moyen.
  // CTA vert foncé solid + texte vert citron, hover inversion.
  // Trust band 4 items (drop "Conseils pharmacienne" qui faisait doublon
  // avec la mention pharmacienne plus bas).
  function block_checkout(o) {
    const wrap = h('section', { class: 'pd-block pd-block-checkout pd-checkout-v7' });

    const packShort = (o.profile && o.profile.primary_pack || 'pack_LIFT').replace('pack_', '');
    const niveauRaw = o.niveau_label || 'OPTIMAL';
    const levelLabel = niveauRaw.charAt(0) + niveauRaw.slice(1).toLowerCase();
    const packDisplay = packShort.charAt(0) + packShort.slice(1).toLowerCase();
    wrap.setAttribute('data-pack', packShort);

    const firstName = (o._meta && o._meta.firstName && o._meta.firstName.trim())
      ? o._meta.firstName.trim()
      : null;

    // === Méta header : TOTAL PROTOCOLE · count ===
    const meta = h('div', { class: 'pd-checkout-v7-meta' });
    meta.appendChild(h('span', { class: 'pd-checkout-v7-meta-label' }, 'Total Protocole'));
    _r6TotalCountEl = h('span', { class: 'pd-checkout-v7-meta-count' }, '0 produit');
    meta.appendChild(_r6TotalCountEl);
    wrap.appendChild(meta);

    // === Titre : Protocole [Pack] Niveau ===
    const title = h('h2', { class: 'pd-checkout-v7-title' });
    title.appendChild(document.createTextNode('Protocole '));
    title.appendChild(h('em', {}, packDisplay));
    title.appendChild(document.createTextNode(' ' + levelLabel));
    wrap.appendChild(title);

    // === Dédicace prénom ===
    const dedicationText = firstName ? '— pour ' + firstName + ' —' : '— pour vous —';
    wrap.appendChild(h('p', { class: 'pd-checkout-v7-dedication' }, dedicationText));

    // === Hairline gold ===
    wrap.appendChild(h('div', { class: 'pd-checkout-v7-divider' }));

    // === Total estimé ===
    const totalRow = h('div', { class: 'pd-checkout-v7-total' });
    totalRow.appendChild(h('span', { class: 'pd-checkout-v7-total-label' }, 'Total estimé'));
    _r6TotalPriceEl = h('span', { class: 'pd-checkout-v7-total-value' }, 'Calculé au panier');
    totalRow.appendChild(_r6TotalPriceEl);
    wrap.appendChild(totalRow);

    // === CTA principal — Ajouter au panier ===
    _r6PrimaryBtnEl = h('button', {
      class: 'pd-checkout-v7-cta', type: 'button'
    });
    _r6PrimaryBtnEl.appendChild(document.createTextNode('Ajouter au panier'));
    _r6PrimaryBtnEl.appendChild(h('span', { class: 'pd-checkout-v7-cta-arrow' }, '→'));
    _r6PrimaryBtnEl.addEventListener('click', () => {
      const items = [];
      _r2Selection.added.forEach(id => {
        const item = _r4ProductLookup.get(id);
        if (item && item.handle) {
          items.push({ handle: item.handle, quantity: 1, label: item.name });
        }
      });
      if (typeof handleAddProtocol === 'function') {
        handleAddProtocol(items, packShort);
      }
    });
    wrap.appendChild(_r6PrimaryBtnEl);

    // === Liens secondaires (email + restart) ===
    const secondary = h('div', { class: 'pd-checkout-v7-secondary' });
    const emailLink = h('button', {
      class: 'pd-checkout-v7-link', type: 'button'
    }, 'Télécharger ma notice (PDF)');
    emailLink.addEventListener('click', () => pdDownloadNoticePdf(o));
    secondary.appendChild(emailLink);
    const restartLink = h('a', {
      class: 'pd-checkout-v7-link', href: '#'
    }, 'Recommencer mon analyse');
    restartLink.addEventListener('click', (e) => {
      e.preventDefault();
      try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
      try { localStorage.removeItem(OUTPUT_KEY); } catch (_) {}
      try { localStorage.removeItem(PACK_KEY); } catch (_) {}
      const quizUrl = (window.PARADERMIA_QUIZ_URL) || '/pages/quiz';
      window.location.href = quizUrl;
    });
    secondary.appendChild(restartLink);
    wrap.appendChild(secondary);

    // === Trust band — 4 items ===
    const trust = h('div', { class: 'pd-checkout-v7-trust' });
    const trustItems = [
      { svg: SVG.truck,    text: 'Point relais offert dès 39 €' },
      { svg: SVG.refund,   text: 'Retours gratuits' },
      { svg: SVG.bookmark, text: 'Sauvegardé dans votre espace membre' },
      { svg: SVG.lock,     text: 'Paiement sécurisé' }
    ];
    trustItems.forEach(it => {
      const item = h('span', { class: 'pd-checkout-v7-trust-item' });
      item.appendChild(h('span', { class: 'pd-checkout-v7-trust-icon', html: it.svg }));
      item.appendChild(document.createTextNode(' ' + it.text));
      trust.appendChild(item);
    });
    wrap.appendChild(trust);

    // V7.9 — Mention pharmacienne + disclaimer légal retirés (déjà présents
    // sur pages d'accroche + alertes pendant le quiz). Footer allégé.

    // Sync initial state (compteur + bouton disabled si 0)
    requestAnimationFrame(() => r6UpdateTotal());

    return wrap;
  }

  // ════════════════════════════════════════════════════════════════════════
  //  ITEM 9 — Sélecteur panier (essentiels verrouillés / recommandés / optionnels)
  //  V3.12 — DEPRECATED : remplacé par block_checkout (R6). Conservé en
  //  dead code pour traçabilité, mais plus appelé depuis renderResults.
  // ════════════════════════════════════════════════════════════════════════

  function blockCartSelector(o) {
    const products = o.block2_products || [];
    const complements = o.block5_complements || [];

    // Catégorisation
    const essentiels = products.filter(p => p.role === 'role_essentiel' || p.role === 'role_obligatoire');
    const recommandes = products.filter(p => p.role === 'role_optionnel' || p.role === 'role_selon_profil');
    const optionnels = products.filter(p => !p.role);

    const compEssentiels = complements.filter(c => c.role === 'essentiel');
    const compRecommandes = complements.filter(c => c.role === 'recommande');
    const compOptionnels = complements.filter(c => c.role === 'optionnel');

    const packKey = (o.profile && o.profile.primary_pack) || 'pack_LIFT';
    const packName = (ROUTINE_DISPLAY_UI[packKey] || {}).name || 'Routine';

    const wrap = h('section', { class: 'pd-block-cart' });
    wrap.appendChild(h('h2', { class: 'pd-cart-title' }, 'Votre protocole complet'));
    wrap.appendChild(h('p', { class: 'pd-cart-subtitle' },
      'Ajustez votre sélection puis ajoutez le tout à votre panier.'));

    // ── Groupe Essentiels (verrouillés)
    if (essentiels.length) {
      const grp = h('div', { class: 'pd-cart-group' });
      grp.appendChild(h('div', { class: 'pd-cart-group-label' }, 'Essentiels'));
      essentiels.forEach(p => grp.appendChild(cartRow(p, 'essentiel', { locked: true, defaultChecked: true })));
      grp.appendChild(h('div', {
        class: 'pd-cart-group-note',
        html: 'Ces produits forment le socle de votre protocole. Utilisés ensemble, ils créent une synergie d\'action que chaque produit seul ne peut pas atteindre. Les protocoles Paradermia sont construits autour de leurs essentiels — si vous souhaitez explorer nos produits individuellement, <a href="/collections">notre parapharmacie</a> est là pour vous.'
      }));
      wrap.appendChild(grp);
    }

    // ── Groupe Recommandés (cochés par défaut)
    if (recommandes.length) {
      const grp = h('div', { class: 'pd-cart-group' });
      grp.appendChild(h('div', { class: 'pd-cart-group-label' }, 'Recommandés'));
      recommandes.forEach(p => grp.appendChild(cartRow(p, 'recommande', { defaultChecked: true })));
      wrap.appendChild(grp);
    }

    // ── Groupe Optionnels
    if (optionnels.length) {
      const grp = h('div', { class: 'pd-cart-group' });
      grp.appendChild(h('div', { class: 'pd-cart-group-label' }, 'Optionnels'));
      optionnels.forEach(p => grp.appendChild(cartRow(p, 'optionnel', { defaultChecked: false })));
      wrap.appendChild(grp);
    }

    // ── Compléments repliable
    const allComps = compEssentiels.concat(compRecommandes, compOptionnels);
    if (allComps.length) {
      // BUG 7 V3.1 — panel ouvert par défaut, toggle via classe is-collapsed
      const togglePanel = h('div', { class: 'pd-cart-comp-panel' });
      compEssentiels.forEach(c => togglePanel.appendChild(cartRow(c, 'comp_essentiel', { locked: true, defaultChecked: true, isComplement: true })));
      compRecommandes.forEach(c => togglePanel.appendChild(cartRow(c, 'comp_recommande', { defaultChecked: true, isComplement: true })));
      compOptionnels.forEach(c => togglePanel.appendChild(cartRow(c, 'comp_optionnel', { defaultChecked: false, isComplement: true })));

      const toggleBtn = h('button', { class: 'pd-cart-toggle is-open', type: 'button' }, [
        h('span', {}, 'Compléments inside-out (' + allComps.length + ')'),
        h('span', { class: 'pd-cart-toggle-chevron', html: SVG.chevron })
      ]);
      toggleBtn.addEventListener('click', () => {
        const collapsed = togglePanel.classList.toggle('is-collapsed');
        toggleBtn.classList.toggle('is-open', !collapsed);
      });
      wrap.appendChild(toggleBtn);
      wrap.appendChild(togglePanel);
    }

    // ── Bloc total + CTA
    const totalBlock = h('div', { class: 'pd-cart-total-block' });
    totalBlock.appendChild(h('div', { class: 'pd-gradient-line-top' }));

    const totalRow = h('div', { class: 'pd-cart-total-row' });
    const totalLeft = h('div', {}, [
      h('span', { class: 'pd-cart-total-label' }, 'Total protocole'),
      h('span', { class: 'pd-cart-total-count', dataset: { cartCount: '' } }, '0 produits')
    ]);
    const totalRight = h('div', { class: 'pd-cart-total-amount', dataset: { cartTotal: '' } }, [
      document.createTextNode('—'),
      h('sup', {}, 'TTC')
    ]);
    totalRow.appendChild(totalLeft);
    totalRow.appendChild(totalRight);
    totalBlock.appendChild(totalRow);

    const ctaStack = h('div', { class: 'pd-cart-cta-stack' });
    const haloWrap = h('div', { class: 'pd-halo-wrap', style: 'width:100%;' });
    const addAllBtn = h('button', { class: 'pd-btn pd-btn-primary pd-btn-block', type: 'button' },
      'Ajouter mon protocole ' + packName.replace('Routine ', '') + ' au panier');
    haloWrap.appendChild(addAllBtn);
    ctaStack.appendChild(haloWrap);

    const emailBtn = h('button', { class: 'pd-btn pd-btn-ghost-light pd-btn-block', type: 'button' },
      'Télécharger ma notice (PDF)');
    emailBtn.addEventListener('click', () => pdDownloadNoticePdf(o));
    ctaStack.appendChild(emailBtn);

    const restartLink = h('a', {
      class: 'pd-cart-restart-link',
      href: '/pages/quiz'
    }, '↺ Recommencer mon analyse de peau');
    ctaStack.appendChild(restartLink);

    totalBlock.appendChild(ctaStack);
    wrap.appendChild(totalBlock);

    // Bouton Add → collecte les checkboxes cochées
    addAllBtn.addEventListener('click', () => {
      const checked = wrap.querySelectorAll('.pd-cart-checkbox:checked');
      const items = Array.from(checked).map(cb => ({
        handle: cb.dataset.handle,
        label: cb.dataset.label,
        quantity: 1
      })).filter(i => i.handle);
      handleAddProtocol(items, packName);
    });

    // Logique de mise à jour du total — recalcul au chargement + à chaque change
    requestAnimationFrame(() => updateCartTotal(wrap));
    wrap.addEventListener('change', (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('pd-cart-checkbox')) {
        updateCartTotal(wrap);
      }
    });

    return wrap;
  }

  function cartRow(item, group, opts) {
    opts = opts || {};
    const row = h('div', { class: 'pd-cart-row' });
    const checkbox = h('input', {
      type: 'checkbox',
      class: 'pd-cart-checkbox',
      dataset: {
        handle: item.handle || '',
        label: item.name || '',
        group: group
      }
    });
    if (opts.defaultChecked) checkbox.checked = true;
    if (opts.locked) {
      checkbox.dataset.locked = 'true';
      checkbox.checked = true;
      checkbox.disabled = true;
    }
    row.appendChild(checkbox);

    const info = h('div', { class: 'pd-cart-product-info' }, [
      h('span', { class: 'pd-cart-product-brand' }, item.brand || ''),
      h('span', { class: 'pd-cart-product-name' }, item.name || '')
    ]);
    row.appendChild(info);

    // Badge rôle
    const badgeText = opts.locked ? 'Essentiel' :
                      group === 'recommande' || group === 'comp_recommande' ? 'Recommandé' :
                      group === 'optionnel' || group === 'comp_optionnel' ? 'Optionnel' :
                      group === 'comp_essentiel' ? 'Essentiel' : '';
    if (badgeText) {
      const badgeClass = badgeText === 'Essentiel' ? 'pd-badge-essentiel' :
                         badgeText === 'Recommandé' ? 'pd-badge-recommande' :
                         'pd-badge-optionnel';
      row.appendChild(h('span', { class: 'pd-product-badge ' + badgeClass }, badgeText));
    } else {
      row.appendChild(h('span', {}));
    }

    // Prix : placeholder "XX€" tant que le lookup live n'a pas résolu le prix
    const priceEl = h('span', {
      class: 'pd-cart-product-price',
      dataset: { handle: item.handle || '' }
    }, 'XX€');
    row.appendChild(priceEl);

    // Lookup async pour afficher le prix
    if (item.handle) {
      lookupVariantId(item.handle).then(info => {
        const price = parseFloat(info.price) || 0;
        priceEl.textContent = price ? formatPrice(price) : 'XX€';
        priceEl.dataset.price = String(price);
        // Si on est sur Shopify, info.price est déjà en cents
        const priceCents = price > 1000 ? price : price * 100;
        priceEl.dataset.priceCents = String(priceCents);
        // Recalcul total après que le prix soit chargé
        const wrap = priceEl.closest('.pd-block-cart');
        if (wrap) updateCartTotal(wrap);
      }).catch(() => { /* silent — prix indisponible */ });
    }

    return row;
  }

  function formatPrice(amount) {
    // amount peut être en cents (Shopify retourne souvent un float comme 18.50 mais selon API en cents)
    // Heuristique : si > 1000, on suppose cents → diviser par 100
    const eur = amount > 1000 ? amount / 100 : amount;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(eur);
  }

  function updateCartTotal(wrap) {
    const checked = wrap.querySelectorAll('.pd-cart-checkbox:checked');
    let total = 0;
    let count = 0;
    checked.forEach(cb => {
      const handle = cb.dataset.handle;
      if (!handle) return;
      const priceEl = wrap.querySelector('.pd-cart-product-price[data-handle="' + handle + '"]');
      if (priceEl && priceEl.dataset.price) {
        total += parseFloat(priceEl.dataset.price) || 0;
        count += 1;
      } else {
        count += 1;
      }
    });
    const countEl = wrap.querySelector('[data-cart-count]');
    if (countEl) countEl.textContent = count + ' produit' + (count > 1 ? 's' : '');
    const totalEl = wrap.querySelector('[data-cart-total]');
    if (totalEl) {
      totalEl.innerHTML = '';
      if (total > 0) {
        totalEl.appendChild(document.createTextNode(formatPrice(total)));
        totalEl.appendChild(h('sup', {}, 'TTC'));
      } else {
        totalEl.appendChild(document.createTextNode('—'));
        totalEl.appendChild(h('sup', {}, 'TTC'));
      }
    }
  }

  // ════════════════════════════════════════════════════════════════════════
  //  ITEM 12 — Bande contact pharmacienne + CTA final + mention légale
  // ════════════════════════════════════════════════════════════════════════

  function blockPharmContact() {
    const wrap = h('section', { class: 'pd-pharm-contact' });
    const text = h('div', { class: 'pd-pharm-contact-text' }, [
      h('p', { class: 'pd-pharm-contact-title' }, 'Une question sur votre protocole ?'),
      h('p', { class: 'pd-pharm-contact-subtitle' }, 'Notre pharmacienne est là pour vous répondre.')
    ]);
    wrap.appendChild(text);
    wrap.appendChild(h('a', { class: 'pd-pharm-contact-btn', href: '/pages/contact' }, 'Nous contacter →'));
    return wrap;
  }

  function blockCtaFinal(o) {
    const wrap = h('section', { class: 'pd-block-cta-final' });
    wrap.appendChild(h('div', { class: 'pd-gradient-line-top' }));

    const reassurance = h('div', { class: 'pd-cta-final-reassurance' }, [
      h('span', {}, 'Protocole sauvegardé'),
      h('span', {}, 'Accessible à tout moment'),
      h('span', {}, 'Livraison offerte dès 39 € en point relais')
    ]);
    wrap.appendChild(reassurance);

    wrap.appendChild(h('p', { class: 'pd-cta-final-savenote' },
      'Votre protocole est sauvegardé — vous pouvez y revenir quand vous voulez.'));

    wrap.appendChild(h('h2', {
      class: 'pd-cta-final-title',
      html: 'Prête à commencer votre <em>routine sur mesure</em> ?'
    }));
    wrap.appendChild(h('p', { class: 'pd-cta-final-subtitle' },
      'Chaque produit est disponible. Livraison rapide, retours gratuits.'));

    const stack = h('div', { class: 'pd-cta-final-stack' });
    const haloWrap = h('div', { class: 'pd-halo-wrap', style: 'width:100%;max-width:420px;' });
    const primary = h('a', {
      class: 'pd-btn pd-btn-primary pd-btn-large pd-btn-block',
      href: (o.block7_cta && o.block7_cta.signature_collection_handle)
        ? '/collections/' + o.block7_cta.signature_collection_handle
        : '/collections'
    }, 'Découvrir mon protocole complet →');
    haloWrap.appendChild(primary);
    stack.appendChild(haloWrap);

    const emailBtn = h('button', { class: 'pd-btn pd-btn-ghost-light pd-btn-block', type: 'button' },
      'Télécharger ma notice (PDF)');
    emailBtn.addEventListener('click', () => pdDownloadNoticePdf(o));
    stack.appendChild(emailBtn);

    const restart = h('a', {
      class: 'pd-cta-final-restart',
      href: '/pages/quiz'
    }, '↺ Recommencer mon analyse de peau');
    stack.appendChild(restart);

    wrap.appendChild(stack);
    return wrap;
  }

  function blockMentionLegale(o) {
    const wrap = h('div', { class: 'pd-mention-legale-final' });
    wrap.appendChild(h('p', {
      html: 'Ce bilan cosmétique est réalisé par une pharmacienne et ne constitue pas un diagnostic médical. En cas de pathologie cutanée, consultez un dermatologue. <a href="/policies/legal-notice">Mentions légales</a>'
    }));
    return wrap;
  }

  // ────────────────────────────────────────────────────────────────────────────
  //  APP BOOTSTRAP
  // ────────────────────────────────────────────────────────────────────────────

  function mountQuiz(root) {
    // V3.20 — Masque la nav Dawn dès le montage du quiz (one-time per
    // page load). Restituée via showNav() en sortie (renderResults +
    // beforeunload + restart bouton).
    hideNav();
    // V3.25 — Force fond #1e3d10 sur tout le body pendant le quiz via
    // classe pd-quiz-active (override Dawn .gradient). Retiré dans showNav().
    document.body.classList.add('pd-quiz-active');
    const app = {
      state: defaultState(),
      render() {
        root.innerHTML = '';
        // V3.16 — renderHero retiré du flow ; step0 est désormais la page
        // d'accueil unique. La fonction renderHero reste en dead code mais
        // n'est plus appelée (pour ne pas casser de référence externe).
        // Cleanup défensif : retire toute classe sas/hero résiduelle puis
        // applique la bonne selon l'étape.
        root.classList.remove('pd-quiz-wrapper--hero-active');
        if (!this.state.step0Seen) {
          root.classList.add('pd-step-sas');
          root.appendChild(renderStep0(this.state, this));
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        // Sortie du sas : retire la classe wrapper sas.
        root.classList.remove('pd-step-sas');
        const flow = buildFlow(this.state.answers, this.state.skipped7);
        const item = flow[this.state.cursor];
        if (!item) { finalize(this.state, this); return; }
        let el;
        if (item.type === '_email') el = renderEmailCapture(this.state, this);
        else if (item.type === '_transition1') el = renderTransition1(this.state, this);
        else if (item.type === '_packtier') el = renderPackAndTier(this.state, this);
        else if (item.type === '_mdvlight') el = renderMdvLight(this.state, this);
        // V3.34b-5 : _preview / _step5 retirés du flow (fusionnés en _packtier ci-dessus).
        // Dispatchers conservés pour rétro-compat au cas où un state localStorage
        // antérieur référencerait encore ces types — si la flag absente du flow,
        // le else final tombera sur renderQuestion qui throw proprement.
        else if (item.type === '_preview') el = renderStep4Preview(this.state, this);
        else if (item.type === '_step5') el = renderStep5Level(this.state, this);
        else if (item.type === '_gate') el = renderStep6Gate(this.state, this);
        else if (item.type === '_alert') el = renderAlertBanner(item, this.state, this);
        else el = renderQuestion(item, this.state, flow, this);
        root.appendChild(el);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    const existing = loadState();
    if (existing && Object.keys(existing.answers || {}).length > 0) {
      root.innerHTML = '';
      root.appendChild(renderResume(existing, app));
    } else {
      app.render();
    }
  }

  // 2026-10-06 — Téléchargement direct de la notice (décision fondatrice :
  // sans compte, plus simple). Le moteur quiz-notice.js est chargé par la
  // section quiz-results.liquid ; données = output + réponses du localStorage.
  function pdDownloadNoticePdf(o) {
    var out = o;
    if (!out) { try { out = JSON.parse(localStorage.getItem(OUTPUT_KEY) || 'null'); } catch (_) { out = null; } }
    if (!out) { if (typeof showToast === 'function') showToast('Aucun protocole à télécharger — refaites votre analyse.', { info: true }); return; }
    if (!window.ParaDermiaNotice || typeof window.ParaDermiaNotice.download !== 'function') {
      if (typeof showToast === 'function') showToast('Génération indisponible pour le moment. Rechargez la page et réessayez.', { info: true });
      return;
    }
    var answers = (out._inputs && out._inputs.answers) || {};
    var first = (out._meta && out._meta.firstName) || '';
    try { window.ParaDermiaNotice.download(out, answers, { firstName: first, purchased: false }); } catch (e) { console.error('[ParaDermia] notice download', e); }
    try { window._learnq = window._learnq || []; window._learnq.push(['track', 'Quiz Peau Notice Téléchargée', Object.assign({}, out.klaviyo_properties || {})]); } catch (_) {}
    if (typeof showToast === 'function') showToast('Votre notice PDF se prépare ✓');
  }

  function mountResults(root) {
    renderResults(root);
    // 2026-10-06 — Attache les réponses du quiz au panier DÈS l'affichage des
    // résultats (et plus seulement au clic « Ajouter au panier ») : toute
    // commande passée ensuite porte _pd_quiz_answers / from_quiz_peau →
    // notice régénérable, « Mes notices » dans le compte, attribution quiz.
    try { persistQuizToCart(); } catch (_) {}
    // V7.13 — Fetch Storefront prix en arrière-plan (non-bloquant) puis patch
    // les cards + total. Si pas de token configuré → no-op silencieux.
    try {
      const output = JSON.parse(localStorage.getItem(OUTPUT_KEY) || 'null');
      if (output) {
        fetchPricesForResults(output).then(prices => applyPricesPatch(prices));
      }
    } catch (_) { /* silently ignore */ }
  }

  window.ParaDermiaQuiz = { mountQuiz, mountResults, STORAGE_KEY, OUTPUT_KEY };

  document.addEventListener('DOMContentLoaded', () => {
    const q = document.querySelector('[data-quiz-root]');
    if (q) mountQuiz(q);
    const r = document.querySelector('[data-quiz-results-root]');
    if (r) mountResults(r);
    // V3.20 — Restaure la nav Dawn sur navigation hors page (defensive).
    // Si l'user reload la page ou navigue ailleurs, hideNav d'une session
    // antérieure ne doit pas rester collé.
    window.addEventListener('beforeunload', showNav);
  });
})();

